export function loadSprites() {

    // Get textures
    let textures = PIXI.loader.resources["static/www/static/images/sprites/sprites.json"].textures;

    // Load sprites from textures
    let bodyHe = new PIXI.Sprite(textures["body_he.png"]);
    let bodyShe = new PIXI.Sprite(textures["body_she.png"]);
    let bodyHeAbs = new PIXI.Sprite(textures["body_he_abs.png"]);
    let bodySheAbs = new PIXI.Sprite(textures["body_she_abs.png"]);

    let eyesDesign = new PIXI.Sprite(textures["eyes.png"]);

    let trunksBase = new PIXI.Sprite(textures["trunks_base.png"]);
    let trunksDesign1 = new PIXI.Sprite(textures["trunks_1.png"]);
    let trunksDesign2 = new PIXI.Sprite(textures["trunks_2.png"]);
    let trunksDesign3 = new PIXI.Sprite(textures["trunks_3.png"]);
    let trunksDesign4 = new PIXI.Sprite(textures["trunks_4.png"]);
    let trunksDesign5 = new PIXI.Sprite(textures["trunks_5.png"]);
    let trunksDesign6A = new PIXI.Sprite(textures["trunks_6_a.png"]);
    let trunksDesign6B = new PIXI.Sprite(textures["trunks_6_b.png"]);
    let trunksDesign7 = new PIXI.Sprite(textures["trunks_7.png"]);
    let trunksDesign8A = new PIXI.Sprite(textures["trunks_8_a.png"]);
    let trunksDesign8B = new PIXI.Sprite(textures["trunks_8_b.png"]);
    let trunksDesign9 = new PIXI.Sprite(textures["trunks_9.png"]);
    let trunksDesign10A = new PIXI.Sprite(textures["trunks_10_a.png"]);
    let trunksDesign10B = new PIXI.Sprite(textures["trunks_10_b.png"]);
    let trunksDesign11 = new PIXI.Sprite(textures["trunks_11.png"]);
    let trunksDesign12 = new PIXI.Sprite(textures["trunks_12.png"]);
    let trunksDesign13 = new PIXI.Sprite(textures["trunks_13.png"]);
    let trunksDesign14A = new PIXI.Sprite(textures["trunks_14_a.png"]);
    let trunksDesign14B = new PIXI.Sprite(textures["trunks_14_b.png"]);
    let trunksDesign15A = new PIXI.Sprite(textures["trunks_15_a.png"]);
    let trunksDesign15B = new PIXI.Sprite(textures["trunks_15_b.png"]);

    let shortsBase = new PIXI.Sprite(textures["shorts_base.png"]);
    let shortsDesign1A = new PIXI.Sprite(textures["shorts_1_a.png"]);
    let shortsDesign1B = new PIXI.Sprite(textures["shorts_1_b.png"]);
    let shortsDesign1C = new PIXI.Sprite(textures["shorts_1_c.png"]);
    let shortsDesign2A = new PIXI.Sprite(textures["shorts_2_a.png"]);
    let shortsDesign2B = new PIXI.Sprite(textures["shorts_2_b.png"]);
    let shortsDesign3 = new PIXI.Sprite(textures["shorts_3.png"]);
    let shortsDesign4A = new PIXI.Sprite(textures["shorts_4_a.png"]);
    let shortsDesign4B = new PIXI.Sprite(textures["shorts_4_b.png"]);
    let shortsDesign5 = new PIXI.Sprite(textures["shorts_5.png"]);
    let shortsDesign6A = new PIXI.Sprite(textures["shorts_6_a.png"]);
    let shortsDesign6B = new PIXI.Sprite(textures["shorts_6_b.png"]);
    let shortsDesign7A = new PIXI.Sprite(textures["shorts_7_a.png"]);
    let shortsDesign7B = new PIXI.Sprite(textures["shorts_7_b.png"]);
    let shortsDesign8A = new PIXI.Sprite(textures["shorts_8_a.png"]);
    let shortsDesign8B = new PIXI.Sprite(textures["shorts_8_b.png"]);
    let shortsDesign9A = new PIXI.Sprite(textures["shorts_9_a.png"]);
    let shortsDesign9B = new PIXI.Sprite(textures["shorts_9_b.png"]);
    let shortsDesign9C = new PIXI.Sprite(textures["shorts_9_c.png"]);

    let tightsBase = new PIXI.Sprite(textures["tights_base.png"]);
    let tightsDesign1A = new PIXI.Sprite(textures["tights_1_a.png"]);
    let tightsDesign1B = new PIXI.Sprite(textures["tights_1_b.png"]);
    let tightsDesign2 = new PIXI.Sprite(textures["tights_2.png"]);
    let tightsDesign3 = new PIXI.Sprite(textures["tights_3.png"]);
    let tightsDesign4A = new PIXI.Sprite(textures["tights_4_a.png"]);
    let tightsDesign4B = new PIXI.Sprite(textures["tights_4_b.png"]);
    let tightsDesign5A = new PIXI.Sprite(textures["tights_5_a.png"]);
    let tightsDesign5B = new PIXI.Sprite(textures["tights_5_b.png"]);
    let tightsDesign6 = new PIXI.Sprite(textures["tights_6.png"]);
    let tightsDesign7A = new PIXI.Sprite(textures["tights_7_a.png"]);
    let tightsDesign7B = new PIXI.Sprite(textures["tights_7_b.png"]);
    let tightsDesign8 = new PIXI.Sprite(textures["tights_8.png"]);
    let tightsDesign9A = new PIXI.Sprite(textures["tights_9_a.png"]);
    let tightsDesign9B = new PIXI.Sprite(textures["tights_9_b.png"]);
    let tightsDesign10 = new PIXI.Sprite(textures["tights_10.png"]);
    let tightsDesign11A = new PIXI.Sprite(textures["tights_11_a.png"]);
    let tightsDesign11B = new PIXI.Sprite(textures["tights_11_b.png"]);
    let tightsDesign12 = new PIXI.Sprite(textures["tights_12.png"]);
    let tightsDesign13 = new PIXI.Sprite(textures["tights_13.png"]);
    let tightsDesign14 = new PIXI.Sprite(textures["tights_14.png"]);
    let tightsDesign15 = new PIXI.Sprite(textures["tights_15.png"]);
    let tightsDesign16 = new PIXI.Sprite(textures["tights_16.png"]);
    let tightsDesign17A = new PIXI.Sprite(textures["tights_17_a.png"]);
    let tightsDesign17B = new PIXI.Sprite(textures["tights_17_b.png"]);
    let tightsDesign18 = new PIXI.Sprite(textures["tights_18.png"]);
    let tightsDesign19A = new PIXI.Sprite(textures["tights_19_a.png"]);
    let tightsDesign19B = new PIXI.Sprite(textures["tights_19_b.png"]);
    let tightsDesign20A = new PIXI.Sprite(textures["tights_20_a.png"]);
    let tightsDesign20B = new PIXI.Sprite(textures["tights_20_b.png"]);
    let tightsDesign20C = new PIXI.Sprite(textures["tights_20_c.png"]);
    let tightsDesign21A = new PIXI.Sprite(textures["tights_21_a.png"]);
    let tightsDesign21B = new PIXI.Sprite(textures["tights_21_b.png"]);
    let tightsDesign21C = new PIXI.Sprite(textures["tights_21_c.png"]);
    let tightsDesign22 = new PIXI.Sprite(textures["tights_22.png"]);
    let tightsDesign23A = new PIXI.Sprite(textures["tights_23_a.png"]);
    let tightsDesign23B = new PIXI.Sprite(textures["tights_23_b.png"]);
    let tightsDesign24A = new PIXI.Sprite(textures["tights_24_a.png"]);
    let tightsDesign24B = new PIXI.Sprite(textures["tights_24_b.png"]);
    let tightsDesign24C = new PIXI.Sprite(textures["tights_24_c.png"]);
    let tightsDesign25A = new PIXI.Sprite(textures["tights_25_a.png"]);
    let tightsDesign25B = new PIXI.Sprite(textures["tights_25_b.png"]);
    let tightsDesign25C = new PIXI.Sprite(textures["tights_25_c.png"]);

    let hairDesign0 = new PIXI.Sprite(textures["hair_0.png"]);
    let hairDesign1 = new PIXI.Sprite(textures["hair_1.png"]);
    let hairDesign2 = new PIXI.Sprite(textures["hair_2.png"]);
    let hairDesign3 = new PIXI.Sprite(textures["hair_3.png"]);
    let hairDesign4 = new PIXI.Sprite(textures["hair_4.png"]);
    let hairDesign5A = new PIXI.Sprite(textures["hair_5_a.png"]);
    let hairDesign5B = new PIXI.Sprite(textures["hair_5_b.png"]);
    let hairDesign6A = new PIXI.Sprite(textures["hair_6_a.png"]);
    let hairDesign6B = new PIXI.Sprite(textures["hair_6_b.png"]);
    let hairDesign7A = new PIXI.Sprite(textures["hair_7_a.png"]);
    let hairDesign7B = new PIXI.Sprite(textures["hair_7_b.png"]);
    let hairDesign8 = new PIXI.Sprite(textures["hair_8.png"]);
    let hairDesign9 = new PIXI.Sprite(textures["hair_9.png"]);
    let hairDesign10 = new PIXI.Sprite(textures["hair_10.png"]);
    let hairDesign11 = new PIXI.Sprite(textures["hair_11.png"]);
    let hairDesign12 = new PIXI.Sprite(textures["hair_12.png"]);
    let hairDesign13 = new PIXI.Sprite(textures["hair_13.png"]);
    let hairDesign14 = new PIXI.Sprite(textures["hair_14.png"]);
    let hairDesign15 = new PIXI.Sprite(textures["hair_15.png"]);
    let hairDesign16 = new PIXI.Sprite(textures["hair_16.png"]);
    let hairDesign17 = new PIXI.Sprite(textures["hair_17.png"]);
    let hairDesign18 = new PIXI.Sprite(textures["hair_18.png"]);
    let hairDesign19 = new PIXI.Sprite(textures["hair_19.png"]);
    let hairDesign20A = new PIXI.Sprite(textures["hair_20_a.png"]);
    let hairDesign20B = new PIXI.Sprite(textures["hair_20_b.png"]);
    let hairDesign21 = new PIXI.Sprite(textures["hair_21.png"]);
    let hairDesign22 = new PIXI.Sprite(textures["hair_22.png"]);
    let hairDesign23 = new PIXI.Sprite(textures["hair_23.png"]);
    let hairDesign24A = new PIXI.Sprite(textures["hair_24_a.png"]);
    let hairDesign24B = new PIXI.Sprite(textures["hair_24_b.png"]);
    let hairDesign25 = new PIXI.Sprite(textures["hair_25.png"]);
    let hairDesign26 = new PIXI.Sprite(textures["hair_26.png"]);
    let hairDesign27 = new PIXI.Sprite(textures["hair_27.png"]);
    let hairDesign28 = new PIXI.Sprite(textures["hair_28.png"]);
    let hairDesign29 = new PIXI.Sprite(textures["hair_29.png"]);
    let hairDesign30 = new PIXI.Sprite(textures["hair_30.png"]);
    let hairDesign31 = new PIXI.Sprite(textures["hair_31.png"]);
    let hairDesign32 = new PIXI.Sprite(textures["hair_32.png"]);
    let hairDesign33 = new PIXI.Sprite(textures["hair_33.png"]);
    let hairDesign34 = new PIXI.Sprite(textures["hair_34.png"]);
    let hairDesign35 = new PIXI.Sprite(textures["hair_35.png"]);
    let hairDesign36A = new PIXI.Sprite(textures["hair_36_a.png"]);
    let hairDesign36B = new PIXI.Sprite(textures["hair_36_b.png"]);

    // Streaks
    let hairDesign4Streak = new PIXI.Sprite(textures["hair_4_streak.png"]);
    let hairDesign10Streak = new PIXI.Sprite(textures["hair_10_streak.png"]);
    let hairDesign12Streak = new PIXI.Sprite(textures["hair_12_streak.png"]);
    let hairDesign18Streak = new PIXI.Sprite(textures["hair_18_streak.png"]);
    let hairDesign23Streak = new PIXI.Sprite(textures["hair_23_streak.png"]);
    let hairDesign27Streak = new PIXI.Sprite(textures["hair_27_streak.png"]);
    let hairDesign29Streak = new PIXI.Sprite(textures["hair_29_streak.png"]);
    let hairDesign31Streak = new PIXI.Sprite(textures["hair_31_streak.png"]);
    let hairDesign34Streak = new PIXI.Sprite(textures["hair_34_streak.png"]);

    let shoesDesign1 = new PIXI.Sprite(textures["shoes_1.png"]);
    let shoesDesign1A = new PIXI.Sprite(textures["shoes_1_a.png"]);
    let shoesDesign2 = new PIXI.Sprite(textures["shoes_2.png"]);
    let shoesDesign2A = new PIXI.Sprite(textures["shoes_2_a.png"]);
    let shoesDesign2B = new PIXI.Sprite(textures["shoes_2_b.png"]);
    let shoesDesign3 = new PIXI.Sprite(textures["shoes_3.png"]);
    let shoesDesign3A = new PIXI.Sprite(textures["shoes_3_a.png"]);
    let shoesDesign4 = new PIXI.Sprite(textures["shoes_4.png"]);
    let shoesDesign4A = new PIXI.Sprite(textures["shoes_4_a.png"]);
    let shoesDesign5 = new PIXI.Sprite(textures["shoes_5.png"]);
    let shoesDesign5A = new PIXI.Sprite(textures["shoes_5_a.png"]);
    let shoesDesign6 = new PIXI.Sprite(textures["shoes_6.png"]);
    let shoesDesign6A = new PIXI.Sprite(textures["shoes_6_a.png"]);
    let shoesDesign7 = new PIXI.Sprite(textures["shoes_7.png"]);
    let shoesDesign7A = new PIXI.Sprite(textures["shoes_7_a.png"]);
    let shoesDesign8 = new PIXI.Sprite(textures["shoes_8.png"]);
    let shoesDesign8A = new PIXI.Sprite(textures["shoes_8_a.png"]);
    let shoesDesign9 = new PIXI.Sprite(textures["shoes_9.png"]);
    let shoesDesign9A = new PIXI.Sprite(textures["shoes_9_a.png"]);
    let shoesDesign10 = new PIXI.Sprite(textures["shoes_10.png"]);
    let shoesDesign10A = new PIXI.Sprite(textures["shoes_10_a.png"]);
    let shoesDesign11 = new PIXI.Sprite(textures["shoes_11.png"]);
    let shoesDesign11A = new PIXI.Sprite(textures["shoes_11_a.png"]);
    let shoesDesign12 = new PIXI.Sprite(textures["shoes_12.png"]);
    let shoesDesign12A = new PIXI.Sprite(textures["shoes_12_a.png"]);
    let shoesDesign12B = new PIXI.Sprite(textures["shoes_12_b.png"]);
    let shoesDesign13 = new PIXI.Sprite(textures["shoes_13.png"]);
    let shoesDesign13A = new PIXI.Sprite(textures["shoes_13_a.png"]);
    let shoesDesign14A = new PIXI.Sprite(textures["shoes_14_a.png"]);
    let shoesDesign15A = new PIXI.Sprite(textures["shoes_15_a.png"]);
    let shoesDesign16 = new PIXI.Sprite(textures["shoes_16.png"]);
    let shoesDesign16A = new PIXI.Sprite(textures["shoes_16_a.png"]);
    let shoesDesign17 = new PIXI.Sprite(textures["shoes_17.png"]);
    let shoesDesign17A = new PIXI.Sprite(textures["shoes_17_a.png"]);
    let shoesDesign18 = new PIXI.Sprite(textures["shoes_18.png"]);
    let shoesDesign18A = new PIXI.Sprite(textures["shoes_18_a.png"]);
    let shoesDesign19A = new PIXI.Sprite(textures["shoes_19_a.png"]);
    let shoesDesign20A = new PIXI.Sprite(textures["shoes_20_a.png"]);

    let topDesign1 = new PIXI.Sprite(textures["top_1.png"]);
    let topDesign1A = new PIXI.Sprite(textures["top_1_a.png"]);
    let topDesign2 = new PIXI.Sprite(textures["top_2.png"]);
    let topDesign2A = new PIXI.Sprite(textures["top_2_a.png"]);
    let topDesign3 = new PIXI.Sprite(textures["top_3.png"]);
    let topDesign4 = new PIXI.Sprite(textures["top_4.png"]);
    let topDesign4A = new PIXI.Sprite(textures["top_4_a.png"]);
    let topDesign5 = new PIXI.Sprite(textures["top_5.png"]);
    let topDesign5A = new PIXI.Sprite(textures["top_5_a.png"]);
    let topDesign6 = new PIXI.Sprite(textures["top_6.png"]);
    let topDesign6A = new PIXI.Sprite(textures["top_6_a.png"]);
    let topDesign6B = new PIXI.Sprite(textures["top_6_b.png"]);
    let topDesign7 = new PIXI.Sprite(textures["top_7.png"]);
    let topDesign8 = new PIXI.Sprite(textures["top_8.png"]);
    let topDesign9 = new PIXI.Sprite(textures["top_9.png"]);
    let topDesign10 = new PIXI.Sprite(textures["top_10.png"]);
    let topDesign11 = new PIXI.Sprite(textures["top_11.png"]);
    let topDesign12 = new PIXI.Sprite(textures["top_12.png"]);
    let topDesign12A = new PIXI.Sprite(textures["top_12_a.png"]);
    let topDesign13A = new PIXI.Sprite(textures["top_13_a.png"]);
    let topDesign14 = new PIXI.Sprite(textures["top_14.png"]);
    let topDesign15 = new PIXI.Sprite(textures["top_15.png"]);
    let topDesign15A = new PIXI.Sprite(textures["top_15_a.png"]);
    let topDesign16 = new PIXI.Sprite(textures["top_16.png"]);
    let topDesign16A = new PIXI.Sprite(textures["top_16_a.png"]);
    let topDesign16B = new PIXI.Sprite(textures["top_16_b.png"]);
    let topDesign17 = new PIXI.Sprite(textures["top_17.png"]);
    let topDesign18 = new PIXI.Sprite(textures["top_18.png"]);
    let topDesign18A = new PIXI.Sprite(textures["top_18_a.png"]);
    let topDesign19A = new PIXI.Sprite(textures["top_19_a.png"]);
    let topDesign20A = new PIXI.Sprite(textures["top_20_a.png"]);
    let topDesign21 = new PIXI.Sprite(textures["top_21.png"]);
    let topDesign21A = new PIXI.Sprite(textures["top_21_a.png"]);
    let topDesign22A = new PIXI.Sprite(textures["top_22_a.png"]);
    let topDesign23A = new PIXI.Sprite(textures["top_23_a.png"]);
    let topDesign24A = new PIXI.Sprite(textures["top_24_a.png"]);
    let topDesign25A = new PIXI.Sprite(textures["top_25_a.png"]);
    let topDesign26A = new PIXI.Sprite(textures["top_26_a.png"]);
    let topDesign27A = new PIXI.Sprite(textures["top_27_a.png"]);
    let topDesign28A = new PIXI.Sprite(textures["top_28_a.png"]);
    let topDesign29 = new PIXI.Sprite(textures["top_29.png"]);
    let topDesign29A = new PIXI.Sprite(textures["top_29_a.png"]);
    let topDesign30A = new PIXI.Sprite(textures["top_30_a.png"]);
    let topDesign31 = new PIXI.Sprite(textures["top_31.png"]);
    let topDesign31A = new PIXI.Sprite(textures["top_31_a.png"]);
    let topDesign31B = new PIXI.Sprite(textures["top_31_b.png"]);
    let topDesign32A = new PIXI.Sprite(textures["top_32_a.png"]);
    let topDesign33 = new PIXI.Sprite(textures["top_33.png"]);
    let topDesign33A = new PIXI.Sprite(textures["top_33_a.png"]);
    let topDesign34A = new PIXI.Sprite(textures["top_34_a.png"]);
    let topDesign35A = new PIXI.Sprite(textures["top_35_a.png"]);
    let topDesign36 = new PIXI.Sprite(textures["top_36.png"]);
    let topDesign37A = new PIXI.Sprite(textures["top_37_a.png"]);
    let topDesign37B = new PIXI.Sprite(textures["top_37_b.png"]);
    let topDesign37C = new PIXI.Sprite(textures["top_37_c.png"]);
    let topDesign38 = new PIXI.Sprite(textures["top_38.png"]);
    let topDesign39 = new PIXI.Sprite(textures["top_39.png"]);
    let topDesign40A = new PIXI.Sprite(textures["top_40_a.png"]);
    let topDesign40B = new PIXI.Sprite(textures["top_40_b.png"]);
    let topDesign41A = new PIXI.Sprite(textures["top_41_a.png"]);
    let topDesign41B = new PIXI.Sprite(textures["top_41_b.png"]);
    let topDesign42 = new PIXI.Sprite(textures["top_42.png"]);
    let topDesign43 = new PIXI.Sprite(textures["top_43.png"]);
    let topDesign44 = new PIXI.Sprite(textures["top_44.png"]);
    let topDesign45A = new PIXI.Sprite(textures["top_45_a.png"]);
    let topDesign45B = new PIXI.Sprite(textures["top_45_b.png"]);
    let topDesign46 = new PIXI.Sprite(textures["top_46.png"]);
    let topDesign47A = new PIXI.Sprite(textures["top_47_a.png"]);
    let topDesign47B = new PIXI.Sprite(textures["top_47_b.png"]);
    let topDesign48A = new PIXI.Sprite(textures["top_48_a.png"]);
    let topDesign48B = new PIXI.Sprite(textures["top_48_b.png"]);
    let topDesign49A = new PIXI.Sprite(textures["top_49_a.png"]);
    let topDesign49B = new PIXI.Sprite(textures["top_49_b.png"]);
    let topDesign50A = new PIXI.Sprite(textures["top_50_a.png"]);
    let topDesign50B = new PIXI.Sprite(textures["top_50_b.png"]);
    let topDesign50C = new PIXI.Sprite(textures["top_50_c.png"]);
    let topDesign50D = new PIXI.Sprite(textures["top_50_d.png"]);
    let topDesign51 = new PIXI.Sprite(textures["top_51.png"]);
    let topDesign52 = new PIXI.Sprite(textures["top_52.png"]);

    let elbowDesign1 = new PIXI.Sprite(textures["elbow_1.png"]);
    let elbowDesign2 = new PIXI.Sprite(textures["elbow_2.png"]);
    let elbowDesign3 = new PIXI.Sprite(textures["elbow_3.png"]);
    let elbowDesign4 = new PIXI.Sprite(textures["elbow_4.png"]);
    let elbowDesign5 = new PIXI.Sprite(textures["elbow_5.png"]);
    let elbowDesign6 = new PIXI.Sprite(textures["elbow_6.png"]);
    let elbowDesign7 = new PIXI.Sprite(textures["elbow_7.png"]);
    let elbowDesign7A = new PIXI.Sprite(textures["elbow_7_a.png"]);
    let elbowDesign8 = new PIXI.Sprite(textures["elbow_8.png"]);
    let elbowDesign9 = new PIXI.Sprite(textures["elbow_9.png"]);
    let elbowDesign10 = new PIXI.Sprite(textures["elbow_10.png"]);

    let facialHairDesign1 = new PIXI.Sprite(textures["facial_hair_1.png"]);
    let facialHairDesign2 = new PIXI.Sprite(textures["facial_hair_2.png"]);
    let facialHairDesign3 = new PIXI.Sprite(textures["facial_hair_3.png"]);
    let facialHairDesign4 = new PIXI.Sprite(textures["facial_hair_4.png"]);
    let facialHairDesign5 = new PIXI.Sprite(textures["facial_hair_5.png"]);
    let facialHairDesign6 = new PIXI.Sprite(textures["facial_hair_6.png"]);
    let facialHairDesign7 = new PIXI.Sprite(textures["facial_hair_7.png"]);
    let facialHairDesign8 = new PIXI.Sprite(textures["facial_hair_8.png"]);
    let facialHairDesign9 = new PIXI.Sprite(textures["facial_hair_9.png"]);
    let facialHairDesign10 = new PIXI.Sprite(textures["facial_hair_10.png"]);
    let facialHairDesign11 = new PIXI.Sprite(textures["facial_hair_11.png"]);
    let facialHairDesign12 = new PIXI.Sprite(textures["facial_hair_12.png"]);
    let facialHairDesign13 = new PIXI.Sprite(textures["facial_hair_13.png"]);
    let facialHairDesign14 = new PIXI.Sprite(textures["facial_hair_14.png"]);
    let facialHairDesign15 = new PIXI.Sprite(textures["facial_hair_15.png"]);
    let facialHairDesign16 = new PIXI.Sprite(textures["facial_hair_16.png"]);
    let facialHairDesign17 = new PIXI.Sprite(textures["facial_hair_17.png"]);
    let facialHairDesign18 = new PIXI.Sprite(textures["facial_hair_18.png"]);
    let facialHairDesign19 = new PIXI.Sprite(textures["facial_hair_19.png"]);
    let facialHairDesign20 = new PIXI.Sprite(textures["facial_hair_20.png"]);

    let emptySprite = new PIXI.Sprite(textures["empty_sprite.png"]);
    let accessoryDesign1A = new PIXI.Sprite(textures["accessory_1_a.png"]);
    let accessoryDesign1B = new PIXI.Sprite(textures["accessory_1_b.png"]);
    let accessoryDesign1C = new PIXI.Sprite(textures["accessory_1_c.png"]);
    let accessoryDesign2A = new PIXI.Sprite(textures["accessory_2_a.png"]);
    let accessoryDesign2B = new PIXI.Sprite(textures["accessory_2_b.png"]);
    let accessoryDesign3A = new PIXI.Sprite(textures["accessory_3_a.png"]);
    let accessoryDesign3B = new PIXI.Sprite(textures["accessory_3_b.png"]);
    let accessoryDesign3C = new PIXI.Sprite(textures["accessory_3_c.png"]);
    let accessoryDesign3D = new PIXI.Sprite(textures["accessory_3_d.png"]);
    let accessoryDesign4 = new PIXI.Sprite(textures["accessory_4.png"]);
    let accessoryDesign5 = new PIXI.Sprite(textures["accessory_5.png"]);
    let accessoryDesign5A = new PIXI.Sprite(textures["accessory_5_a.png"]);
    let accessoryDesign6 = new PIXI.Sprite(textures["accessory_6.png"]);
    let accessoryDesign7 = new PIXI.Sprite(textures["accessory_7.png"]);
    let accessoryDesign7A = new PIXI.Sprite(textures["accessory_7_a.png"]);
    let accessoryDesign8 = new PIXI.Sprite(textures["accessory_8.png"]);
    let accessoryDesign8A = new PIXI.Sprite(textures["accessory_8_a.png"]);
    let accessoryDesign8B = new PIXI.Sprite(textures["accessory_8_b.png"]);
    let accessoryDesign9 = new PIXI.Sprite(textures["accessory_9.png"]);
    let accessoryDesign10 = new PIXI.Sprite(textures["accessory_10.png"]);
    let accessoryDesign11 = new PIXI.Sprite(textures["accessory_11.png"]);
    let accessoryDesign11A = new PIXI.Sprite(textures["accessory_11_a.png"]);
    let accessoryDesign12A = new PIXI.Sprite(textures["accessory_12_a.png"]);
    let accessoryDesign13 = new PIXI.Sprite(textures["accessory_13.png"]);
    let accessoryDesign14A = new PIXI.Sprite(textures["accessory_14_a.png"]);
    let accessoryDesign14B = new PIXI.Sprite(textures["accessory_14_b.png"]);
    let accessoryDesign15 = new PIXI.Sprite(textures["accessory_15.png"]);
    let accessoryDesign16A = new PIXI.Sprite(textures["accessory_16_a.png"]);
    let accessoryDesign16B = new PIXI.Sprite(textures["accessory_16_b.png"]);
    let accessoryDesign17 = new PIXI.Sprite(textures["accessory_17.png"]);
    let accessoryDesign18 = new PIXI.Sprite(textures["accessory_18.png"]);
    let accessoryDesign19 = new PIXI.Sprite(textures["accessory_19.png"]);
    let accessoryDesign20 = new PIXI.Sprite(textures["accessory_20.png"]);
    let accessoryDesign21A = new PIXI.Sprite(textures["accessory_21_a.png"]);
    let accessoryDesign21B = new PIXI.Sprite(textures["accessory_21_b.png"]);
    let accessoryDesign22A = new PIXI.Sprite(textures["accessory_22_a.png"]);
    let accessoryDesign22B = new PIXI.Sprite(textures["accessory_22_b.png"]);
    let accessoryDesign22C = new PIXI.Sprite(textures["accessory_22_c.png"]);
    let accessoryDesign23A = new PIXI.Sprite(textures["accessory_23_a.png"]);
    let accessoryDesign23B = new PIXI.Sprite(textures["accessory_23_b.png"]);
    let accessoryDesign24A = new PIXI.Sprite(textures["accessory_24_a.png"]);
    let accessoryDesign24B = new PIXI.Sprite(textures["accessory_24_b.png"]);
    let accessoryDesign25A = new PIXI.Sprite(textures["accessory_25_a.png"]);
    let accessoryDesign25B = new PIXI.Sprite(textures["accessory_25_b.png"]);
    let accessoryDesign26A = new PIXI.Sprite(textures["accessory_26_a.png"]);
    let accessoryDesign26B = new PIXI.Sprite(textures["accessory_26_b.png"]);
    let accessoryDesign27A = new PIXI.Sprite(textures["accessory_27_a.png"]);
    let accessoryDesign27B = new PIXI.Sprite(textures["accessory_27_b.png"]);
    let accessoryDesign28A = new PIXI.Sprite(textures["accessory_28_a.png"]);
    let accessoryDesign29A = new PIXI.Sprite(textures["accessory_29_a.png"]);
    let accessoryDesign29B = new PIXI.Sprite(textures["accessory_29_b.png"]);
    let accessoryDesign30A = new PIXI.Sprite(textures["accessory_30_a.png"]);
    let accessoryDesign30B = new PIXI.Sprite(textures["accessory_30_b.png"]);
    let accessoryDesign31A = new PIXI.Sprite(textures["accessory_31_a.png"]);
    let accessoryDesign31B = new PIXI.Sprite(textures["accessory_31_b.png"]);
    let accessoryDesign32Base = new PIXI.Sprite(textures["accessory_32.png"]);
    let accessoryDesign32A = new PIXI.Sprite(textures["accessory_32_a.png"]);
    let accessoryDesign32B = new PIXI.Sprite(textures["accessory_32_b.png"]);
    let accessoryDesign32C = new PIXI.Sprite(textures["accessory_32_c.png"]);
    let accessoryDesign33A = new PIXI.Sprite(textures["accessory_33_a.png"]);
    let accessoryDesign33B = new PIXI.Sprite(textures["accessory_33_b.png"]);
    let accessoryDesign34A = new PIXI.Sprite(textures["accessory_34_a.png"]);
    let accessoryDesign34B = new PIXI.Sprite(textures["accessory_34_b.png"]);
    let accessoryDesign34C = new PIXI.Sprite(textures["accessory_34_c.png"]);
    let accessoryDesign35A = new PIXI.Sprite(textures["accessory_35_a.png"]);
    let accessoryDesign35B = new PIXI.Sprite(textures["accessory_35_b.png"]);
    let accessoryDesign35C = new PIXI.Sprite(textures["accessory_35_c.png"]);
    let accessoryDesign36A = new PIXI.Sprite(textures["accessory_36_a.png"]);
    let accessoryDesign36B = new PIXI.Sprite(textures["accessory_36_b.png"]);
    let accessoryDesign36C = new PIXI.Sprite(textures["accessory_36_c.png"]);
    let accessoryDesign37A = new PIXI.Sprite(textures["accessory_37_a.png"]);
    let accessoryDesign37B = new PIXI.Sprite(textures["accessory_37_b.png"]);
    let accessoryDesign37C = new PIXI.Sprite(textures["accessory_37_c.png"]);
    let accessoryDesign38A = new PIXI.Sprite(textures["accessory_38_a.png"]);
    let accessoryDesign38B = new PIXI.Sprite(textures["accessory_38_b.png"]);
    let accessoryDesign38C = new PIXI.Sprite(textures["accessory_38_c.png"]);
    let accessoryDesign39A = new PIXI.Sprite(textures["accessory_39_a.png"]);
    let accessoryDesign39B = new PIXI.Sprite(textures["accessory_39_b.png"]);
    let accessoryDesign39C = new PIXI.Sprite(textures["accessory_39_c.png"]);
    let accessoryDesign39D = new PIXI.Sprite(textures["accessory_39_d.png"]);
    let accessoryDesign40A = new PIXI.Sprite(textures["accessory_40_a.png"]);
    let accessoryDesign40B = new PIXI.Sprite(textures["accessory_40_b.png"]);
    let accessoryDesign40C = new PIXI.Sprite(textures["accessory_40_c.png"]);
    let accessoryDesign41A = new PIXI.Sprite(textures["accessory_41_a.png"]);
    let accessoryDesign41B = new PIXI.Sprite(textures["accessory_41_b.png"]);
    let accessoryDesign42A = new PIXI.Sprite(textures["accessory_42_a.png"]);
    let accessoryDesign42B = new PIXI.Sprite(textures["accessory_42_b.png"]);
    let accessoryDesign42C = new PIXI.Sprite(textures["accessory_42_c.png"]);
    let accessoryDesign43A = new PIXI.Sprite(textures["accessory_43_a.png"]);
    let accessoryDesign43B = new PIXI.Sprite(textures["accessory_43_b.png"]);
    let accessoryDesign44A = new PIXI.Sprite(textures["accessory_44_a.png"]);
    let accessoryDesign44B = new PIXI.Sprite(textures["accessory_44_b.png"]);
    let accessoryDesign45A = new PIXI.Sprite(textures["accessory_45_a.png"]);
    let accessoryDesign46A = new PIXI.Sprite(textures["accessory_46_a.png"]);
    let accessoryDesign46B = new PIXI.Sprite(textures["accessory_46_b.png"]);
    let accessoryDesign47A = new PIXI.Sprite(textures["accessory_47_a.png"]);
    let accessoryDesign48A = new PIXI.Sprite(textures["accessory_48_a.png"]);
    let accessoryDesign48B = new PIXI.Sprite(textures["accessory_48_b.png"]);
    let accessoryDesign48C = new PIXI.Sprite(textures["accessory_48_c.png"]);
    let accessoryDesign49A = new PIXI.Sprite(textures["accessory_49_a.png"]);
    let accessoryDesign49B = new PIXI.Sprite(textures["accessory_49_b.png"]);
    let accessoryDesign49C = new PIXI.Sprite(textures["accessory_49_c.png"]);
    let accessoryDesign49D = new PIXI.Sprite(textures["accessory_49_d.png"]);
    let accessoryDesign50A = new PIXI.Sprite(textures["accessory_50_a.png"]);
    let accessoryDesign50B = new PIXI.Sprite(textures["accessory_50_b.png"]);
    let accessoryDesign50C = new PIXI.Sprite(textures["accessory_50_c.png"]);
    let accessoryDesign50D = new PIXI.Sprite(textures["accessory_50_d.png"]);
    let accessoryDesign51A = new PIXI.Sprite(textures["accessory_51_a.png"]);
    let accessoryDesign52A = new PIXI.Sprite(textures["accessory_52_a.png"]);
    let accessoryDesign53A = new PIXI.Sprite(textures["accessory_53_a.png"]);
    let accessoryDesign53B = new PIXI.Sprite(textures["accessory_53_b.png"]);
    let accessoryDesign53C = new PIXI.Sprite(textures["accessory_53_c.png"]);
    let accessoryDesign54A = new PIXI.Sprite(textures["accessory_54_a.png"]);
    let accessoryDesign54B = new PIXI.Sprite(textures["accessory_54_b.png"]);
    let accessoryDesign55A = new PIXI.Sprite(textures["accessory_55_a.png"]);
    let accessoryDesign55B = new PIXI.Sprite(textures["accessory_55_b.png"]);
    let accessoryDesign55C = new PIXI.Sprite(textures["accessory_55_c.png"]);
    let accessoryDesign55D = new PIXI.Sprite(textures["accessory_55_d.png"]);
    let accessoryDesign56A = new PIXI.Sprite(textures["accessory_56_a.png"]);
    let accessoryDesign56B = new PIXI.Sprite(textures["accessory_56_b.png"]);
    let accessoryDesign57A = new PIXI.Sprite(textures["accessory_57_a.png"]);
    let accessoryDesign57B = new PIXI.Sprite(textures["accessory_57_b.png"]);
    let accessoryDesign58A = new PIXI.Sprite(textures["accessory_58_a.png"]);
    let accessoryDesign58B = new PIXI.Sprite(textures["accessory_58_b.png"]);
    let accessoryDesign59A = new PIXI.Sprite(textures["accessory_59_a.png"]);
    let accessoryDesign59B = new PIXI.Sprite(textures["accessory_59_b.png"]);
    let accessoryDesign59C = new PIXI.Sprite(textures["accessory_59_c.png"]);
    let accessoryDesign59D = new PIXI.Sprite(textures["accessory_59_d.png"]);
    let accessoryDesign60A = new PIXI.Sprite(textures["accessory_60_a.png"]);
    let accessoryDesign60B = new PIXI.Sprite(textures["accessory_60_b.png"]);
    let accessoryDesign60C = new PIXI.Sprite(textures["accessory_60_c.png"]);
    let accessoryDesign61A = new PIXI.Sprite(textures["accessory_61_a.png"]);
    let accessoryDesign61B = new PIXI.Sprite(textures["accessory_61_b.png"]);
    let accessoryDesign61C = new PIXI.Sprite(textures["accessory_61_c.png"]);
    let accessoryDesign62A = new PIXI.Sprite(textures["accessory_62_a.png"]);
    let accessoryDesign62B = new PIXI.Sprite(textures["accessory_62_b.png"]);
    let accessoryDesign62C = new PIXI.Sprite(textures["accessory_62_c.png"]);
    let accessoryDesign63A = new PIXI.Sprite(textures["accessory_63_a.png"]);
    let accessoryDesign63B = new PIXI.Sprite(textures["accessory_63_b.png"]);
    let accessoryDesign64A = new PIXI.Sprite(textures["accessory_64_a.png"]);
    let accessoryDesign64B = new PIXI.Sprite(textures["accessory_64_b.png"]);
    let accessoryDesign65A = new PIXI.Sprite(textures["accessory_65_a.png"]);
    let accessoryDesign65B = new PIXI.Sprite(textures["accessory_65_b.png"]);
    let accessoryDesign65C = new PIXI.Sprite(textures["accessory_65_c.png"]);
    let accessoryDesign66A = new PIXI.Sprite(textures["accessory_66_a.png"]);
    let accessoryDesign66B = new PIXI.Sprite(textures["accessory_66_b.png"]);
    let accessoryDesign67A = new PIXI.Sprite(textures["accessory_67_a.png"]);
    let accessoryDesign67B = new PIXI.Sprite(textures["accessory_67_b.png"]);
    let accessoryDesign68A = new PIXI.Sprite(textures["accessory_68_a.png"]);
    let accessoryDesign68B = new PIXI.Sprite(textures["accessory_68_b.png"]);
    let accessoryDesign68C = new PIXI.Sprite(textures["accessory_68_c.png"]);
    let accessoryDesign68D = new PIXI.Sprite(textures["accessory_68_d.png"]);
    let accessoryDesign69A = new PIXI.Sprite(textures["accessory_69_a.png"]);
    let accessoryDesign70A = new PIXI.Sprite(textures["accessory_70_a.png"]);
    let accessoryDesign70B = new PIXI.Sprite(textures["accessory_70_b.png"]);
    let accessoryDesign71A = new PIXI.Sprite(textures["accessory_71_a.png"]);
    let accessoryDesign71B = new PIXI.Sprite(textures["accessory_71_b.png"]);
    let accessoryDesign71C = new PIXI.Sprite(textures["accessory_71_c.png"]);
    let accessoryDesign72A = new PIXI.Sprite(textures["accessory_72_a.png"]);
    let accessoryDesign72B = new PIXI.Sprite(textures["accessory_72_b.png"]);

    // Gloves
    let glovesDesign1 = new PIXI.Sprite(textures["gloves_1.png"]);
    let glovesDesign2A = new PIXI.Sprite(textures["gloves_2_a.png"]);
    let glovesDesign2B = new PIXI.Sprite(textures["gloves_2_b.png"]);
    let glovesDesign3A = new PIXI.Sprite(textures["gloves_3_a.png"]);
    let glovesDesign3B = new PIXI.Sprite(textures["gloves_3_b.png"]);
    let glovesDesign4A = new PIXI.Sprite(textures["gloves_4_a.png"]);
    let glovesDesign4B = new PIXI.Sprite(textures["gloves_4_b.png"]);
    let glovesDesign5A = new PIXI.Sprite(textures["gloves_5_a.png"]);
    let glovesDesign5B = new PIXI.Sprite(textures["gloves_5_b.png"]);
    let glovesDesign6A = new PIXI.Sprite(textures["gloves_6_a.png"]);
    let glovesDesign6B = new PIXI.Sprite(textures["gloves_6_b.png"]);

    // Glasses
    let glassesDesign2 = new PIXI.Sprite(textures["glasses_2.png"]);
    let glassesDesign3 = new PIXI.Sprite(textures["glasses_3.png"]);
    let glassesDesign4 = new PIXI.Sprite(textures["glasses_4.png"]);
    let glassesDesign5 = new PIXI.Sprite(textures["glasses_5.png"]);
    let glassesDesign6 = new PIXI.Sprite(textures["glasses_6.png"]);
    let glassesDesign7A = new PIXI.Sprite(textures["glasses_7_a.png"]);
    let glassesDesign7B = new PIXI.Sprite(textures["glasses_7_b.png"]);
    let glassesDesign8A = new PIXI.Sprite(textures["glasses_8_a.png"]);
    let glassesDesign8B = new PIXI.Sprite(textures["glasses_8_b.png"]);

    // Wrist tapes
    let wristTape1 = new PIXI.Sprite(textures["wrist_tape_1.png"]);
    let wristTape2 = new PIXI.Sprite(textures["wrist_tape_2.png"]);
    let wristTape3 = new PIXI.Sprite(textures["wrist_tape_3.png"]);

    // Ties
    let ties1 = new PIXI.Sprite(textures["ties_1.png"]);
    let ties2 = new PIXI.Sprite(textures["ties_2.png"]);
    let ties3 = new PIXI.Sprite(textures["ties_3.png"]);
    let ties4 = new PIXI.Sprite(textures["ties_4.png"]);

    // Suits
    let suits1 = new PIXI.Sprite(textures["suits_1.png"]);
    let suits2 = new PIXI.Sprite(textures["suits_2.png"]);
    let suits3A = new PIXI.Sprite(textures["suits_3_a.png"]);
    let suits3B = new PIXI.Sprite(textures["suits_3_b.png"]);

    // Face paint
    let facepaint1 = new PIXI.Sprite(textures["facepaint_1.png"]);
    let facepaint2 = new PIXI.Sprite(textures["facepaint_2.png"]);
    let facepaint3 = new PIXI.Sprite(textures["facepaint_3.png"]);
    let facepaint4A = new PIXI.Sprite(textures["facepaint_4_a.png"]);
    let facepaint4B = new PIXI.Sprite(textures["facepaint_4_b.png"]);
    let facepaint5A = new PIXI.Sprite(textures["facepaint_5_a.png"]);
    let facepaint5B = new PIXI.Sprite(textures["facepaint_5_b.png"]);
    let facepaint6A = new PIXI.Sprite(textures["facepaint_6_a.png"]);
    let facepaint6B = new PIXI.Sprite(textures["facepaint_6_b.png"]);
    let facepaint7A = new PIXI.Sprite(textures["facepaint_7_a.png"]);
    let facepaint7B = new PIXI.Sprite(textures["facepaint_7_b.png"]);
    let facepaint7C = new PIXI.Sprite(textures["facepaint_7_c.png"]);
    let facepaint8A = new PIXI.Sprite(textures["facepaint_8_a.png"]);
    let facepaint8B = new PIXI.Sprite(textures["facepaint_8_b.png"]);
    let facepaint9A = new PIXI.Sprite(textures["facepaint_9_a.png"]);
    let facepaint9B = new PIXI.Sprite(textures["facepaint_9_b.png"]);
    let facepaint9C = new PIXI.Sprite(textures["facepaint_9_c.png"]);
    let facepaint10A = new PIXI.Sprite(textures["facepaint_10_a.png"]);
    let facepaint10B = new PIXI.Sprite(textures["facepaint_10_b.png"]);
    let facepaint11A = new PIXI.Sprite(textures["facepaint_11_a.png"]);
    let facepaint11B = new PIXI.Sprite(textures["facepaint_11_b.png"]);
    let facepaint12A = new PIXI.Sprite(textures["facepaint_12_a.png"]);
    let facepaint12B = new PIXI.Sprite(textures["facepaint_12_b.png"]);

    let facepaint2Female = new PIXI.Sprite(textures["facepaint_2_female.png"]);
    let facepaint3Female = new PIXI.Sprite(textures["facepaint_3_female.png"]);
    let facepaint4AFemale = new PIXI.Sprite(textures["facepaint_4_a_female.png"]);
    let facepaint4BFemale = new PIXI.Sprite(textures["facepaint_4_b_female.png"]);
    let facepaint5AFemale = new PIXI.Sprite(textures["facepaint_5_a_female.png"]);
    let facepaint5BFemale = new PIXI.Sprite(textures["facepaint_5_b_female.png"]);
    let facepaint6AFemale = new PIXI.Sprite(textures["facepaint_6_a_female.png"]);
    let facepaint6BFemale = new PIXI.Sprite(textures["facepaint_6_b_female.png"]);
    let facepaint7AFemale = new PIXI.Sprite(textures["facepaint_7_a_female.png"]);
    let facepaint8AFemale = new PIXI.Sprite(textures["facepaint_8_a_female.png"]);
    let facepaint8BFemale = new PIXI.Sprite(textures["facepaint_8_b_female.png"]);
    let facepaint9AFemale = new PIXI.Sprite(textures["facepaint_9_a_female.png"]);
    let facepaint9BFemale = new PIXI.Sprite(textures["facepaint_9_b_female.png"]);
    let facepaint9CFemale = new PIXI.Sprite(textures["facepaint_9_c_female.png"]);
    let facepaint10AFemale = new PIXI.Sprite(textures["facepaint_10_a_female.png"]);
    let facepaint10BFemale = new PIXI.Sprite(textures["facepaint_10_b_female.png"]);
    let facepaint11AFemale = new PIXI.Sprite(textures["facepaint_11_a_female.png"]);
    let facepaint11BFemale = new PIXI.Sprite(textures["facepaint_11_b_female.png"]);
    let facepaint12AFemale = new PIXI.Sprite(textures["facepaint_12_a_female.png"]);
    let facepaint12BFemale = new PIXI.Sprite(textures["facepaint_12_b_female.png"]);

    // Sports bras
    let sportsbraBasic = new PIXI.Sprite(textures["sports_bras_basic.png"]);
    let sportsbraLow = new PIXI.Sprite(textures["sports_bras_low.png"]);
    let sportsbraShort = new PIXI.Sprite(textures["sports_bras_short.png"]);
    let sportsbraThinA = new PIXI.Sprite(textures["sports_bras_thin_a.png"]);
    let sportsbraThinB = new PIXI.Sprite(textures["sports_bras_thin_b.png"]);
    let sportsbra1 = new PIXI.Sprite(textures["sports_bras_1.png"]);
    let sportsbra2A = new PIXI.Sprite(textures["sports_bras_2_a.png"]);
    let sportsbra2B = new PIXI.Sprite(textures["sports_bras_2_b.png"]);
    let sportsbra3 = new PIXI.Sprite(textures["sports_bras_3.png"]);
    let sportsbra4 = new PIXI.Sprite(textures["sports_bras_4.png"]);
    let sportsbra5A = new PIXI.Sprite(textures["sports_bras_5_a.png"]);
    let sportsbra5B = new PIXI.Sprite(textures["sports_bras_5_b.png"]);
    let sportsbra6A = new PIXI.Sprite(textures["sports_bras_6_a.png"]);
    let sportsbra6B = new PIXI.Sprite(textures["sports_bras_6_b.png"]);
    let sportsbra6C = new PIXI.Sprite(textures["sports_bras_6_c.png"]);
    let sportsbra7A = new PIXI.Sprite(textures["sports_bras_7_a.png"]);
    let sportsbra7B = new PIXI.Sprite(textures["sports_bras_7_b.png"]);
    let sportsbra8A = new PIXI.Sprite(textures["sports_bras_8_a.png"]);
    let sportsbra8B = new PIXI.Sprite(textures["sports_bras_8_b.png"]);
    let sportsbra8C = new PIXI.Sprite(textures["sports_bras_8_c.png"]);
    let sportsbra9A = new PIXI.Sprite(textures["sports_bras_9_a.png"]);
    let sportsbra9B = new PIXI.Sprite(textures["sports_bras_9_b.png"]);
    let sportsbra9C = new PIXI.Sprite(textures["sports_bras_9_c.png"]);
    let sportsbra10A = new PIXI.Sprite(textures["sports_bras_10_a.png"]);
    let sportsbra10B = new PIXI.Sprite(textures["sports_bras_10_b.png"]);
    let sportsbra10C = new PIXI.Sprite(textures["sports_bras_10_c.png"]);
    let sportsbra11A = new PIXI.Sprite(textures["sports_bras_11_a.png"]);
    let sportsbra11B = new PIXI.Sprite(textures["sports_bras_11_b.png"]);
    let sportsbra12 = new PIXI.Sprite(textures["sports_bras_12.png"]);
    let sportsbra13A = new PIXI.Sprite(textures["sports_bras_13_a.png"]);
    let sportsbra13B = new PIXI.Sprite(textures["sports_bras_13_b.png"]);
    let sportsbra13C = new PIXI.Sprite(textures["sports_bras_13_c.png"]);
    let sportsbra14A = new PIXI.Sprite(textures["sports_bras_14_a.png"]);
    let sportsbra14B = new PIXI.Sprite(textures["sports_bras_14_b.png"]);
    let sportsbra14C = new PIXI.Sprite(textures["sports_bras_14_c.png"]);
    let sportsbra14D = new PIXI.Sprite(textures["sports_bras_14_d.png"]);
    let sportsbra15 = new PIXI.Sprite(textures["sports_bras_15.png"]);
    let sportsbra16A = new PIXI.Sprite(textures["sports_bras_16_a.png"]);
    let sportsbra16B = new PIXI.Sprite(textures["sports_bras_16_b.png"]);
    let sportsbra16C = new PIXI.Sprite(textures["sports_bras_16_c.png"]);

    // Tattoos
    let tattoo1 = new PIXI.Sprite(textures["tattoo_1.png"]);
    let tattoo2 = new PIXI.Sprite(textures["tattoo_2.png"]);
    let tattoo3 = new PIXI.Sprite(textures["tattoo_3.png"]);
    let tattoo4 = new PIXI.Sprite(textures["tattoo_4.png"]);
    let tattoo5 = new PIXI.Sprite(textures["tattoo_5.png"]);
    let tattoo6 = new PIXI.Sprite(textures["tattoo_6.png"]);
    let tattoo7A = new PIXI.Sprite(textures["tattoo_7_a.png"]);
    let tattoo7B = new PIXI.Sprite(textures["tattoo_7_b.png"]);
    let tattoo7C = new PIXI.Sprite(textures["tattoo_7_c.png"]);
    let tattoo8A = new PIXI.Sprite(textures["tattoo_8_a.png"]);
    let tattoo8B = new PIXI.Sprite(textures["tattoo_8_b.png"]);
    let tattoo9 = new PIXI.Sprite(textures["tattoo_9.png"]);
    let tattoo10 = new PIXI.Sprite(textures["tattoo_10.png"]);
    let tattoo11 = new PIXI.Sprite(textures["tattoo_11.png"]);
    let tattoo12 = new PIXI.Sprite(textures["tattoo_12.png"]);
    let tattoo13 = new PIXI.Sprite(textures["tattoo_13.png"]);
    let tattoo14 = new PIXI.Sprite(textures["tattoo_14.png"]);
    let tattoo15 = new PIXI.Sprite(textures["tattoo_15.png"]);
    let tattoo16 = new PIXI.Sprite(textures["tattoo_16.png"]);
    let tattoo17 = new PIXI.Sprite(textures["tattoo_17.png"]);
    let tattoo18 = new PIXI.Sprite(textures["tattoo_18.png"]);
    let tattoo19 = new PIXI.Sprite(textures["tattoo_19.png"]);
    let tattoo20 = new PIXI.Sprite(textures["tattoo_20.png"]);
    let tattoo21 = new PIXI.Sprite(textures["tattoo_21.png"]);
    let tattoo22 = new PIXI.Sprite(textures["tattoo_22.png"]);
    let tattoo23 = new PIXI.Sprite(textures["tattoo_23.png"]);
    let tattoo1Female = new PIXI.Sprite(textures["tattoo_1_female.png"]);
    let tattoo2Female = new PIXI.Sprite(textures["tattoo_2_female.png"]);
    let tattoo3Female = new PIXI.Sprite(textures["tattoo_3_female.png"]);
    let tattoo4Female = new PIXI.Sprite(textures["tattoo_4_female.png"]);
    let tattoo5Female = new PIXI.Sprite(textures["tattoo_5_female.png"]);
    let tattoo10Female = new PIXI.Sprite(textures["tattoo_10_female.png"]);
    let tattoo11Female = new PIXI.Sprite(textures["tattoo_11_female.png"]);
    let tattoo16Female = new PIXI.Sprite(textures["tattoo_16_female.png"]);
    let tattoo17Female = new PIXI.Sprite(textures["tattoo_17_female.png"]);
    let tattoo19Female = new PIXI.Sprite(textures["tattoo_19_female.png"]);
    let tattoo20Female = new PIXI.Sprite(textures["tattoo_20_female.png"]);
    let tattoo21Female = new PIXI.Sprite(textures["tattoo_21_female.png"]);
    let tattoo22Female = new PIXI.Sprite(textures["tattoo_22_female.png"]);
    let tattoo23Female = new PIXI.Sprite(textures["tattoo_23_female.png"]);

    // Knee pads
    let kneepad1 = new PIXI.Sprite(textures["knee_pads_1.png"]);
    let kneepad2 = new PIXI.Sprite(textures["knee_pads_2.png"]);
    let kneepad3 = new PIXI.Sprite(textures["knee_pads_3.png"]);
    let kneepad4 = new PIXI.Sprite(textures["knee_pads_4.png"]);
    let kneepad5 = new PIXI.Sprite(textures["knee_pads_5.png"]);
    let kneepad6 = new PIXI.Sprite(textures["knee_pads_6.png"]);
    let kneepad7 = new PIXI.Sprite(textures["knee_pads_7.png"]);
    let kneepad8 = new PIXI.Sprite(textures["knee_pads_8.png"]);
    let kneepad9 = new PIXI.Sprite(textures["knee_pads_9.png"]);
    let kneepad10 = new PIXI.Sprite(textures["knee_pads_10.png"]);

    // Female tops
    let femaleTop1 = new PIXI.Sprite(textures["female_tops_1.png"]);
    let femaleTop2 = new PIXI.Sprite(textures["female_tops_2.png"]);
    let femaleTop3 = new PIXI.Sprite(textures["female_tops_3.png"]);
    let femaleTop4 = new PIXI.Sprite(textures["female_tops_4.png"]);
    let femaleTop5 = new PIXI.Sprite(textures["female_tops_5.png"]);
    let femaleTop6 = new PIXI.Sprite(textures["female_tops_6.png"]);
    let femaleTop7 = new PIXI.Sprite(textures["female_tops_7.png"]);
    let femaleTop8A = new PIXI.Sprite(textures["female_tops_8_a.png"]);
    let femaleTop8B = new PIXI.Sprite(textures["female_tops_8_b.png"]);
    let femaleTop9A = new PIXI.Sprite(textures["female_tops_9_a.png"]);
    let femaleTop9B = new PIXI.Sprite(textures["female_tops_9_b.png"]);
    let femaleTop10A = new PIXI.Sprite(textures["female_tops_10_a.png"]);
    let femaleTop10B = new PIXI.Sprite(textures["female_tops_10_b.png"]);
    let femaleTop11A = new PIXI.Sprite(textures["female_tops_11_a.png"]);
    let femaleTop11B = new PIXI.Sprite(textures["female_tops_11_b.png"]);

    // Female bottoms
    let femaleBottom1A = new PIXI.Sprite(textures["female_bottoms_1_a.png"]);
    let femaleBottom1B = new PIXI.Sprite(textures["female_bottoms_1_b.png"]);
    let femaleBottom2 = new PIXI.Sprite(textures["female_bottoms_2.png"]);
    let femaleBottom3A = new PIXI.Sprite(textures["female_bottoms_3_a.png"]);
    let femaleBottom3B = new PIXI.Sprite(textures["female_bottoms_3_b.png"]);
    let femaleBottom3C = new PIXI.Sprite(textures["female_bottoms_3_c.png"]);
    let femaleBottom4A = new PIXI.Sprite(textures["female_bottoms_4_a.png"]);
    let femaleBottom4B = new PIXI.Sprite(textures["female_bottoms_4_b.png"]);
    let femaleBottom4C = new PIXI.Sprite(textures["female_bottoms_4_c.png"]);
    let femaleBottom5 = new PIXI.Sprite(textures["female_bottoms_5.png"]);
    let femaleBottom6A = new PIXI.Sprite(textures["female_bottoms_6_a.png"]);
    let femaleBottom6B = new PIXI.Sprite(textures["female_bottoms_6_b.png"]);
    let femaleBottom6C = new PIXI.Sprite(textures["female_bottoms_6_c.png"]);
    let femaleBottom7 = new PIXI.Sprite(textures["female_bottoms_7.png"]);
    let femaleBottom8A = new PIXI.Sprite(textures["female_bottoms_8_a.png"]);
    let femaleBottom8B = new PIXI.Sprite(textures["female_bottoms_8_b.png"]);
    let femaleBottom9A = new PIXI.Sprite(textures["female_bottoms_9_a.png"]);
    let femaleBottom9B = new PIXI.Sprite(textures["female_bottoms_9_b.png"]);
    let femaleBottom10 = new PIXI.Sprite(textures["female_bottoms_10.png"]);
    let femaleBottom11 = new PIXI.Sprite(textures["female_bottoms_11.png"]);
    let femaleBottom12A = new PIXI.Sprite(textures["female_bottoms_12_a.png"]);
    let femaleBottom12B = new PIXI.Sprite(textures["female_bottoms_12_b.png"]);
    let femaleBottom12C = new PIXI.Sprite(textures["female_bottoms_12_c.png"]);
    let femaleBottom13 = new PIXI.Sprite(textures["female_bottoms_13.png"]);
    let femaleBottom14A = new PIXI.Sprite(textures["female_bottoms_14_a.png"]);
    let femaleBottom14B = new PIXI.Sprite(textures["female_bottoms_14_b.png"]);
    let femaleBottom15 = new PIXI.Sprite(textures["female_bottoms_15.png"]);
    let femaleBottom16A = new PIXI.Sprite(textures["female_bottoms_16_a.png"]);
    let femaleBottom16B = new PIXI.Sprite(textures["female_bottoms_16_b.png"]);
    let femaleBottom17 = new PIXI.Sprite(textures["female_bottoms_17.png"]);
    let femaleBottom18 = new PIXI.Sprite(textures["female_bottoms_18.png"]);
    let femaleBottom19 = new PIXI.Sprite(textures["female_bottoms_19.png"]);
    let femaleBottom20 = new PIXI.Sprite(textures["female_bottoms_20.png"]);
    let femaleBottom21A = new PIXI.Sprite(textures["female_bottoms_21_a.png"]);
    let femaleBottom21B = new PIXI.Sprite(textures["female_bottoms_21_b.png"]);
    let femaleBottom21C = new PIXI.Sprite(textures["female_bottoms_21_c.png"]);

    // Female accessories
    let femaleAccessory1 = new PIXI.Sprite(textures["female_accessories_1.png"]);
    let femaleAccessory2 = new PIXI.Sprite(textures["female_accessories_2.png"]);
    let femaleAccessory3 = new PIXI.Sprite(textures["female_accessories_3.png"]);
    let femaleAccessory4A = new PIXI.Sprite(textures["female_accessories_4_a.png"]);
    let femaleAccessory4B = new PIXI.Sprite(textures["female_accessories_4_b.png"]);
    let femaleAccessory5 = new PIXI.Sprite(textures["female_accessories_5.png"]);
    let femaleAccessory6 = new PIXI.Sprite(textures["female_accessories_6.png"]);
    let femaleAccessory7 = new PIXI.Sprite(textures["female_accessories_7.png"]);
    let femaleAccessory8A = new PIXI.Sprite(textures["female_accessories_8_a.png"]);
    let femaleAccessory8B = new PIXI.Sprite(textures["female_accessories_8_b.png"]);
    let femaleAccessory9A = new PIXI.Sprite(textures["female_accessories_9_a.png"]);
    let femaleAccessory9B = new PIXI.Sprite(textures["female_accessories_9_b.png"]);
    let femaleAccessory10 = new PIXI.Sprite(textures["female_accessories_10.png"]);
    let femaleAccessory11 = new PIXI.Sprite(textures["female_accessories_11.png"]);
    let femaleAccessory12 = new PIXI.Sprite(textures["female_accessories_12.png"]);

    // Female hair
    let femaleHair1A = new PIXI.Sprite(textures["hair_female_1_a.png"]);
    let femaleHair1B = new PIXI.Sprite(textures["hair_female_1_b.png"]);
    let femaleHair2A = new PIXI.Sprite(textures["hair_female_2_a.png"]);
    let femaleHair2B = new PIXI.Sprite(textures["hair_female_2_b.png"]);
    let femaleHair3A = new PIXI.Sprite(textures["hair_female_3_a.png"]);
    let femaleHair3B = new PIXI.Sprite(textures["hair_female_3_b.png"]);
    let femaleHair4A = new PIXI.Sprite(textures["hair_female_4_a.png"]);
    let femaleHair5A = new PIXI.Sprite(textures["hair_female_5_a.png"]);
    let femaleHair5B = new PIXI.Sprite(textures["hair_female_5_b.png"]);
    let femaleHair6A = new PIXI.Sprite(textures["hair_female_6_a.png"]);
    let femaleHair6B = new PIXI.Sprite(textures["hair_female_6_b.png"]);
    let femaleHair7A = new PIXI.Sprite(textures["hair_female_7_a.png"]);
    let femaleHair7B = new PIXI.Sprite(textures["hair_female_7_b.png"]);
    let femaleHair8A = new PIXI.Sprite(textures["hair_female_8_a.png"]);
    let femaleHair8B = new PIXI.Sprite(textures["hair_female_8_b.png"]);
    let femaleHair9A = new PIXI.Sprite(textures["hair_female_9_a.png"]);
    let femaleHair9B = new PIXI.Sprite(textures["hair_female_9_b.png"]);
    let femaleHair10A = new PIXI.Sprite(textures["hair_female_10_a.png"]);
    let femaleHair10B = new PIXI.Sprite(textures["hair_female_10_b.png"]);
    let femaleHair11A = new PIXI.Sprite(textures["hair_female_11_a.png"]);
    let femaleHair11B = new PIXI.Sprite(textures["hair_female_11_b.png"]);
    let femaleHair12A = new PIXI.Sprite(textures["hair_female_12_a.png"]);
    let femaleHair12B = new PIXI.Sprite(textures["hair_female_12_b.png"]);
    let femaleHair13A = new PIXI.Sprite(textures["hair_female_13_a.png"]);
    let femaleHair13B = new PIXI.Sprite(textures["hair_female_13_b.png"]);
    let femaleHair14A = new PIXI.Sprite(textures["hair_female_14_a.png"]);
    let femaleHair14B = new PIXI.Sprite(textures["hair_female_14_b.png"]);
    let femaleHair15A = new PIXI.Sprite(textures["hair_female_15_a.png"]);
    let femaleHair15B = new PIXI.Sprite(textures["hair_female_15_b.png"]);
    let femaleHair16A = new PIXI.Sprite(textures["hair_female_16_a.png"]);
    let femaleHair16B = new PIXI.Sprite(textures["hair_female_16_b.png"]);
    let femaleHair17A = new PIXI.Sprite(textures["hair_female_17_a.png"]);
    let femaleHair17B = new PIXI.Sprite(textures["hair_female_17_b.png"]);
    let femaleHair18A = new PIXI.Sprite(textures["hair_female_18_a.png"]);
    let femaleHair18B = new PIXI.Sprite(textures["hair_female_18_b.png"]);
    let femaleHair19A = new PIXI.Sprite(textures["hair_female_19_a.png"]);
    let femaleHair19B = new PIXI.Sprite(textures["hair_female_19_b.png"]);
    let femaleHair20A = new PIXI.Sprite(textures["hair_female_20_a.png"]);
    let femaleHair20B = new PIXI.Sprite(textures["hair_female_20_b.png"]);
    let femaleHair21A = new PIXI.Sprite(textures["hair_female_21_a.png"]);
    let femaleHair21B = new PIXI.Sprite(textures["hair_female_21_b.png"]);
    let femaleHair22A = new PIXI.Sprite(textures["hair_female_22_a.png"]);
    let femaleHair22B = new PIXI.Sprite(textures["hair_female_22_b.png"]);
    let femaleHair23A = new PIXI.Sprite(textures["hair_female_23_a.png"]);
    let femaleHair23B = new PIXI.Sprite(textures["hair_female_23_b.png"]);
    let femaleHair23C = new PIXI.Sprite(textures["hair_female_23_c.png"]);
    let femaleHair24A = new PIXI.Sprite(textures["hair_female_24_a.png"]);
    let femaleHair24B = new PIXI.Sprite(textures["hair_female_24_b.png"]);
    let femaleHair25A = new PIXI.Sprite(textures["hair_female_25_a.png"]);
    let femaleHair25B = new PIXI.Sprite(textures["hair_female_25_b.png"]);
    let femaleHair26A = new PIXI.Sprite(textures["hair_female_26_a.png"]);
    let femaleHair26B = new PIXI.Sprite(textures["hair_female_26_b.png"]);
    let femaleHair27A = new PIXI.Sprite(textures["hair_female_27_a.png"]);
    let femaleHair27B = new PIXI.Sprite(textures["hair_female_27_b.png"]);
    let femaleHair28A = new PIXI.Sprite(textures["hair_female_28_a.png"]);
    let femaleHair28B = new PIXI.Sprite(textures["hair_female_28_b.png"]);
    let femaleHair29A = new PIXI.Sprite(textures["hair_female_29_a.png"]);
    let femaleHair29B = new PIXI.Sprite(textures["hair_female_29_b.png"]);
    let femaleHair30A = new PIXI.Sprite(textures["hair_female_30_a.png"]);
    let femaleHair30B = new PIXI.Sprite(textures["hair_female_30_b.png"]);

    // Title Sprites
    let titleSmallPlate1 = new PIXI.Sprite(textures["title_small_plate_1.png"]);
    let titleSmallPlate2 = new PIXI.Sprite(textures["title_small_plate_2.png"]);
    let titleSmallPlate3 = new PIXI.Sprite(textures["title_small_plate_3.png"]);
    let titleSmallPlate4 = new PIXI.Sprite(textures["title_small_plate_4.png"]);
    let titleSmallPlate5 = new PIXI.Sprite(textures["title_small_plate_5.png"]);
    let titleSmallPlate6 = new PIXI.Sprite(textures["title_small_plate_6.png"]);
    let titleSmallPlate7 = new PIXI.Sprite(textures["title_small_plate_7.png"]);
    let titleSmallPlate8 = new PIXI.Sprite(textures["title_small_plate_8.png"]);
    let titleSmallPlate9 = new PIXI.Sprite(textures["title_small_plate_9.png"]);
    let titleSmallPlate10 = new PIXI.Sprite(textures["title_small_plate_10.png"]);

    let titleSmallGems1 = new PIXI.Sprite(textures["title_small_gems_1.png"]);
    let titleSmallGems2 = new PIXI.Sprite(textures["title_small_gems_2.png"]);
    let titleSmallGems3 = new PIXI.Sprite(textures["title_small_gems_3.png"]);
    let titleSmallGems4 = new PIXI.Sprite(textures["title_small_gems_4.png"]);
    let titleSmallGems5 = new PIXI.Sprite(textures["title_small_gems_5.png"]);
    let titleSmallGems6 = new PIXI.Sprite(textures["title_small_gems_6.png"]);
    let titleSmallGems7 = new PIXI.Sprite(textures["title_small_gems_7.png"]);
    let titleSmallGems8 = new PIXI.Sprite(textures["title_small_gems_8.png"]);
    let titleSmallGems9 = new PIXI.Sprite(textures["title_small_gems_9.png"]);
    let titleSmallGems10 = new PIXI.Sprite(textures["title_small_gems_10.png"]);

    let titleSmallStrap1 = new PIXI.Sprite(textures["title_small_strap_1.png"]);
    let titleSmallStrap2 = new PIXI.Sprite(textures["title_small_strap_2.png"]);
    let titleSmallStrap3 = new PIXI.Sprite(textures["title_small_strap_3.png"]);
    let titleSmallStrap4 = new PIXI.Sprite(textures["title_small_strap_4.png"]);
    let titleSmallStrap5 = new PIXI.Sprite(textures["title_small_strap_5.png"]);
    let titleSmallStrap6 = new PIXI.Sprite(textures["title_small_strap_6.png"]);
    let titleSmallStrap7 = new PIXI.Sprite(textures["title_small_strap_7.png"]);
    let titleSmallStrap8 = new PIXI.Sprite(textures["title_small_strap_8.png"]);
    let titleSmallStrap9 = new PIXI.Sprite(textures["title_small_strap_9.png"]);
    let titleSmallStrap10 = new PIXI.Sprite(textures["title_small_strap_10.png"]);

    // Special segment sprites
    let specialSegmentsCar = new PIXI.Sprite(textures["special_segments_car_black.png"]);
    let specialSegmentsCarFire = new PIXI.Sprite(textures["special_segments_car_fire.png"]);
    let specialSegmentsHelicopter = new PIXI.Sprite(textures["special_segments_helicopter.png"]);
    let specialSegmentsHelicopterBuilding = new PIXI.Sprite(textures["special_segments_helicopter_building.png"]);
    let specialSegmentsHelicopterBuildingLights = new PIXI.Sprite(textures["special_segments_helicopter_building_lights.png"]);
    let specialSegmentsLemonadeTruck = new PIXI.Sprite(textures["special_segments_lemonade_truck.png"]);
    let specialSegmentsLemonadeTruckSpray = new PIXI.Sprite(textures["special_segments_lemonade_truck_spray.png"]);
    let specialSegmentsStage = new PIXI.Sprite(textures["special_segments_stage.png"]);
    let specialSegmentsStageRailing = new PIXI.Sprite(textures["special_segments_stage_railing.png"]);
    let specialSegmentsDummy = new PIXI.Sprite(textures["special_segments_dummy.png"]);
    let specialSegmentsAmbulance = new PIXI.Sprite(textures["special_segments_ambulance.png"]);
    let specialSegmentsCelebrityAmericanQueen = new PIXI.Sprite(textures["special_segments_celebrity_1.png"]);
    let specialSegmentsCelebrityPrezz = new PIXI.Sprite(textures["special_segments_celebrity_2.png"]);
    let specialSegmentsCelebrityBigT = new PIXI.Sprite(textures["special_segments_celebrity_3.png"]);
    let specialSegmentsRantMic = new PIXI.Sprite(textures["special_segments_rant_mic.png"]);
    let specialSegmentsRantSpeech = new PIXI.Sprite(textures["special_segments_rant_speech.png"]);
    let specialSegmentsLoveMakingManClothed = new PIXI.Sprite(textures["special_segments_love_making_man_clothed.png"]);
    let specialSegmentsLoveMakingManNude = new PIXI.Sprite(textures["special_segments_love_making_man_nude.png"]);
    let specialSegmentsLoveMakingWomanClothed = new PIXI.Sprite(textures["special_segments_love_making_woman_clothed.png"]);
    let specialSegmentsLoveMakingWomanNude = new PIXI.Sprite(textures["special_segments_love_making_woman_nude.png"]);
    let specialSegmentsLoveMakingBottomCensor = new PIXI.Sprite(textures["special_segments_love_making_bottom_censor.png"]);
    let specialSegmentsLoveMakingTopCensor = new PIXI.Sprite(textures["special_segments_love_making_top_censor.png"]);
    let specialSegmentsLoveMakingBed = new PIXI.Sprite(textures["special_segments_love_making_bed.png"]);
    let specialSegmentsLoveMakingHeart = new PIXI.Sprite(textures["special_segments_love_making_heart.png"]);
    let specialSegmentsRing = new PIXI.Sprite(textures["special_segments_ring.png"]);
    let specialSegmentsRingRopes = new PIXI.Sprite(textures["special_segments_ring_ropes.png"]);
    let specialSegmentsRingPeopleTop = new PIXI.Sprite(textures["special_segments_ring_people_top.png"]);
    let specialSegmentsRingPeopleBottom = new PIXI.Sprite(textures["special_segments_ring_people_bottom.png"]);

    // Blood sprites
    let bloodDesign1 = new PIXI.Sprite(textures["blood_1.png"]);
    let bloodDesign2 = new PIXI.Sprite(textures["blood_2.png"]);
    let bloodDesign3 = new PIXI.Sprite(textures["blood_3.png"]);
    let bloodDesign4 = new PIXI.Sprite(textures["blood_4.png"]);
    let bloodDesign5 = new PIXI.Sprite(textures["blood_5.png"]);
    let bloodDesign6 = new PIXI.Sprite(textures["blood_6.png"]);
    let bloodDesign7 = new PIXI.Sprite(textures["blood_7.png"]);
    let bloodDesign8 = new PIXI.Sprite(textures["blood_8.png"]);
    let bloodDesign9 = new PIXI.Sprite(textures["blood_9.png"]);
    let bloodDesign10 = new PIXI.Sprite(textures["blood_10.png"]);
    let bloodDesign11 = new PIXI.Sprite(textures["blood_11.png"]);
    let bloodDesign12 = new PIXI.Sprite(textures["blood_12.png"]);
    let bloodDesign13 = new PIXI.Sprite(textures["blood_13.png"]);

    // Backgrounds
    let posterBackground1 = new PIXI.Sprite(textures["poster_background_1.png"]);
    let posterBackground2 = new PIXI.Sprite(textures["poster_background_2.png"]);
    let posterBackground3 = new PIXI.Sprite(textures["poster_background_3.png"]);
    let posterBackground4 = new PIXI.Sprite(textures["poster_background_4.png"]);
    let posterBackground5 = new PIXI.Sprite(textures["poster_background_5.png"]);
    let posterBackground6 = new PIXI.Sprite(textures["poster_background_6.png"]);
    let posterBackground7 = new PIXI.Sprite(textures["poster_background_7.png"]);
    let posterBackground8 = new PIXI.Sprite(textures["poster_background_8.png"]);
    let posterBackground9 = new PIXI.Sprite(textures["poster_background_9.png"]);
    let posterBackground10 = new PIXI.Sprite(textures["poster_background_10.png"]);

    // Gimmick match sprites
    let gimmickMatchLadderBlack = new PIXI.Sprite(textures["gimmick_match_ladder_black.png"]);
    let gimmickMatchLadderGrey = new PIXI.Sprite(textures["gimmick_match_ladder_grey.png"]);
    let gimmickMatchLadderOrange = new PIXI.Sprite(textures["gimmick_match_ladder_red.png"]);
    let gimmickMatchCageGrey = new PIXI.Sprite(textures["gimmick_match_cage_grey.png"]);
    let gimmickMatchCageRed = new PIXI.Sprite(textures["gimmick_match_cage_red.png"]);
    let gimmickMatchCageRetroBlue = new PIXI.Sprite(textures["gimmick_match_cage_retro_blue.png"]);
    let gimmickMatchCageRetroBlack = new PIXI.Sprite(textures["gimmick_match_cage_retro_black.png"]);
    let gimmickMatchTableBrown = new PIXI.Sprite(textures["gimmick_match_table_brown.png"]);
    let gimmickMatchTableBrownStanding = new PIXI.Sprite(textures["gimmick_match_table_brown_standing.png"]);
    let gimmickMatchTableDarkBrown = new PIXI.Sprite(textures["gimmick_match_table_dark_brown.png"]);
    let gimmickMatchTableDarkBrownStanding = new PIXI.Sprite(textures["gimmick_match_table_dark_brown_standing.png"]);
    let gimmickMatchTableLightBrown = new PIXI.Sprite(textures["gimmick_match_table_light_brown.png"]);
    let gimmickMatchTableLightBrownStanding = new PIXI.Sprite(textures["gimmick_match_table_light_brown_standing.png"]);
    let gimmickMatchChairBiege = new PIXI.Sprite(textures["gimmick_match_chair_biege.png"]);
    let gimmickMatchChairBlack = new PIXI.Sprite(textures["gimmick_match_chair_black.png"]);
    let gimmickMatchChairBlue = new PIXI.Sprite(textures["gimmick_match_chair_blue.png"]);
    let gimmickMatchAmbulance = new PIXI.Sprite(textures["gimmick_match_ambulance.png"]);
    let gimmickMatchBarbedWireRopes = new PIXI.Sprite(textures["gimmick_match_barbed_wire_ropes.png"]);
    let gimmickMatchBarbedWireBoard = new PIXI.Sprite(textures["gimmick_match_barbed_wire_board.png"]);
    let gimmickMatchBuriedAlive = new PIXI.Sprite(textures["gimmick_match_buried_alive.png"]);
    let gimmickMatchCasketBrown = new PIXI.Sprite(textures["gimmick_match_casket_brown.png"]);
    let gimmickMatchCasketPurple = new PIXI.Sprite(textures["gimmick_match_casket_purple.png"]);
    let gimmickMatchCasketLightBrown = new PIXI.Sprite(textures["gimmick_match_casket_light_brown.png"]);
    let gimmickMatchParkingLotA = new PIXI.Sprite(textures["gimmick_match_parking_lot_a.png"]);
    let gimmickMatchParkingLotB = new PIXI.Sprite(textures["gimmick_match_parking_lot_b.png"]);

    // Temporary injury sprites
    let bruiseEyeRight = new PIXI.Sprite(textures["bruise_eye_right.png"]);
    let bruiseEyeLeft = new PIXI.Sprite(textures["bruise_eye_left.png"]);
    let bandageArmRight = new PIXI.Sprite(textures["bandage_arm_right.png"]);
    let bandageArmLeft = new PIXI.Sprite(textures["bandage_arm_left.png"]);
    let bandageForeheadLeft = new PIXI.Sprite(textures["bandage_forehead_left.png"]);
    let bandageForeheadRight = new PIXI.Sprite(textures["bandage_forehead_right.png"]);
    let bandageForeheadFull = new PIXI.Sprite(textures["bandage_forehead_full.png"]);

    // TGI sprites
    let TGITrophy = new PIXI.Sprite(textures["tgi_trophy.png"]);
    let TGIFireworks = new PIXI.Sprite(textures["tgi_fireworks.png"]);

    // Set graphic objects
    let bodyObjectHe = {
        designs: [{sprite: bodyHe, zIndex: -1, defaultColor: '0xF7D1B9'}]
    };
    let bodyObjectHe2 = {
        designs: [{sprite: bodyHe, zIndex: -1, defaultColor: '0xB6916E'}]
    };
    let bodyObjectHe3 = {
        designs: [{sprite: bodyHe, zIndex: -1, defaultColor: '0xEBC6A2'}]
    };
    let bodyObjectShe = {
        designs: [{sprite: bodyShe, zIndex: -1, defaultColor: '0xF7D1B9'}]
    };
    let bodyObjectHeAbs = {
        designs: [{sprite: bodyHeAbs, zIndex: -1, defaultColor: '0xF7D1B9'}]
    };
    let bodyObjectSheAbs = {
        designs: [{sprite: bodySheAbs, zIndex: -1, defaultColor: '0xF7D1B9'}]
    };

    let eyesObject = {
        designs: [{sprite: eyesDesign, zIndex: 0, defaultColor: '0x000000'}]
    };

    let trunkObject1 = {
        designs: [
            {sprite: trunksBase, zIndex: 1, defaultColor: '0x333333'}
        ]
    };
    let trunkObject2 = {
        designs: [
            {sprite: trunksBase, zIndex: 1, defaultColor: '0x72A2C7'},
        ]
    };
    let trunkObject3 = {
        designs: [
            {sprite: trunksBase, zIndex: 1, defaultColor: '0x5B935F'},
            {sprite: trunksDesign1, zIndex: 2, defaultColor: '0xCCCCCC'}
        ]
    };
    let trunkObject4 = {
        designs: [
            {sprite: trunksBase, zIndex: 1, defaultColor: '0xA54848'},
            {sprite: trunksDesign2, zIndex: 2, defaultColor: '0x444444'}
        ]
    };
    let trunkObject5 = {
        designs: [
            {sprite: trunksBase, zIndex: 1, defaultColor: '0xE7E7E7'},
            {sprite: trunksDesign3, zIndex: 2, defaultColor: '0xE2A54E'}
        ]
    };
    let trunkObject6 = {
        designs: [
            {sprite: trunksBase, zIndex: 1, defaultColor: '0x9F557C'},
            {sprite: trunksDesign4, zIndex: 2, defaultColor: '0x4C4C4C'}
        ]
    };
    let trunkObject7 = {
        designs: [
            {sprite: trunksBase, zIndex: 1, defaultColor: '0x7FB2D2'},
            {sprite: trunksDesign5, zIndex: 2, defaultColor: '0xD27F7F'}
        ]
    };
    let trunkObject8 = {
        designs: [
            {sprite: trunksBase, zIndex: 1, defaultColor: '0x5BDE37'},
            {sprite: trunksDesign6A, zIndex: 2, defaultColor: '0xFFD622'},
            {sprite: trunksDesign6B, zIndex: 3, defaultColor: '0xF1FF2E'}
        ]
    };
    let trunkObject9 = {
        designs: [
            {sprite: trunksBase, zIndex: 1, defaultColor: '0x505050'},
            {sprite: trunksDesign7, zIndex: 2, defaultColor: '0x967892'}
        ]
    };
    let trunkObject10 = {
        designs: [
            {sprite: trunksBase, zIndex: 1, defaultColor: '0x313131'},
            {sprite: trunksDesign8A, zIndex: 2, defaultColor: '0xB091C1'},
            {sprite: trunksDesign8B, zIndex: 3, defaultColor: '0xFFFFFF'}
        ]
    };
    let trunkObject11 = {
        designs: [
            {sprite: trunksBase, zIndex: 1, defaultColor: '0x74D8F6'},
            {sprite: trunksDesign9, zIndex: 2, defaultColor: '0xFFFFFF'}
        ]
    };
    let trunkObject12 = {
        designs: [
            {sprite: trunksBase, zIndex: 1, defaultColor: '0x3B3B3B'},
            {sprite: trunksDesign10A, zIndex: 2, defaultColor: '0xC9C9C9'},
            {sprite: trunksDesign10B, zIndex: 3, defaultColor: '0xDAD235'}
        ]
    };
    let trunkObject13 = {
        designs: [
            {sprite: trunksBase, zIndex: 1, defaultColor: '0x62BF6D'},
            {sprite: trunksDesign11, zIndex: 2, defaultColor: '0xC3C3C3'},
        ]
    };
    let trunkObject14 = {
        designs: [
            {sprite: trunksBase, zIndex: 1, defaultColor: '0xD2822D'},
            {sprite: trunksDesign12, zIndex: 2, defaultColor: '0x474747'},
        ]
    };
    let trunkObject15 = {
        designs: [
            {sprite: trunksBase, zIndex: 1, defaultColor: '0xD2822D'},
            {sprite: trunksDesign13, zIndex: 2, defaultColor: '0xDCD43B'},
        ]
    };
    let trunkObject16 = {
        designs: [
            {sprite: trunksBase, zIndex: 1, defaultColor: '0x2E2E2E'},
            {sprite: trunksDesign14A, zIndex: 2, defaultColor: '0xCBCBCB'},
            {sprite: trunksDesign14B, zIndex: 3, defaultColor: '0x4195B9'}
        ]
    };
    let trunkObject17 = {
        designs: [
            {sprite: trunksBase, zIndex: 1, defaultColor: '0xD0D0D0'},
            {sprite: trunksDesign15A, zIndex: 2, defaultColor: '0x575757'},
            {sprite: trunksDesign15B, zIndex: 3, defaultColor: '0xFFFFFF'}
        ]
    };

    let shortsObjectBasic = {
        designs: [
            {sprite: shortsBase, zIndex: 13, defaultColor: '0x444444'}
        ]
    };

    let shortsObject1 = {
        designs: [
            {sprite: shortsBase, zIndex: 13, defaultColor: '0xEEA744'},
            {sprite: shortsDesign1A, zIndex: 14, defaultColor: '0x333333'},
            {sprite: shortsDesign1B, zIndex: 15, defaultColor: '0xE2E2E2'},
            {sprite: shortsDesign1C, zIndex: 15, defaultColor: '0xFFFFFF'}
        ]
    };
    let shortsObject2 = {
        designs: [
            {sprite: shortsBase, zIndex: 13, defaultColor: '0xCA4545'},
            {sprite: shortsDesign2A, zIndex: 14, defaultColor: '0x65A1DD'},
            {sprite: shortsDesign2B, zIndex: 15, defaultColor: '0xFFFFFF'}
        ]
    };
    let shortsObject3 = {
        designs: [
            {sprite: shortsBase, zIndex: 13, defaultColor: '0x77C1C0'},
            {sprite: shortsDesign3, zIndex: 14, defaultColor: '0xFFFFFF'}
        ]
    };
    let shortsObject4 = {
        designs: [
            {sprite: shortsBase, zIndex: 13, defaultColor: '0x4C4C4C'},
            {sprite: shortsDesign4A, zIndex: 14, defaultColor: '0x4E9755'},
            {sprite: shortsDesign4B, zIndex: 15, defaultColor: '0xC6C6C6'}
        ]
    };
    let shortsObject5 = {
        designs: [
            {sprite: shortsBase, zIndex: 13, defaultColor: '0x564695'},
            {sprite: shortsDesign5, zIndex: 14, defaultColor: '0x7DC1DA'}
        ]
    };
    let shortsObject6 = {
        designs: [
            {sprite: shortsBase, zIndex: 13, defaultColor: '0x3B3B3B'},
            {sprite: shortsDesign6A, zIndex: 14, defaultColor: '0xCF3636'},
            {sprite: shortsDesign6B, zIndex: 15, defaultColor: '0x3B3B3B'}
        ]
    };
    let shortsObject7 = {
        designs: [
            {sprite: shortsBase, zIndex: 13, defaultColor: '0x3B3B3B'},
            {sprite: shortsDesign7A, zIndex: 14, defaultColor: '0xD1D1D1'},
            {sprite: shortsDesign7B, zIndex: 15, defaultColor: '0x656565'}
        ]
    };
    let shortsObject8 = {
        designs: [
            {sprite: shortsBase, zIndex: 13, defaultColor: '0x45565E'},
            {sprite: shortsDesign8A, zIndex: 14, defaultColor: '0xCCCCCC'},
            {sprite: shortsDesign8B, zIndex: 15, defaultColor: '0x4D6069'}
        ]
    };
    let shortsObject9 = {
        designs: [
            {sprite: shortsDesign9A, zIndex: 13, defaultColor: '0x333333'},
            {sprite: shortsDesign9B, zIndex: 14, defaultColor: '0xF3C632'},
            {sprite: shortsDesign9C, zIndex: 15, defaultColor: '0xF3C632'}
        ]
    };

    let tightsObject0 = {
        designs: [
            {sprite: tightsBase, zIndex: 4, defaultColor: '0x333333'}
        ]
    };
    let tightsObject1 = {
        designs: [
            {sprite: tightsBase, zIndex: 4, defaultColor: '0x6ACFE7'},
            {sprite: tightsDesign1A, zIndex: 5, defaultColor: '0x358B7C'},
            {sprite: tightsDesign1B, zIndex: 5, defaultColor: '0x358B7C'}
        ]
    };
    let tightsObject2 = {
        designs: [
            {sprite: tightsBase, zIndex: 4, defaultColor: '0x785CAA'},
            {sprite: tightsDesign2, zIndex: 5, defaultColor: '0xEBEBEB'}
        ]
    };
    let tightsObject3 = {
        designs: [
            {sprite: tightsBase, zIndex: 4, defaultColor: '0x65C474'},
            {sprite: tightsDesign3, zIndex: 5, defaultColor: '0xEBDB55'}
        ]
    };
    let tightsObject4 = {
        designs: [
            {sprite: tightsBase, zIndex: 4, defaultColor: '0x6FB0E7'},
            {sprite: tightsDesign4A, zIndex: 5, defaultColor: '0xE75B5B'},
            {sprite: tightsDesign4B, zIndex: 5, defaultColor: '0xE75B5B'}
        ]
    };
    let tightsObject5 = {
        designs: [
            {sprite: tightsBase, zIndex: 4, defaultColor: '0x3F3F3F'},
            {sprite: tightsDesign5A, zIndex: 5, defaultColor: '0xBA3434'},
            {sprite: tightsDesign5B, zIndex: 5, defaultColor: '0xBA3434'}
        ]
    };
    let tightsObject6 = {
        designs: [
            {sprite: tightsBase, zIndex: 4, defaultColor: '0x5D5D5D'},
            {sprite: tightsDesign6, zIndex: 5, defaultColor: '0xDB8A49'}
        ]
    };
    let tightsObject7 = {
        designs: [
            {sprite: tightsBase, zIndex: 4, defaultColor: '0x3B3B3B'},
            {sprite: tightsDesign7A, zIndex: 5, defaultColor: '0xFDA9FF'},
            {sprite: tightsDesign7B, zIndex: 5, defaultColor: '0xFDA9FF'}
        ]
    };
    let tightsObject8 = {
        designs: [
            {sprite: tightsBase, zIndex: 4, defaultColor: '0x7B985D'},
            {sprite: tightsDesign8, zIndex: 5, defaultColor: '0xD2FFA3'}
        ]
    };
    let tightsObject9 = {
        designs: [
            {sprite: tightsBase, zIndex: 4, defaultColor: '0x363636'},
            {sprite: tightsDesign9A, zIndex: 5, defaultColor: '0xDC814A'},
            {sprite: tightsDesign9B, zIndex: 5, defaultColor: '0xF4DC38'}
        ]
    };
    let tightsObject10 = {
        designs: [
            {sprite: tightsBase, zIndex: 4, defaultColor: '0xDEFFA0'},
            {sprite: tightsDesign10, zIndex: 5, defaultColor: '0x628CE8'}
        ]
    };
    let tightsObject11 = {
        designs: [
            {sprite: tightsBase, zIndex: 4, defaultColor: '0x363636'},
            {sprite: tightsDesign11A, zIndex: 5, defaultColor: '0xFFFFFF'},
            {sprite: tightsDesign11B, zIndex: 5, defaultColor: '0xFFFFFF'}
        ]
    };
    let tightsObject12 = {
        designs: [
            {sprite: tightsBase, zIndex: 4, defaultColor: '0xEBE93D'},
            {sprite: tightsDesign12, zIndex: 5, defaultColor: '0x2D2D2D'}
        ]
    };
    let tightsObject13 = {
        designs: [
            {sprite: tightsBase, zIndex: 4, defaultColor: '0x363636'},
            {sprite: tightsDesign13, zIndex: 5, defaultColor: '0xE1BE1A'}
        ]
    };
    let tightsObject14 = {
        designs: [
            {sprite: tightsBase, zIndex: 4, defaultColor: '0x363636'},
            {sprite: tightsDesign14, zIndex: 5, defaultColor: '0xD4D4D4'}
        ]
    };
    let tightsObject15 = {
        designs: [
            {sprite: tightsBase, zIndex: 4, defaultColor: '0xB25E4D'},
            {sprite: tightsDesign15, zIndex: 5, defaultColor: '0x358B7C'}
        ]
    };
    let tightsObject16 = {
        designs: [
            {sprite: tightsBase, zIndex: 4, defaultColor: '0xF4F4F4'},
            {sprite: tightsDesign16, zIndex: 5, defaultColor: '0x4F4F4F'}
        ]
    };
    let tightsObject17 = {
            designs: [
                {sprite: tightsBase, zIndex: 4, defaultColor: '0x666666'},
                {sprite: tightsDesign17A, zIndex: 5, defaultColor: '0x666666'},
                {sprite: tightsDesign17B, zIndex: 5, defaultColor: '0xC8C7C7'}
            ]
        };
    let tightsObject18 = {
        designs: [
            {sprite: tightsBase, zIndex: 4, defaultColor: '0xEFEFEF'},
            {sprite: tightsDesign18, zIndex: 5, defaultColor: '0x777777'}
        ]
    };
    let tightsObject19 = {
        designs: [
            {sprite: tightsBase, zIndex: 4, defaultColor: '0x333333'},
            {sprite: tightsDesign19A, zIndex: 5, defaultColor: '0xD9C431'},
            {sprite: tightsDesign19B, zIndex: 5, defaultColor: '0x078DB5'}
        ]
    };
    let tightsObject20 = {
        designs: [
            {sprite: tightsBase, zIndex: 4, defaultColor: '0x333333'},
            {sprite: tightsDesign20A, zIndex: 5, defaultColor: '0xCECECE'},
            {sprite: tightsDesign20B, zIndex: 5, defaultColor: '0x6EA425'},
            {sprite: tightsDesign20C, zIndex: 5, defaultColor: '0x666666'}
        ]
    };
    let tightsObject21 = {
        designs: [
            {sprite: tightsBase, zIndex: 4, defaultColor: '0xA53131'},
            {sprite: tightsDesign21A, zIndex: 5, defaultColor: '0xE4D5BB'},
            {sprite: tightsDesign21B, zIndex: 5, defaultColor: '0xE4D5BB'},
            {sprite: tightsDesign21C, zIndex: 5, defaultColor: '0xE4D5BB'}
        ]
    };
    let tightsObject22 = {
        designs: [
            {sprite: tightsBase, zIndex: 4, defaultColor: '0x4C64E2'},
            {sprite: tightsDesign22, zIndex: 5, defaultColor: '0x212B5D'}
        ]
    };
    let tightsObject23 = {
            designs: [
                {sprite: tightsBase, zIndex: 4, defaultColor: '0x920909'},
                {sprite: tightsDesign23A, zIndex: 5, defaultColor: '0xE4E4E4'},
                {sprite: tightsDesign23B, zIndex: 5, defaultColor: '0xE4E4E4'}
            ]
        };
    let tightsObject24 = {
        designs: [
            {sprite: tightsDesign24A, zIndex: 4, defaultColor: '0x515937'},
            {sprite: tightsDesign24B, zIndex: 4, defaultColor: '0x94916C'},
            {sprite: tightsDesign24C, zIndex: 4, defaultColor: '0x63391E'}
        ]
    };
    let tightsObject25 = {
        designs: [
            {sprite: tightsDesign25A, zIndex: 4, defaultColor: '0x7B29D9'},
            {sprite: tightsDesign25B, zIndex: 4, defaultColor: '0x438CD9'},
            {sprite: tightsDesign25C, zIndex: 4, defaultColor: '0x43C5D9'}
        ]
    };

    let hairObject1 = {
        designs: [
            {sprite: hairDesign1, zIndex: 25, defaultColor: '0x71645F'}
        ]
    };
    let hairObject2 = {
        designs: [
            {sprite: hairDesign2, zIndex: 25, defaultColor: '0x71645F'}
        ]
    };
    let hairObject3 = {
        designs: [
            {sprite: hairDesign3, zIndex: 25, defaultColor: '0x71645F'}
        ]
    };
    let hairObject4 = {
        designs: [
            {sprite: hairDesign4, zIndex: 25, defaultColor: '0x71645F'},
            {sprite: hairDesign4Streak, zIndex: 25, defaultColor: '0xFFF1B8'}
        ]
    };
    let hairObject5 = {
        designs: [
            {sprite: hairDesign5A, zIndex: 25, defaultColor: '0x71645F'},
            {sprite: hairDesign5B, zIndex: 25, defaultColor: '0x71645F'}
        ]
    };
    let hairObject6 = {
        designs: [
            {sprite: hairDesign6A, zIndex: 25, defaultColor: '0x3C3C3C'},
            {sprite: hairDesign6B, zIndex: 25, defaultColor: '0x71645F'}
        ]
    };
    let hairObject7 = {
        designs: [
            {sprite: hairDesign7A, zIndex: 25, defaultColor: '0x3C3C3C'},
            {sprite: hairDesign7B, zIndex: 25, defaultColor: '0x71645F'}
        ]
    };
    let hairObject8 = {
        designs: [
            {sprite: hairDesign8, zIndex: 25, defaultColor: '0x71645F'}
        ]
    };
    let hairObject9 = {
        designs: [
            {sprite: hairDesign9, zIndex: 25, defaultColor: '0x71645F'}
        ]
    };
    let hairObject10 = {
        designs: [
            {sprite: hairDesign10, zIndex: 25, defaultColor: '0x71645F'},
            {sprite: hairDesign10Streak, zIndex: 25, defaultColor: '0xFFF1B8'}
        ]
    };
    let hairObject11 = {
        designs: [
            {sprite: hairDesign11, zIndex: 25, defaultColor: '0x71645F'}
        ]
    };
    let hairObject12 = {
        designs: [
            {sprite: hairDesign12, zIndex: 25, defaultColor: '0x71645F'},
            {sprite: hairDesign12Streak, zIndex: 25, defaultColor: '0xFFF1B8'}
        ]
    };
    let hairObject13 = {
        designs: [
            {sprite: hairDesign13, zIndex: 25, defaultColor: '0x71645F'}
        ]
    };
    let hairObject14 = {
        designs: [
            {sprite: hairDesign14, zIndex: 25, defaultColor: '0x71645F'}
        ]
    };
    let hairObject15 = {
        designs: [
            {sprite: hairDesign15, zIndex: 25, defaultColor: '0x71645F'}
        ]
    };
    let hairObject16 = {
        designs: [
            {sprite: hairDesign16, zIndex: 25, defaultColor: '0x71645F'}
        ]
    };
    let hairObject17 = {
        designs: [
            {sprite: hairDesign17, zIndex: 25, defaultColor: '0x71645F'}
        ]
    };
    let hairObject18 = {
        designs: [
            {sprite: hairDesign18, zIndex: 25, defaultColor: '0x71645F'},
            {sprite: hairDesign18Streak, zIndex: 25, defaultColor: '0xFFF1B8'}
        ]
    };
    let hairObject19 = {
        designs: [
            {sprite: hairDesign19, zIndex: 25, defaultColor: '0x71645F'}
        ]
    };
    let hairObject20 = {
        designs: [
            {sprite: hairDesign20A, zIndex: 25, defaultColor: '0x71645F'},
            {sprite: hairDesign20B, zIndex: 25, defaultColor: '0x71645F'}
        ]
    };
    let hairObject21 = {
        designs: [
            {sprite: hairDesign21, zIndex: 25, defaultColor: '0x71645F'}
        ]
    };
    let hairObject22 = {
        designs: [
            {sprite: hairDesign22, zIndex: 25, defaultColor: '0x71645F'}
        ]
    };
    let hairObject23 = {
        designs: [
            {sprite: hairDesign23, zIndex: 25, defaultColor: '0x71645F'},
            {sprite: hairDesign23Streak, zIndex: 25, defaultColor: '0xFFF1B8'}
        ]
    };
    let hairObject24 = {
        designs: [
            {sprite: hairDesign24A, zIndex: 25, defaultColor: '0x3C3C3C'},
            {sprite: hairDesign24B, zIndex: 25, defaultColor: '0x71645F'}
        ]
    };
    let hairObject25 = {
        designs: [
            {sprite: hairDesign25, zIndex: 25, defaultColor: '0x71645F'}
        ]
    };
    let hairObject26 = {
        designs: [
            {sprite: hairDesign26, zIndex: 25, defaultColor: '0x71645F'}
        ]
    };
    let hairObject27 = {
        designs: [
            {sprite: hairDesign27, zIndex: 25, defaultColor: '0x71645F'},
            {sprite: hairDesign27Streak, zIndex: 25, defaultColor: '0xFFF1B8'}
        ]
    };
    let hairObject28 = {
        designs: [
            {sprite: hairDesign28, zIndex: 25, defaultColor: '0x71645F'}
        ]
    };
    let hairObject29 = {
        designs: [
            {sprite: hairDesign29, zIndex: 25, defaultColor: '0x71645F'},
            {sprite: hairDesign29Streak, zIndex: 25, defaultColor: '0xFFF1B8'}
        ]
    };
    let hairObject30 = {
        designs: [
            {sprite: hairDesign30, zIndex: 25, defaultColor: '0x71645F'}
        ]
    };
    let hairObject31 = {
        designs: [
            {sprite: hairDesign31, zIndex: 25, defaultColor: '0x71645F'},
            {sprite: hairDesign31Streak, zIndex: 25, defaultColor: '0xFFF1B8'}
        ]
    };
    let hairObject32 = {
        designs: [
            {sprite: hairDesign32, zIndex: 25, defaultColor: '0x71645F'}
        ]
    };
    let hairObject33 = {
        designs: [
            {sprite: hairDesign33, zIndex: 25, defaultColor: '0x71645F'}
        ]
    };
    let hairObject34 = {
        designs: [
            {sprite: hairDesign34, zIndex: 25, defaultColor: '0x71645F'},
            {sprite: hairDesign34Streak, zIndex: 25, defaultColor: '0xFFF1B8'}
        ]
    };
    let hairObject35 = {
        designs: [
            {sprite: hairDesign35, zIndex: 25, defaultColor: '0x71645F'}
        ]
    };
    let hairObject36 = {
        designs: [
            {sprite: hairDesign36A, zIndex: 25, defaultColor: '0x71645F'},
            {sprite: hairDesign36B, zIndex: 25, defaultColor: '0x88766E'}
        ]
    };

    let shoesObject0 = {
        designs: [
            {sprite: shoesDesign2, zIndex: 10, defaultColor: '0x1B1B1B'}
        ]
    };
    let shoesObject1 = {
        designs: [
            {sprite: shoesDesign1, zIndex: 10, defaultColor: '0xeea744'},
            {sprite: shoesDesign1A, zIndex: 11, defaultColor: '0x242424'}
        ]
    };
    let shoesObject2 = {
        designs: [
            {sprite: shoesDesign2, zIndex: 10, defaultColor: '0x65A1DD'},
            {sprite: shoesDesign2A, zIndex: 11, defaultColor: '0xFFFFFF'},
            {sprite: shoesDesign2B, zIndex: 12, defaultColor: '0xCA4545'}
        ]
    };
    let shoesObject3 = {
        designs: [
            {sprite: shoesDesign3, zIndex: 10, defaultColor: '0xFFFFFF'},
            {sprite: shoesDesign3A, zIndex: 11, defaultColor: '0x77C1C0'}
        ]
    };
    let shoesObject4 = {
        designs: [
            {sprite: shoesDesign4, zIndex: 10, defaultColor: '0x4C4C4C'},
            {sprite: shoesDesign4A, zIndex: 11, defaultColor: '0x4E9755'}
        ]
    };
    let shoesObject5 = {
        designs: [
            {sprite: shoesDesign5, zIndex: 10, defaultColor: '0x7DC1DA'},
            {sprite: shoesDesign5A, zIndex: 11, defaultColor: '0x564695'}
        ]
    };
    let shoesObject6 = {
        designs: [
            {sprite: shoesDesign6, zIndex: 10, defaultColor: '0x3B3B3B'},
            {sprite: shoesDesign6A, zIndex: 11, defaultColor: '0x606060'}
        ]
    };
    let shoesObject7 = {
        designs: [
            {sprite: shoesDesign7, zIndex: 10, defaultColor: '0x3B3B3B'},
            {sprite: shoesDesign7A, zIndex: 11, defaultColor: '0x525252'}
        ]
    };
    let shoesObject8 = {
        designs: [
            {sprite: shoesDesign8, zIndex: 10, defaultColor: '0x313131'},
            {sprite: shoesDesign8A, zIndex: 11, defaultColor: '0xADADAD'}
        ]
    };
    let shoesObject9 = {
        designs: [
            {sprite: shoesDesign9, zIndex: 10, defaultColor: '0x4B4B4B'},
            {sprite: shoesDesign9A, zIndex: 11, defaultColor: '0xD35B5B'}
        ]
    };
    let shoesObject10 = {
        designs: [
            {sprite: shoesDesign10, zIndex: 10, defaultColor: '0x5A9DE2'},
            {sprite: shoesDesign10A, zIndex: 11, defaultColor: '0xFFFFFF'}
        ]
    };
    let shoesObject11 = {
        designs: [
            {sprite: shoesDesign11, zIndex: 10, defaultColor: '0xF3F3F3'},
            {sprite: shoesDesign11A, zIndex: 11, defaultColor: '0x81BE86'}
        ]
    };
    let shoesObject12 = {
        designs: [
            {sprite: shoesDesign12, zIndex: 10, defaultColor: '0xFFFFFF'},
            {sprite: shoesDesign12A, zIndex: 11, defaultColor: '0xDFAC21'},
            {sprite: shoesDesign12B, zIndex: 12, defaultColor: '0x3D3D3D'}
        ]
    };
    let shoesObject13 = {
        designs: [
            {sprite: shoesDesign13, zIndex: 10, defaultColor: '0x181818'},
            {sprite: shoesDesign13A, zIndex: 11, defaultColor: '0x2D862A'}
        ]
    };
    let shoesObject14 = {
        designs: [
            {sprite: shoesDesign7, zIndex: 10, defaultColor: '0x323232'},
            {sprite: shoesDesign14A, zIndex: 11, defaultColor: '0x1D1D1D'}
        ]
    };
    let shoesObject15 = {
        designs: [
            {sprite: shoesDesign7, zIndex: 10, defaultColor: '0xE6B059'},
            {sprite: shoesDesign15A, zIndex: 11, defaultColor: '0x6AABBA'}
        ]
    };
    let shoesObject16 = {
        designs: [
            {sprite: shoesDesign16, zIndex: 10, defaultColor: '0xD4A0E9'},
            {sprite: shoesDesign16A, zIndex: 11, defaultColor: '0xE8AAE7'}
        ]
    };
    let shoesObject17 = {
        designs: [
            {sprite: shoesDesign17, zIndex: 10, defaultColor: '0xF2F2F2'},
            {sprite: shoesDesign17A, zIndex: 11, defaultColor: '0x65C8A9'}
        ]
    };
    let shoesObject18 = {
        designs: [
            {sprite: shoesDesign18, zIndex: 10, defaultColor: '0x272727'},
            {sprite: shoesDesign18A, zIndex: 11, defaultColor: '0x6C94D0'}
        ]
    };
    let shoesObject19 = {
        designs: [
            {sprite: shoesDesign7, zIndex: 10, defaultColor: '0xCCCCCC'},
            {sprite: shoesDesign19A, zIndex: 11, defaultColor: '0x8B80ED'}
        ]
    };
    let shoesObject20 = {
        designs: [
            {sprite: shoesDesign7, zIndex: 10, defaultColor: '0xAF9F8F'},
            {sprite: shoesDesign20A, zIndex: 11, defaultColor: '0x63574C'}
        ]
    };

    let topObject1 = {
        designs: [
            {sprite: topDesign1, zIndex: 7, defaultColor: '0xB7B7B7'},
            {sprite: topDesign1A, zIndex: 8, defaultColor: '0xE3E3E3'}
        ]
    };
    let topObject2 = {
        designs: [
            {sprite: topDesign2, zIndex: 7, defaultColor: '0x484848'},
            {sprite: topDesign2A, zIndex: 8, defaultColor: '0x232323'}
        ]
    };
    let topObject3 = {
        designs: [
            {sprite: topDesign3, zIndex: 7, defaultColor: '0xCD4444'}
        ]
    };
    let topObject4 = {
        designs: [
            {sprite: topDesign4, zIndex: 7, defaultColor: '0x2D2D2D'},
            {sprite: topDesign4A, zIndex: 8, defaultColor: '0x6EAC6C'}
        ]
    };
    let topObject5 = {
        designs: [
            {sprite: topDesign5, zIndex: 7, defaultColor: '0xB85F5F'},
            {sprite: topDesign5A, zIndex: 8, defaultColor: '0x515151'}
        ]
    };
    let topObject6 = {
        designs: [
            {sprite: topDesign6, zIndex: 7, defaultColor: '0xD3BB6E'},
            {sprite: topDesign6A, zIndex: 8, defaultColor: '0xC45265'},
            {sprite: topDesign6B, zIndex: 8, defaultColor: '0x526FC4'}
        ]
    };
    let topObject7 = {
        designs: [
            {sprite: topDesign7, zIndex: 7, defaultColor: '0xE6D644'}
        ]
    };
    let topObject8 = {
        designs: [
            {sprite: topDesign8, zIndex: 18, defaultColor: '0x595E7C'}
        ]
    };
    let topObject9 = {
        designs: [
            {sprite: topDesign9, zIndex: 7, defaultColor: '0x857362'}
        ]
    };
    let topObject10 = {
        designs: [
            {sprite: topDesign10, zIndex: 7, defaultColor: '0x699B69'}
        ]
    };
    let topObject11 = {
        designs: [
            {sprite: topDesign11, zIndex: 7, defaultColor: '0x6198C2'}
        ]
    };
    let topObject12 = {
        designs: [
            {sprite: topDesign12, zIndex: 18, defaultColor: '0x5D5D5D'},
            {sprite: topDesign12A, zIndex: 19, defaultColor: '0xBDBDBD'}
        ]
    };
    let topObject13 = {
        designs: [
            {sprite: topDesign11, zIndex: 7, defaultColor: '0xDBAD58'},
            {sprite: topDesign13A, zIndex: 8, defaultColor: '0x6CB4C1'}
        ]
    };
    let topObject14 = {
        designs: [
            {sprite: topDesign14, zIndex: 18, defaultColor: '0xDBC952'}
        ]
    };
    let topObject15 = {
        designs: [
            {sprite: topDesign15, zIndex: 7, defaultColor: '0x515151'},
            {sprite: topDesign15A, zIndex: 8, defaultColor: '0xFFFFFF'}
        ]
    };
    let topObject16 = {
        designs: [
            {sprite: topDesign16, zIndex: 7, defaultColor: '0x7FD1CA'},
            {sprite: topDesign16A, zIndex: 8, defaultColor: '0xF8F16F'},
            {sprite: topDesign16B, zIndex: 8, defaultColor: '0xDBDBDB'}
        ]
    };
    let topObject17 = {
        designs: [
            {sprite: topDesign17, zIndex: 18, defaultColor: '0xF9BFFE'}
        ]
    };
    let topObject18 = {
        designs: [
            {sprite: topDesign18, zIndex: 7, defaultColor: '0x7D93F2'},
            {sprite: topDesign18A, zIndex: 8, defaultColor: '0x8F70E0'}
        ]
    };
    let topObject19 = {
        designs: [
            {sprite: topDesign10, zIndex: 7, defaultColor: '0xD8905C'},
            {sprite: topDesign19A, zIndex: 8, defaultColor: '0x958377'}
        ]
    };
    let topObject20 = {
        designs: [
            {sprite: topDesign7, zIndex: 7, defaultColor: '0x373737'},
            {sprite: topDesign20A, zIndex: 8, defaultColor: '0xBC364C'}
        ]
    };
    let topObject21 = {
        designs: [
            {sprite: topDesign21, zIndex: 18, defaultColor: '0xDADADA'},
            {sprite: topDesign21A, zIndex: 19, defaultColor: '0x5159AD'}
        ]
    };
    let topObject22 = {
        designs: [
            {sprite: topDesign10, zIndex: 7, defaultColor: '0xEBDB55'},
            {sprite: topDesign22A, zIndex: 8, defaultColor: '0x65C474'}
        ]
    };
    let topObject23 = {
        designs: [
            {sprite: topDesign3, zIndex: 7, defaultColor: '0x9FCEF5'},
            {sprite: topDesign23A, zIndex: 8, defaultColor: '0x6899C1'}
        ]
    };
    let topObject24 = {
        designs: [
            {sprite: topDesign9, zIndex: 7, defaultColor: '0x363636'},
            {sprite: topDesign24A, zIndex: 8, defaultColor: '0xE1BE1A'}
        ]
    };
    let topObject25 = {
        designs: [
            {sprite: topDesign7, zIndex: 7, defaultColor: '0x5D5D5D'},
            {sprite: topDesign25A, zIndex: 8, defaultColor: '0xDB8A49'}
        ]
    };
    let topObject26 = {
        designs: [
            {sprite: topDesign9, zIndex: 7, defaultColor: '0x85755E'},
            {sprite: topDesign26A, zIndex: 8, defaultColor: '0x5E5446'}
        ]
    };
    let topObject27 = {
        designs: [
            {sprite: topDesign11, zIndex: 7, defaultColor: '0x7B985D'},
            {sprite: topDesign27A, zIndex: 8, defaultColor: '0xD2FFA3'}
        ]
    };
    let topObject28 = {
        designs: [
            {sprite: topDesign3, zIndex: 7, defaultColor: '0x3B3B3B'},
            {sprite: topDesign28A, zIndex: 8, defaultColor: '0xFEC7FF'}
        ]
    };
    let topObject29 = {
        designs: [
            {sprite: topDesign29, zIndex: 7, defaultColor: '0x6FB0E7'},
            {sprite: topDesign29A, zIndex: 8, defaultColor: '0xE75B5B'}
        ]
    };
    let topObject30 = {
        designs: [
            {sprite: topDesign7, zIndex: 7, defaultColor: '0xEBEBEB'},
            {sprite: topDesign30A, zIndex: 8, defaultColor: '0x785CAA'}
        ]
    };
    let topObject31 = {
        designs: [
            {sprite: topDesign31, zIndex: 7, defaultColor: '0x323232'},
            {sprite: topDesign31A, zIndex: 8, defaultColor: '0xDBDBDB'},
            {sprite: topDesign31B, zIndex: 8, defaultColor: '0x626262'}
        ]
    };
    let topObject32 = {
        designs: [
            {sprite: topDesign11, zIndex: 7, defaultColor: '0x358B7C'},
            {sprite: topDesign32A, zIndex: 8, defaultColor: '0x6ACFE7'}
        ]
    };
    let topObject33 = {
        designs: [
            {sprite: topDesign33, zIndex: 7, defaultColor: '0xD18E57'},
            {sprite: topDesign33A, zIndex: 8, defaultColor: '0xD8D8D8'}
        ]
    };
    let topObject34 = {
        designs: [
            {sprite: topDesign33, zIndex: 7, defaultColor: '0x282828'},
            {sprite: topDesign34A, zIndex: 8, defaultColor: '0xC54F4F'}
        ]
    };
    let topObject35 = {
        designs: [
            {sprite: topDesign33, zIndex: 7, defaultColor: '0x457AA2'},
            {sprite: topDesign35A, zIndex: 8, defaultColor: '0x77A3A5'}
        ]
    };
    let topObject36 = {
        designs: [
            {sprite: topDesign36, zIndex: 7, defaultColor: '0xFB9A9A'}
        ]
    };
    let topObject37 = {
        designs: [
            {sprite: topDesign37A, zIndex: 7, defaultColor: '0x7C7C7C'},
            {sprite: topDesign37B, zIndex: 8, defaultColor: '0x3D3E45'},
            {sprite: topDesign37C, zIndex: 9, defaultColor: '0xA0A5B7'}
        ]
    };
    let topObject38 = {
        designs: [
            {sprite: topDesign38, zIndex: 7, defaultColor: '0xFFFFFF'}
        ]
    };
    let topObject39 = {
        designs: [
            {sprite: topDesign39, zIndex: 7, defaultColor: '0xFFFFFF'}
        ]
    };
    let topObject40 = {
        designs: [
            {sprite: topDesign40A, zIndex: 7, defaultColor: '0x842727'},
            {sprite: topDesign40B, zIndex: 8, defaultColor: '0x2D2A2A'}
        ]
    };
    let topObject41 = {
        designs: [
            {sprite: topDesign1, zIndex: 7, defaultColor: '0x333333'},
            {sprite: topDesign41A, zIndex: 8, defaultColor: '0xFFFFFF'},
            {sprite: topDesign41B, zIndex: 8, defaultColor: '0xD24143'}
        ]
    };
    let topObject42 = {
        designs: [
            {sprite: topDesign1, zIndex: 7, defaultColor: '0x333333'},
            {sprite: topDesign42, zIndex: 8, defaultColor: '0xFFFFFF'}
        ]
    };
    let topObject43 = {
        designs: [
            {sprite: topDesign1, zIndex: 7, defaultColor: '0x921B14'},
            {sprite: topDesign43, zIndex: 8, defaultColor: '0xBAE37E'}
        ]
    };
    let topObject44 = {
        designs: [
            {sprite: topDesign1, zIndex: 7, defaultColor: '0x444444'}
        ]
    };
    let topObject45 = {
        designs: [
            {sprite: topDesign2, zIndex: 7, defaultColor: '0xCECECE'}
        ]
    };
    let topObject46 = {
        designs: [
            {sprite: topDesign44, zIndex: 7, defaultColor: '0xa36840'}
        ]
    };
    let topObject47 = {
        designs: [
            {sprite: topDesign45A, zIndex: 7, defaultColor: '0xA4B9D9'},
            {sprite: topDesign45B, zIndex: 8, defaultColor: '0xFFFFFF'}
        ]
    };
    let topObject48 = {
        designs: [
            {sprite: topDesign46, zIndex: 7, defaultColor: '0xF2F2F2'}
        ]
    };
    let topObject49 = {
        designs: [
            {sprite: topDesign47A, zIndex: 7, defaultColor: '0x595757'},
            {sprite: topDesign47B, zIndex: 8, defaultColor: '0x434343'}
        ]
    };
    let topObject50 = {
        designs: [
            {sprite: topDesign1, zIndex: 7, defaultColor: '0x333333'},
            {sprite: topDesign48A, zIndex: 8, defaultColor: '0xFFFFFF'},
            {sprite: topDesign48B, zIndex: 8, defaultColor: '0xFF0100'}
        ]
    };
    let topObject51 = {
        designs: [
            {sprite: topDesign49A, zIndex: 7, defaultColor: '0x2D2D2D'},
            {sprite: topDesign49B, zIndex: 8, defaultColor: '0xF0F0F0'}
        ]
    };
    let topObject52 = {
        designs: [
            {sprite: topDesign50A, zIndex: 7, defaultColor: '0x8CBFDA'},
            {sprite: topDesign50B, zIndex: 8, defaultColor: '0xC7565C'},
            {sprite: topDesign50C, zIndex: 8, defaultColor: '0x6C8B3F'},
            {sprite: topDesign50D, zIndex: 8, defaultColor: '0xD2CE9C'}
        ]
    };
    let topObject53 = {
        designs: [
            {sprite: topDesign1, zIndex: 7, defaultColor: '0x333333'},
            {sprite: topDesign51, zIndex: 8, defaultColor: '0xD8D8D8'}
        ]
    };
    let topObject54 = {
        designs: [
            {sprite: topDesign1, zIndex: 7, defaultColor: '0x333333'},
            {sprite: topDesign52, zIndex: 8, defaultColor: '0xD8D8D8'}
        ]
    };

    let elbowObject1 = {
        designs: [
            {sprite: elbowDesign1, zIndex: 10, defaultColor: '0x1B1B1B'}
        ]
    };
    let elbowObject2 = {
        designs: [
            {sprite: elbowDesign2, zIndex: 10, defaultColor: '0x1B1B1B'}
        ]
    };
    let elbowObject3 = {
        designs: [
            {sprite: elbowDesign3, zIndex: 10, defaultColor: '0x1B1B1B'}
        ]
    };
    let elbowObject4 = {
        designs: [
            {sprite: elbowDesign4, zIndex: 10, defaultColor: '0x1B1B1B'}
        ]
    };
    let elbowObject5 = {
        designs: [
            {sprite: elbowDesign5, zIndex: 10, defaultColor: '0x1B1B1B'}
        ]
    };
    let elbowObject6 = {
        designs: [
            {sprite: elbowDesign6, zIndex: 10, defaultColor: '0x1B1B1B'}
        ]
    };
    let elbowObject7 = {
        designs: [
            {sprite: elbowDesign7, zIndex: 10, defaultColor: '0x1B1B1B'},
            {sprite: elbowDesign7A, zIndex: 10, defaultColor: '0x363636'}
        ]
    };
    let elbowObject8 = {
        designs: [
            {sprite: elbowDesign8, zIndex: 10, defaultColor: '0x1B1B1B'}
        ]
    };
    let elbowObject9 = {
        designs: [
            {sprite: elbowDesign9, zIndex: 10, defaultColor: '0x1B1B1B'}
        ]
    };
    let elbowObject10 = {
        designs: [
            {sprite: elbowDesign10, zIndex: 10, defaultColor: '0x1B1B1B'}
        ]
    };

    let facialHairObject1 = {
        designs: [
            {sprite: facialHairDesign1, zIndex: 24, defaultColor: '0x635955'}
        ]
    };
    let facialHairObject2 = {
        designs: [
            {sprite: facialHairDesign2, zIndex: 24, defaultColor: '0x635955'}
        ]
    };
    let facialHairObject3 = {
        designs: [
            {sprite: facialHairDesign3, zIndex: 24, defaultColor: '0x635955'}
        ]
    };
    let facialHairObject4 = {
        designs: [
            {sprite: facialHairDesign4, zIndex: 24, defaultColor: '0x635955'}
        ]
    };
    let facialHairObject5 = {
        designs: [
            {sprite: facialHairDesign5, zIndex: 24, defaultColor: '0x635955'}
        ]
    };
    let facialHairObject6 = {
        designs: [
            {sprite: facialHairDesign6, zIndex: 24, defaultColor: '0x635955'}
        ]
    };
    let facialHairObject7 = {
        designs: [
            {sprite: facialHairDesign7, zIndex: 24, defaultColor: '0x635955'}
        ]
    };
    let facialHairObject8 = {
        designs: [
            {sprite: facialHairDesign8, zIndex: 24, defaultColor: '0x635955'}
        ]
    };
    let facialHairObject9 = {
        designs: [
            {sprite: facialHairDesign9, zIndex: 24, defaultColor: '0x635955'}
        ]
    };
    let facialHairObject10 = {
        designs: [
            {sprite: facialHairDesign10, zIndex: 24, defaultColor: '0x635955'}
        ]
    };
    let facialHairObject11 = {
        designs: [
            {sprite: facialHairDesign11, zIndex: 25, defaultColor: '0x635955'}
        ]
    };
    let facialHairObject12 = {
        designs: [
            {sprite: facialHairDesign12, zIndex: 24, defaultColor: '0x635955'}
        ]
    };
    let facialHairObject13 = {
        designs: [
            {sprite: facialHairDesign13, zIndex: 24, defaultColor: '0x635955'}
        ]
    };
    let facialHairObject14 = {
        designs: [
            {sprite: facialHairDesign14, zIndex: 24, defaultColor: '0x635955'}
        ]
    };
    let facialHairObject15 = {
        designs: [
            {sprite: facialHairDesign15, zIndex: 24, defaultColor: '0x635955'}
        ]
    };
    let facialHairObject16 = {
        designs: [
            {sprite: facialHairDesign16, zIndex: 24, defaultColor: '0x635955'}
        ]
    };
    let facialHairObject17 = {
        designs: [
            {sprite: facialHairDesign17, zIndex: 24, defaultColor: '0x635955'}
        ]
    };
    let facialHairObject18 = {
        designs: [
            {sprite: facialHairDesign18, zIndex: 24, defaultColor: '0x635955'}
        ]
    };
    let facialHairObject19 = {
        designs: [
            {sprite: facialHairDesign19, zIndex: 11, defaultColor: '0x635955'}
        ]
    };
    let facialHairObject20 = {
        designs: [
            {sprite: facialHairDesign20, zIndex: 11, defaultColor: '0x635955'}
        ]
    };

    let accessoryObject1 = {
        designs: [
            {sprite: accessoryDesign1A, zIndex: -2, defaultColor: '0x9C2525'},
            {sprite: accessoryDesign1B, zIndex: 20, defaultColor: '0x9C2525'},
            {sprite: accessoryDesign1C, zIndex: 21, defaultColor: '0x404040'}
        ]
    };
    let accessoryObject2 = {
        designs: [
            {sprite: accessoryDesign2A, zIndex: -2, defaultColor: '0x3F6840'},
            {sprite: accessoryDesign2B, zIndex: 20, defaultColor: '0x3F6840'}
        ]
    };
    let accessoryObject3 = {
        designs: [
            {sprite: accessoryDesign3A, zIndex: -2, defaultColor: '0x947FD3'},
            {sprite: accessoryDesign3B, zIndex: -2, defaultColor: '0xE2E2E2'},
            {sprite: accessoryDesign3C, zIndex: 20, defaultColor: '0x947FD3'},
            {sprite: accessoryDesign3D, zIndex: 21, defaultColor: '0xE2E2E2'}
        ]
    };
    let accessoryObject4 = {
        designs: [
            {sprite: accessoryDesign4, zIndex: 2, defaultColor: '0xffff00'}
        ]
    };
    let accessoryObject5 = {
        designs: [
            {sprite: accessoryDesign5, zIndex: 2, defaultColor: '0xffff00'},
            {sprite: accessoryDesign5A, zIndex: 3, defaultColor: '0x6768CE'}
        ]
    };
    let accessoryObject6 = {
        designs: [
            {sprite: accessoryDesign6, zIndex: 26, defaultColor: '0xE4E3B7'}
        ]
    };
    let accessoryObject7 = {
        designs: [
            {sprite: accessoryDesign7, zIndex: 20, defaultColor: '0xC6364E'},
            {sprite: accessoryDesign7A, zIndex: 21, defaultColor: '0xEFD73C'}
        ]
    };
    let accessoryObject8 = {
        designs: [
            {sprite: accessoryDesign8, zIndex: 20, defaultColor: '0x4883C2'},
            {sprite: accessoryDesign8A, zIndex: 21, defaultColor: '0xD64E44'},
            {sprite: accessoryDesign8B, zIndex: 21, defaultColor: '0x46C44A'}
        ]
    };
    let accessoryObject9 = {
        designs: [
            {sprite: accessoryDesign9, zIndex: 26, defaultColor: '0x202020'}
        ]
    };
    let accessoryObject10 = {
        designs: [
            {sprite: accessoryDesign10, zIndex: 20, defaultColor: '0x2D2D2D'}
        ]
    };
    let accessoryObject11 = {
        designs: [
            {sprite: accessoryDesign11, zIndex: 2, defaultColor: '0xF4F4F4'}
        ]
    };
    let accessoryObject12 = {
        designs: [
            {sprite: accessoryDesign11, zIndex: 2, defaultColor: '0x6CA3D9'},
            {sprite: accessoryDesign11A, zIndex: 3, defaultColor: '0xCE8A4A'}
        ]
    };
    let accessoryObject13 = {
        designs: [
            {sprite: accessoryDesign11, zIndex: 2, defaultColor: '0xEBEBEB'},
            {sprite: accessoryDesign12A, zIndex: 3, defaultColor: '0x9C2525'}
        ]
    };
    let accessoryObject14 = {
        designs: [
            {sprite: accessoryDesign13, zIndex: 22, defaultColor: '0xFFFFFF'}
        ]
    };
    let accessoryObject15 = {
        designs: [
            {sprite: accessoryDesign14A, zIndex: 2, defaultColor: '0x8C6137'},
            {sprite: accessoryDesign14B, zIndex: 3, defaultColor: '0x683605'}
        ]
    };
    let accessoryObject16 = {
        designs: [
            {sprite: accessoryDesign15, zIndex: 2, defaultColor: '0x8C8C8C'}
        ]
    };
    let accessoryObject17 = {
        designs: [
            {sprite: accessoryDesign16A, zIndex: 12, defaultColor: '0x693420'},
            {sprite: accessoryDesign16B, zIndex: 13, defaultColor: '0x59EBE6'}
        ]
    };
    let accessoryObject18 = {
        designs: [
            {sprite: accessoryDesign17, zIndex: 2, defaultColor: '0xFFFFFF'}
        ]
    };
    let accessoryObject19 = {
        designs: [
            {sprite: accessoryDesign18, zIndex: 26, defaultColor: '0xCC3636'}
        ]
    };
    let accessoryObject20 = {
        designs: [
            {sprite: accessoryDesign19, zIndex: 20, defaultColor: '0x5F5F5F'}
        ]
    };
    let accessoryObject21 = {
        designs: [
            {sprite: accessoryDesign20, zIndex: 20, defaultColor: '0xF3F3F3'}
        ]
    };
    let accessoryObject22 = {
        designs: [
            {sprite: accessoryDesign21A, zIndex: 26, defaultColor: '0x1F3E7F'},
            {sprite: accessoryDesign21B, zIndex: 26, defaultColor: '0xC15E34'}
        ]
    };
    let accessoryObject23 = {
        designs: [
            {sprite: accessoryDesign22A, zIndex: 26, defaultColor: '0xF1BF64'},
            {sprite: accessoryDesign22B, zIndex: 26, defaultColor: '0x598128'},
            {sprite: accessoryDesign22C, zIndex: 26, defaultColor: '0x555555'}
        ]
    };
    let accessoryObject24 = {
        designs: [
            {sprite: accessoryDesign23A, zIndex: 26, defaultColor: '0x3A3A3A'},
            {sprite: accessoryDesign23B, zIndex: 26, defaultColor: '0x535353'}
        ]
    };
    let accessoryObject25 = {
        designs: [
            {sprite: accessoryDesign24A, zIndex: 30, defaultColor: '0xFAEC90'},
            {sprite: accessoryDesign24B, zIndex: 30, defaultColor: '0xFFFFFF'}
        ]
    };
    let accessoryObject26 = {
        designs: [
            {sprite: accessoryDesign25A, zIndex: 26, defaultColor: '0x1F1F1F'},
            {sprite: accessoryDesign25B, zIndex: 26, defaultColor: '0xF0BC6E'}
        ]
    };
    let accessoryObject27 = {
        designs: [
            {sprite: accessoryDesign26A, zIndex: -2, defaultColor: '0xFFFFFF'},
            {sprite: accessoryDesign26B, zIndex: -2, defaultColor: '0xFFFFFF'}
        ]
    };
    let accessoryObject28 = {
        designs: [
            {sprite: accessoryDesign27A, zIndex: -2, defaultColor: '0xBF58C5'},
            {sprite: accessoryDesign27B, zIndex: -2, defaultColor: '0xF29541'}
        ]
    };
    let accessoryObject29 = {
        designs: [
            {sprite: accessoryDesign28A, zIndex: 30, defaultColor: '0x383838'}
        ]
    };
    let accessoryObject30 = {
        designs: [
            {sprite: accessoryDesign29A, zIndex: 30, defaultColor: '0xCCA670'},
            {sprite: accessoryDesign29B, zIndex: 30, defaultColor: '0x4D4D4D'}
        ]
    };
    let accessoryObject31 = {
        designs: [
            {sprite: accessoryDesign30A, zIndex: 30, defaultColor: '0xD9BA5B'},
            {sprite: accessoryDesign30B, zIndex: 30, defaultColor: '0xD2D2D2'}
        ]
    };
    let accessoryObject32 = {
        designs: [
            {sprite: accessoryDesign31A, zIndex: 30, defaultColor: '0xEAC123'},
            {sprite: accessoryDesign31B, zIndex: 30, defaultColor: '0xDF3030'}
        ]
    };

    // Base face mask
    let accessoryObject33 = {
        designs: [
            {sprite: accessoryDesign32Base, zIndex: 30, defaultColor: '0x333333'}
        ]
    };

    // Styled face masks
    let accessoryObject34 = {
        designs: [
            {sprite: accessoryDesign32Base, zIndex: 30, defaultColor: '0x333333'},
            {sprite: accessoryDesign32A, zIndex: 30, defaultColor: '0xFFFFFF'}
        ]
    };
    let accessoryObject35 = {
        designs: [
            {sprite: accessoryDesign32Base, zIndex: 30, defaultColor: '0x4E4E4E'},
            {sprite: accessoryDesign32B, zIndex: 31, defaultColor: '0xFFFFFF'}
        ]
    };
    let accessoryObject36 = {
        designs: [
            {sprite: accessoryDesign32Base, zIndex: 30, defaultColor: '0x5F5F5F'},
            {sprite: accessoryDesign32C, zIndex: 31, defaultColor: '0xC9AF2E'}
        ]
    };
    let accessoryObject37 = {
        designs: [
            {sprite: accessoryDesign33A, zIndex: 30, defaultColor: '0xDF0000'},
            {sprite: accessoryDesign33B, zIndex: 31, defaultColor: '0xF0F0F0'}
        ]
    };
    let accessoryObject38 = {
        designs: [
            {sprite: accessoryDesign34A, zIndex: 20, defaultColor: '0x3A3A3A'},
            {sprite: accessoryDesign34B, zIndex: -2, defaultColor: '0x3A3A3A'},
            {sprite: accessoryDesign34C, zIndex: 21, defaultColor: '0x949494'}
        ]
    };
    let accessoryObject39 = {
        designs: [
            {sprite: accessoryDesign35A, zIndex: 20, defaultColor: '0x434343'},
            {sprite: accessoryDesign35B, zIndex: 20, defaultColor: '0xD8D8D8'},
            {sprite: accessoryDesign35C, zIndex: 21, defaultColor: '0xF8F8F8'}
        ]
    };
    let accessoryObject40 = {
        designs: [
            {sprite: accessoryDesign36A, zIndex: 26, defaultColor: '0xCBD7DA'},
            {sprite: accessoryDesign36B, zIndex: 26, defaultColor: '0x9B845D'},
            {sprite: accessoryDesign36C, zIndex: 27, defaultColor: '0xE9E2D4'}
        ]
    };
    let accessoryObject41 = {
        designs: [
            {sprite: accessoryDesign37A, zIndex: 30, defaultColor: '0xCCCCCC'},
            {sprite: accessoryDesign37B, zIndex: 31, defaultColor: '0x969696'},
            {sprite: accessoryDesign37C, zIndex: 31, defaultColor: '0xE5564D'}
        ]
    };
    let accessoryObject42 = {
        designs: [
            {sprite: accessoryDesign38A, zIndex: 9, defaultColor: '0x616060'},
            {sprite: accessoryDesign38B, zIndex: 10, defaultColor: '0x616060'},
            {sprite: accessoryDesign38C, zIndex: 10, defaultColor: '0xA1A1A1'}
        ]
    };
    let accessoryObject43 = {
        designs: [
            {sprite: accessoryDesign39A, zIndex: 32, defaultColor: '0xD60C08'},
            {sprite: accessoryDesign39B, zIndex: 30, defaultColor: '0x262626'},
            {sprite: accessoryDesign39C, zIndex: 31, defaultColor: '0xD6E3DF'},
            {sprite: accessoryDesign39D, zIndex: 33, defaultColor: '0xFDEF50'}
        ]
    };
    let accessoryObject44 = {
        designs: [
            {sprite: accessoryDesign40A, zIndex: 30, defaultColor: '0xEDE4D9'},
            {sprite: accessoryDesign40B, zIndex: 31, defaultColor: '0x292929'},
            {sprite: accessoryDesign40C, zIndex: 31, defaultColor: '0xB0000F'}
        ]
    };
    let accessoryObject45 = {
        designs: [
            {sprite: accessoryDesign41A, zIndex: 30, defaultColor: '0xD1D1D1'},
            {sprite: accessoryDesign41B, zIndex: 31, defaultColor: '0xD1B78A'}
        ]
    };
    let accessoryObject46 = {
        designs: [
            {sprite: accessoryDesign42A, zIndex: 26, defaultColor: '0xE4E4E4'},
            {sprite: accessoryDesign42B, zIndex: 27, defaultColor: '0xEE5F74'},
            {sprite: accessoryDesign42C, zIndex: 28, defaultColor: '0xD47281'}
        ]
    };
    let accessoryObject47 = {
        designs: [
            {sprite: accessoryDesign43A, zIndex: 30, defaultColor: '0xE0E0E0'},
            {sprite: accessoryDesign43B, zIndex: 31, defaultColor: '0x8D8D8D'},
        ]
    };
    let accessoryObject48 = {
        designs: [
            {sprite: accessoryDesign44A, zIndex: 30, defaultColor: '0x535353'},
            {sprite: accessoryDesign44B, zIndex: 31, defaultColor: '0x535353'},
        ]
    };
    let accessoryObject49 = {
        designs: [
            {sprite: accessoryDesign45A, zIndex: 30, defaultColor: '0xC8A979'}
        ]
    };
    let accessoryObject50 = {
        designs: [
            {sprite: accessoryDesign46A, zIndex: 30, defaultColor: '0xE8E8E8'},
            {sprite: accessoryDesign46B, zIndex: 30, defaultColor: '0xCC3C3C'}
        ]
    };
    let accessoryObject51 = {
        designs: [
            {sprite: accessoryDesign47A, zIndex: 30, defaultColor: '0xBF0000'}
        ]
    };
    let accessoryObject52 = {
        designs: [
            {sprite: accessoryDesign48A, zIndex: 31, defaultColor: '0x0D0D0D'},
            {sprite: accessoryDesign48B, zIndex: 31, defaultColor: '0x0D0D0D'},
            {sprite: accessoryDesign48C, zIndex: 30, defaultColor: '0xA6A6A6'}
        ]
    };
    let accessoryObject53 = {
        designs: [
            {sprite: accessoryDesign49A, zIndex: 30, defaultColor: '0xFADA9E'},
            {sprite: accessoryDesign49B, zIndex: 30, defaultColor: '0x755B3D'},
            {sprite: accessoryDesign49C, zIndex: 30, defaultColor: '0x423A30'},
            {sprite: accessoryDesign49D, zIndex: 30, defaultColor: '0xFFFFFF'}
        ]
    };
    let accessoryObject54 = {
        designs: [
            {sprite: accessoryDesign50A, zIndex: 30, defaultColor: '0xEEEEEE'},
            {sprite: accessoryDesign50B, zIndex: 31, defaultColor: '0xCD2323'},
            {sprite: accessoryDesign50C, zIndex: 31, defaultColor: '0xD91414'},
            {sprite: accessoryDesign50D, zIndex: 31, defaultColor: '0xCD2323'}
        ]
    };
    let accessoryObject55 = {
        designs: [
            {sprite: accessoryDesign51A, zIndex: 30, defaultColor: '0x555555'}
        ]
    };
    let accessoryObject56 = {
        designs: [
            {sprite: accessoryDesign52A, zIndex: 30, defaultColor: '0xD0D5D9'}
        ]
    };
    let accessoryObject57 = {
        designs: [
            {sprite: accessoryDesign53A, zIndex: 30, defaultColor: '0xAE2D2D'},
            {sprite: accessoryDesign53B, zIndex: 30, defaultColor: '0xE8E8E8'},
            {sprite: accessoryDesign53C, zIndex: 30, defaultColor: '0xD9D9D9'}
        ]
    };
    let accessoryObject58 = {
        designs: [
            {sprite: accessoryDesign54A, zIndex: 30, defaultColor: '0x957F5F'},
            {sprite: accessoryDesign54B, zIndex: 30, defaultColor: '0x656565'}
        ]
    };
    let accessoryObject59 = {
        designs: [
            {sprite: accessoryDesign55A, zIndex: 30, defaultColor: '0xC2493A'},
            {sprite: accessoryDesign55B, zIndex: 30, defaultColor: '0xEBEBEB'},
            {sprite: accessoryDesign55C, zIndex: 30, defaultColor: '0x565656'},
            {sprite: accessoryDesign55D, zIndex: 30, defaultColor: '0xBEBEBE'}
        ]
    };
    let accessoryObject60 = {
        designs: [
            {sprite: accessoryDesign56A, zIndex: 30, defaultColor: '0xE8CD8F'},
            {sprite: accessoryDesign56B, zIndex: 30, defaultColor: '0xFFFFFF'}
        ]
    };
    let accessoryObject61 = {
        designs: [
            {sprite: accessoryDesign57A, zIndex: 2, defaultColor: '0xE1E1E1'},
            {sprite: accessoryDesign57B, zIndex: 3, defaultColor: '0x4A4A4A'}
        ]
    };
    let accessoryObject62 = {
        designs: [
            {sprite: accessoryDesign58A, zIndex: 2, defaultColor: '0xF7EE51'},
            {sprite: accessoryDesign58B, zIndex: 3, defaultColor: '0x4A4A4A'}
        ]
    };
    let accessoryObject63 = {
        designs: [
            {sprite: accessoryDesign59A, zIndex: 30, defaultColor: '0xEFEFEF'},
            {sprite: accessoryDesign59B, zIndex: 30, defaultColor: '0xBB1313'},
            {sprite: accessoryDesign59C, zIndex: 30, defaultColor: '0x1E3A74'},
            {sprite: accessoryDesign59D, zIndex: 30, defaultColor: '0xCCCCCC'}
        ]
    };
    let accessoryObject64 = {
        designs: [
            {sprite: accessoryDesign60A, zIndex: 30, defaultColor: '0xEC1D1E'},
            {sprite: accessoryDesign60B, zIndex: 30, defaultColor: '0xEFEFEF'},
            {sprite: accessoryDesign60C, zIndex: 30, defaultColor: '0xEC1D1E'},
            {sprite: accessoryDesign59D, zIndex: 30, defaultColor: '0xCCCCCC'}
        ]
    };
    let accessoryObject65 = {
        designs: [
            {sprite: accessoryDesign61A, zIndex: 30, defaultColor: '0x0032A5'},
            {sprite: accessoryDesign61B, zIndex: 30, defaultColor: '0xEFEFEF'},
            {sprite: accessoryDesign61C, zIndex: 30, defaultColor: '0xF02832'},
            {sprite: accessoryDesign59D, zIndex: 30, defaultColor: '0xCCCCCC'}
        ]
    };
    let accessoryObject66 = {
        designs: [
            {sprite: accessoryDesign62A, zIndex: 30, defaultColor: '0x1F1F1F'},
            {sprite: accessoryDesign62B, zIndex: 30, defaultColor: '0xD20000'},
            {sprite: accessoryDesign62C, zIndex: 30, defaultColor: '0xF2C300'},
            {sprite: accessoryDesign59D, zIndex: 30, defaultColor: '0xCCCCCC'}
        ]
    };
    let accessoryObject67 = {
        designs: [
            {sprite: accessoryDesign63A, zIndex: 30, defaultColor: '0x005BBC'},
            {sprite: accessoryDesign63B, zIndex: 30, defaultColor: '0xF2CA00'},
            {sprite: accessoryDesign59D, zIndex: 30, defaultColor: '0xCCCCCC'}
        ]
    };
    let accessoryObject68 = {
        designs: [
            {sprite: accessoryDesign64A, zIndex: 30, defaultColor: '0xC21010'},
            {sprite: accessoryDesign64B, zIndex: 30, defaultColor: '0xF3F3F3'},
            {sprite: accessoryDesign59D, zIndex: 30, defaultColor: '0xCCCCCC'}
        ]
    };
    let accessoryObject69 = {
        designs: [
            {sprite: accessoryDesign65A, zIndex: 30, defaultColor: '0xC9082A'},
            {sprite: accessoryDesign65B, zIndex: 30, defaultColor: '0xF3F3F3'},
            {sprite: accessoryDesign65C, zIndex: 30, defaultColor: '0x0B1F4F'},
            {sprite: accessoryDesign59D, zIndex: 30, defaultColor: '0xCCCCCC'}
        ]
    };
    let accessoryObject70 = {
        designs: [
            {sprite: accessoryDesign66A, zIndex: 30, defaultColor: '0x505050'},
            {sprite: accessoryDesign66B, zIndex: 30, defaultColor: '0x888888'}
        ]
    };
    let accessoryObject71 = {
        designs: [
            {sprite: accessoryDesign67A, zIndex: 30, defaultColor: '0xEBC729'},
            {sprite: accessoryDesign67B, zIndex: 30, defaultColor: '0x635034'}
        ]
    };
    let accessoryObject72 = {
        designs: [
            {sprite: accessoryDesign68A, zIndex: 30, defaultColor: '0xD95C2B'},
            {sprite: accessoryDesign68B, zIndex: 30, defaultColor: '0xE3E4E4'},
            {sprite: accessoryDesign68C, zIndex: 30, defaultColor: '0xD95C2B'},
            {sprite: accessoryDesign68D, zIndex: 30, defaultColor: '0x525252'}
        ]
    };
    let accessoryObject73 = {
        designs: [
            {sprite: accessoryDesign69A, zIndex: 0, defaultColor: '0x777777'}
        ]
    };
    let accessoryObject74 = {
        designs: [
            {sprite: accessoryDesign70A, zIndex: 30, defaultColor: '0x696969'},
            {sprite: accessoryDesign70B, zIndex: 31, defaultColor: '0xE3E3E3'}
        ]
    };
    let accessoryObject75 = {
        designs: [
            {sprite: accessoryDesign71A, zIndex: 30, defaultColor: '0x696969'},
            {sprite: accessoryDesign71B, zIndex: 31, defaultColor: '0xEEF2F3'},
            {sprite: accessoryDesign71C, zIndex: 31, defaultColor: '0xD3BE00'}
        ]
    };
    let accessoryObject76 = {
        designs: [
            {sprite: accessoryDesign72A, zIndex: 30, defaultColor: '0x404040'},
            {sprite: accessoryDesign72B, zIndex: 31, defaultColor: '0xEEEEEE'}
        ]
    };

    // Gloves
    let glovesObject1 = {
        designs: [
            {sprite: glovesDesign1, zIndex: 2, defaultColor: '0x424242'}
        ]
    };
    let glovesObject2 = {
        designs: [
            {sprite: glovesDesign2A, zIndex: 2, defaultColor: '0xFF443C'},
            {sprite: glovesDesign2B, zIndex: 2, defaultColor: '0x2E3F34'}
        ]
    };
    let glovesObject3 = {
        designs: [
            {sprite: glovesDesign3A, zIndex: 2, defaultColor: '0x0D9C9E'},
            {sprite: glovesDesign3B, zIndex: 2, defaultColor: '0x424242'}
        ]
    };
    let glovesObject4 = {
        designs: [
            {sprite: glovesDesign4A, zIndex: 2, defaultColor: '0xECECEC'},
            {sprite: glovesDesign4B, zIndex: 2, defaultColor: '0x333333'}
        ]
    };
    let glovesObject5 = {
        designs: [
            {sprite: glovesDesign5A, zIndex: 2, defaultColor: '0x333333'},
            {sprite: glovesDesign5B, zIndex: 2, defaultColor: '0xAAAAAA'}
        ]
    };
    let glovesObject6 = {
        designs: [
            {sprite: glovesDesign6A, zIndex: 2, defaultColor: '0x333333'},
            {sprite: glovesDesign6B, zIndex: 2, defaultColor: '0xe5bd43'}
        ]
    };

    // Glasses
    let glassesObject2 = {
        designs: [
            {sprite: glassesDesign2, zIndex: 20, defaultColor: '0x333333'}
        ]
    };
    let glassesObject3 = {
        designs: [
            {sprite: glassesDesign3, zIndex: 20, defaultColor: '0x333333'}
        ]
    };
    let glassesObject4 = {
        designs: [
            {sprite: glassesDesign4, zIndex: 20, defaultColor: '0x333333'}
        ]
    };
    let glassesObject5 = {
        designs: [
            {sprite: glassesDesign5, zIndex: 20, defaultColor: '0x333333'}
        ]
    };
    let glassesObject6 = {
        designs: [
            {sprite: glassesDesign6, zIndex: 20, defaultColor: '0x333333'}
        ]
    };
    let glassesObject7 = {
        designs: [
            {sprite: glassesDesign7A, zIndex: 20, defaultColor: '0x333333'},
            {sprite: glassesDesign7B, zIndex: 20, defaultColor: '0xA9504C'}
        ]
    };
    let glassesObject8 = {
        designs: [
            {sprite: glassesDesign8A, zIndex: 20, defaultColor: '0xDEDEDE'},
            {sprite: glassesDesign8B, zIndex: 20, defaultColor: '0x333333'}
        ]
    };

    // Wrist tapes
    let wristTapeObject1 = {
        designs: [
            {sprite: wristTape1, zIndex: 2, defaultColor: '0xF4F4F4'}
        ]
    };
    let wristTapeObject2 = {
        designs: [
            {sprite: wristTape2, zIndex: 2, defaultColor: '0xF4F4F4'}
        ]
    };
    let wristTapeObject3 = {
        designs: [
            {sprite: wristTape3, zIndex: 2, defaultColor: '0xf4f4f4'}
        ]
    };

    // Ties
    let tiesObject1 = {
        designs: [
            {sprite: ties1, zIndex: 9, defaultColor: '0xE13636'}
        ]
    };
    let tiesObject2 = {
        designs: [
            {sprite: ties2, zIndex: 9, defaultColor: '0x4A63CC'}
        ]
    };
    let tiesObject3 = {
        designs: [
            {sprite: ties3, zIndex: 9, defaultColor: '0x7D4DD9'}
        ]
    };
    let tiesObject4 = {
        designs: [
            {sprite: ties4, zIndex: 9, defaultColor: '0x6E6E6E'}
        ]
    };

    // Suits
    let suitsObject1 = {
        designs: [
            {sprite: suits1, zIndex: 10, defaultColor: '0x6E6E6E'}
        ]
    };
    let suitsObject2 = {
        designs: [
            {sprite: suits2, zIndex: 10, defaultColor: '0x365994'}
        ]
    };
    let suitsObject3 = {
        designs: [
            {sprite: suits3A, zIndex: 10, defaultColor: '0x6E6E6E'},
            {sprite: suits3B, zIndex: 10, defaultColor: '0xE4E4E4'}
        ]
    };

    // Face paint
    let facepaintObject2Female = {
        designs: [
            {sprite: facepaint2Female, zIndex: 10, defaultColor: '0xDF6565'}
        ]
    };
    let facepaintObject3Female = {
        designs: [
            {sprite: facepaint3Female, zIndex: 10, defaultColor: '0x474747'}
        ]
    };
    let facepaintObject4Female = {
        designs: [
            {sprite: facepaint4AFemale, zIndex: 10, defaultColor: '0x474747'},
            {sprite: facepaint4BFemale, zIndex: 10, defaultColor: '0xECD58B'}
        ]
    };
    let facepaintObject5Female = {
        designs: [
            {sprite: facepaint5AFemale, zIndex: 10, defaultColor: '0x474747'},
            {sprite: facepaint5BFemale, zIndex: 10, defaultColor: '0xECD58B'}
        ]
    };
    let facepaintObject6Female = {
        designs: [
            {sprite: facepaint6AFemale, zIndex: 10, defaultColor: '0xDCDCDC'},
            {sprite: facepaint6BFemale, zIndex: 10, defaultColor: '0x484848'}
        ]
    };
    let facepaintObject7Female = {
        designs: [
            {sprite: facepaint7AFemale, zIndex: 10, defaultColor: '0xDC7E6F'},
            {sprite: facepaint7B, zIndex: 10, defaultColor: '0xC7E278'},
            {sprite: facepaint7C, zIndex: 10, defaultColor: '0x303030'}
        ]
    };
    let facepaintObject8Female = {
        designs: [
            {sprite: facepaint8AFemale, zIndex: 10, defaultColor: '0x6F6BD4'},
            {sprite: facepaint8BFemale, zIndex: 10, defaultColor: '0xE7DE7F'}
        ]
    };
    let facepaintObject9Female = {
        designs: [
            {sprite: facepaint9AFemale, zIndex: 10, defaultColor: '0x242424'},
            {sprite: facepaint9BFemale, zIndex: 10, defaultColor: '0xD84444'},
            {sprite: facepaint9CFemale, zIndex: 10, defaultColor: '0xD5D5D5'}
        ]
    };
    let facepaintObject10Female = {
        designs: [
            {sprite: facepaint10AFemale, zIndex: 10, defaultColor: '0xFDCF89'},
            {sprite: facepaint10BFemale, zIndex: 10, defaultColor: '0x303030'}
        ]
    };
    let facepaintObject11Female = {
        designs: [
            {sprite: facepaint11AFemale, zIndex: 10, defaultColor: '0xFFFFFF'},
            {sprite: facepaint11BFemale, zIndex: 10, defaultColor: '0x525054'}
        ]
    };
    let facepaintObject12Female = {
        designs: [
            {sprite: facepaint12AFemale, zIndex: 10, defaultColor: '0xF35562'},
            {sprite: facepaint12BFemale, zIndex: 10, defaultColor: '0xFFFFFF'}
        ]
    };


    let facepaintObject1 = {
        designs: [
            {sprite: facepaint1, zIndex: 10, defaultColor: '0x474747'}
        ]
    };
    let facepaintObject2 = {
        designs: [
            {sprite: facepaint2, zIndex: 10, defaultColor: '0xDF6565'}
        ],
        femaleObject: facepaintObject2Female
    };
    facepaintObject2Female.maleObject = facepaintObject2;

    let facepaintObject3 = {
        designs: [
            {sprite: facepaint3, zIndex: 10, defaultColor: '0x474747'}
        ],
        femaleObject: facepaintObject3Female
    };
    facepaintObject3Female.maleObject = facepaintObject3;

    let facepaintObject4 = {
        designs: [
            {sprite: facepaint4A, zIndex: 10, defaultColor: '0xFFFFFF'},
            {sprite: facepaint4B, zIndex: 11, defaultColor: '0x191919'}
        ],
        femaleObject: facepaintObject4Female
    };
    facepaintObject4Female.maleObject = facepaintObject4;

    let facepaintObject5 = {
        designs: [
            {sprite: facepaint5A, zIndex: 10, defaultColor: '0x474747'},
            {sprite: facepaint5B, zIndex: 11, defaultColor: '0xECD58B'}
        ],
        femaleObject: facepaintObject5Female
    };
    facepaintObject5Female.maleObject = facepaintObject5;

    let facepaintObject6 = {
        designs: [
            {sprite: facepaint6A, zIndex: 10, defaultColor: '0xDCDCDC'},
            {sprite: facepaint6B, zIndex: 11, defaultColor: '0x484848'}
        ],
        femaleObject: facepaintObject6Female
    };
    facepaintObject6Female.maleObject = facepaintObject6;

    let facepaintObject7 = {
        designs: [
            {sprite: facepaint7A, zIndex: 10, defaultColor: '0xDC7E6F'},
            {sprite: facepaint7B, zIndex: 11, defaultColor: '0xC7E278'},
            {sprite: facepaint7C, zIndex: 12, defaultColor: '0x303030'}
        ],
        femaleObject: facepaintObject7Female
    };
    facepaintObject7Female.maleObject = facepaintObject7;

    let facepaintObject8 = {
        designs: [
            {sprite: facepaint8A, zIndex: 10, defaultColor: '0x6F6BD4'},
            {sprite: facepaint8B, zIndex: 11, defaultColor: '0xE7DE7F'}
        ],
        femaleObject: facepaintObject8Female
    };
    facepaintObject8Female.maleObject = facepaintObject8;

    let facepaintObject9 = {
        designs: [
            {sprite: facepaint9A, zIndex: 10, defaultColor: '0x242424'},
            {sprite: facepaint9B, zIndex: 11, defaultColor: '0xD84444'},
            {sprite: facepaint9C, zIndex: 12, defaultColor: '0xD5D5D5'}
        ],
        femaleObject: facepaintObject9Female
    };
    facepaintObject9Female.maleObject = facepaintObject9;

    let facepaintObject10 = {
        designs: [
            {sprite: facepaint10A, zIndex: 10, defaultColor: '0xFDCF89'},
            {sprite: facepaint10B, zIndex: 11, defaultColor: '0x303030'}
        ],
        femaleObject: facepaintObject10Female
    };
    facepaintObject10Female.maleObject = facepaintObject10;

    let facepaintObject11 = {
        designs: [
            {sprite: facepaint11A, zIndex: 10, defaultColor: '0xFFFFFF'},
            {sprite: facepaint11B, zIndex: 11, defaultColor: '0x444444'}
        ],
        femaleObject: facepaintObject11Female
    };
    facepaintObject11Female.maleObject = facepaintObject11;

    let facepaintObject12 = {
        designs: [
            {sprite: facepaint12A, zIndex: 10, defaultColor: '0xF35562'},
            {sprite: facepaint12B, zIndex: 11, defaultColor: '0xFFFFFF'}
        ],
        femaleObject: facepaintObject12Female
    };
    facepaintObject12Female.maleObject = facepaintObject12;


    // Sports bras
    let sportsBraObjectBasic = {
        designs: [
            {sprite: sportsbraBasic, zIndex: 7, defaultColor: '0x444444'}
        ]
    };
    let sportsBraObjectLow = {
        designs: [
            {sprite: sportsbraLow, zIndex: 7, defaultColor: '0xF6A0BD'}
        ]
    };
    let sportsBraObjectShort = {
        designs: [
            {sprite: sportsbraShort, zIndex: 7, defaultColor: '0x136CC0'}
        ]
    };
    let sportsBraObjectThin = {
        designs: [
            {sprite: sportsbraThinA, zIndex: 7, defaultColor: '0xDADADA'},
            {sprite: sportsbraThinB, zIndex: 7, defaultColor: '0x75AE31'}
        ]
    };
    let sportsBraObject1 = {
        designs: [
            {sprite: sportsbra1, zIndex: 7, defaultColor: '0xCA4B4B'}
        ]
    };
    let sportsBraObject2 = {
        designs: [
            {sprite: sportsbra2A, zIndex: 7, defaultColor: '0xAB3E3E'},
            {sprite: sportsbra2B, zIndex: 8, defaultColor: '0x333333'}
        ]
    };
    let sportsBraObject3 = {
        designs: [
            {sprite: sportsbra3, zIndex: 7, defaultColor: '0x4E4E4E'}
        ]
    };
    let sportsBraObject4 = {
        designs: [
            {sprite: sportsbra4, zIndex: 7, defaultColor: '0xC12323'}
        ]
    };
    let sportsBraObject5 = {
        designs: [
            {sprite: sportsbra5A, zIndex: 7, defaultColor: '0x6043B7'},
            {sprite: sportsbra5B, zIndex: 8, defaultColor: '0xBBACE7'}
        ]
    };
    let sportsBraObject6 = {
        designs: [
            {sprite: sportsbra6A, zIndex: 7, defaultColor: '0x7C7C7C'},
            {sprite: sportsbra6B, zIndex: 8, defaultColor: '0x2E2E2E'},
            {sprite: sportsbra6C, zIndex: 9, defaultColor: '0x9E9E9E'}
        ]
    };
    let sportsBraObject7 = {
        designs: [
            {sprite: sportsbra7A, zIndex: 7, defaultColor: '0x74B3B6'},
            {sprite: sportsbra7B, zIndex: 8, defaultColor: '0xC57BE8'}
        ]
    };
    let sportsBraObject8 = {
        designs: [
            {sprite: sportsbra8A, zIndex: 7, defaultColor: '0x74B3B6'},
            {sprite: sportsbra8B, zIndex: 8, defaultColor: '0xDE6FB5'},
            {sprite: sportsbra8C, zIndex: 9, defaultColor: '0x161616'}
        ]
    };
    let sportsBraObject9 = {
        designs: [
            {sprite: sportsbra9A, zIndex: 7, defaultColor: '0x222222'},
            {sprite: sportsbra9B, zIndex: 8, defaultColor: '0xC74B4B'},
            {sprite: sportsbra9C, zIndex: 9, defaultColor: '0xDAA969'}
        ]
    };
    let sportsBraObject10 = {
        designs: [
            {sprite: sportsbra10A, zIndex: 7, defaultColor: '0x393939'},
            {sprite: sportsbra10B, zIndex: 8, defaultColor: '0x1F1F1F'},
            {sprite: sportsbra10C, zIndex: 9, defaultColor: '0xD53A3A'}
        ]
    };
    let sportsBraObject11 = {
        designs: [
            {sprite: sportsbra11A, zIndex: 7, defaultColor: '0x424242'},
            {sprite: sportsbra11B, zIndex: 8, defaultColor: '0xBA8A50'}
        ]
    };
    let sportsBraObject12 = {
        designs: [
            {sprite: sportsbra12, zIndex: 7, defaultColor: '0x404040'}
        ]
    };
    let sportsBraObject13 = {
        designs: [
            {sprite: sportsbra13A, zIndex: 7, defaultColor: '0xC9C9C9'},
            {sprite: sportsbra13B, zIndex: 8, defaultColor: '0x101010'},
            {sprite: sportsbra13C, zIndex: 9, defaultColor: '0xA43939'}
        ]
    };
    let sportsBraObject14 = {
        designs: [
            {sprite: sportsbra14A, zIndex: 7, defaultColor: '0xFFFFFF'},
            {sprite: sportsbra14B, zIndex: 8, defaultColor: '0xE2A881'},
            {sprite: sportsbra14C, zIndex: 9, defaultColor: '0x589BDD'},
            {sprite: sportsbra14D, zIndex: 10, defaultColor: '0x4F4F4F'}
        ]
    };
    let sportsBraObject15 = {
        designs: [
            {sprite: sportsbra15, zIndex: 7, defaultColor: '0xFFFFFF'}
        ]
    };
    let sportsBraObject16 = {
        designs: [
            {sprite: sportsbra16A, zIndex: 7, defaultColor: '0xD02D36'},
            {sprite: sportsbra16B, zIndex: 8, defaultColor: '0xF4D976'},
            {sprite: sportsbra16C, zIndex: 9, defaultColor: '0x524632'}
        ]
    };

    // Tattoos
    let tattooObject1Female = {
        designs: [
            {sprite: tattoo1Female, zIndex: 1, defaultColor: '0x747474'}
        ]
    };
    let tattooObject2Female = {
        designs: [
            {sprite: tattoo2Female, zIndex: 1, defaultColor: '0x747474'}
        ]
    };
    let tattooObject3Female = {
        designs: [
            {sprite: tattoo3Female, zIndex: 1, defaultColor: '0x747474'}
        ]
    };
    let tattooObject4Female = {
        designs: [
            {sprite: tattoo4Female, zIndex: 1, defaultColor: '0x747474'}
        ]
    };
    let tattooObject5Female = {
        designs: [
            {sprite: tattoo5Female, zIndex: 1, defaultColor: '0x747474'}
        ]
    };
    let tattooObject10Female = {
        designs: [
            {sprite: tattoo10Female, zIndex: 1, defaultColor: '0x747474'}
        ]
    };
    let tattooObject11Female = {
        designs: [
            {sprite: tattoo11Female, zIndex: 1, defaultColor: '0x747474'}
        ]
    };
    let tattooObject16Female = {
        designs: [
            {sprite: tattoo16Female, zIndex: 1, defaultColor: '0x747474'}
        ]
    };
    let tattooObject17Female = {
        designs: [
            {sprite: tattoo17Female, zIndex: 1, defaultColor: '0x747474'}
        ]
    };
    let tattooObject19Female = {
        designs: [
            {sprite: tattoo19Female, zIndex: 1, defaultColor: '0x747474'}
        ]
    };
    let tattooObject20Female = {
        designs: [
            {sprite: tattoo20Female, zIndex: 1, defaultColor: '0x747474'}
        ]
    };
    let tattooObject21Female = {
        designs: [
            {sprite: tattoo21Female, zIndex: 1, defaultColor: '0x747474'}
        ]
    };
    let tattooObject22Female = {
        designs: [
            {sprite: tattoo22Female, zIndex: 1, defaultColor: '0x747474'}
        ]
    };
    let tattooObject23Female = {
        designs: [
            {sprite: tattoo23Female, zIndex: 1, defaultColor: '0x747474'}
        ]
    };

    let tattooObject1 = {
        designs: [
            {sprite: tattoo1, zIndex: 1, defaultColor: '0x747474'}
        ],
        femaleObject: tattooObject1Female
    };
    tattooObject1Female.maleObject = tattooObject1;

    let tattooObject2 = {
        designs: [
            {sprite: tattoo2, zIndex: 1, defaultColor: '0x747474'}
        ],
        femaleObject: tattooObject2Female
    };
    tattooObject2Female.maleObject = tattooObject2;

    let tattooObject3 = {
        designs: [
            {sprite: tattoo3, zIndex: 1, defaultColor: '0x747474'}
        ],
        femaleObject: tattooObject3Female
    };
    tattooObject3Female.maleObject = tattooObject3;

    let tattooObject4 = {
        designs: [
            {sprite: tattoo4, zIndex: 1, defaultColor: '0x747474'}
        ],
        femaleObject: tattooObject4Female
    };
    tattooObject4Female.maleObject = tattooObject4;

    let tattooObject5 = {
        designs: [
            {sprite: tattoo5, zIndex: 1, defaultColor: '0x747474'}
        ],
        femaleObject: tattooObject5Female
    };
    tattooObject5Female.maleObject = tattooObject5;

    let tattooObject6 = {
        designs: [
            {sprite: tattoo6, zIndex: 1, defaultColor: '0x747474'}
        ]
    };
    let tattooObject7 = {
        designs: [
            {sprite: tattoo7A, zIndex: 1, defaultColor: '0x747474'},
            {sprite: tattoo7B, zIndex: 1, defaultColor: '0xB26666'},
            {sprite: tattoo7C, zIndex: 1, defaultColor: '0x7ED2B6'}
        ]
    };
    let tattooObject8 = {
        designs: [
            {sprite: tattoo8A, zIndex: 1, defaultColor: '0x747474'},
            {sprite: tattoo8B, zIndex: 1, defaultColor: '0xB26666'}
        ]
    };
    let tattooObject9 = {
        designs: [
            {sprite: tattoo9, zIndex: 1, defaultColor: '0x747474'}
        ]
    };
    let tattooObject10 = {
        designs: [
            {sprite: tattoo10, zIndex: 1, defaultColor: '0x747474'}
        ],
        femaleObject: tattooObject10Female
    };
    tattooObject10Female.maleObject = tattooObject10;

    let tattooObject11 = {
        designs: [
            {sprite: tattoo11, zIndex: 1, defaultColor: '0x747474'}
        ],
        femaleObject: tattooObject11Female
    };
    tattooObject11Female.maleObject = tattooObject11;

    let tattooObject12 = {
        designs: [
            {sprite: tattoo12, zIndex: 1, defaultColor: '0x747474'}
        ]
    };
    let tattooObject13 = {
        designs: [
            {sprite: tattoo13, zIndex: 1, defaultColor: '0x747474'}
        ]
    };
    let tattooObject14 = {
        designs: [
            {sprite: tattoo14, zIndex: 1, defaultColor: '0x747474'}
        ]
    };
    let tattooObject15 = {
        designs: [
            {sprite: tattoo15, zIndex: 1, defaultColor: '0x747474'}
        ]
    };
    let tattooObject16 = {
        designs: [
            {sprite: tattoo16, zIndex: 1, defaultColor: '0x747474'}
        ],
        femaleObject: tattooObject16Female
    };
    tattooObject16Female.maleObject = tattooObject16;
    let tattooObject17 = {
        designs: [
            {sprite: tattoo17, zIndex: 1, defaultColor: '0x747474'}
        ],
        femaleObject: tattooObject17Female
    };
    tattooObject17Female.maleObject = tattooObject17;
    let tattooObject18 = {
        designs: [
            {sprite: tattoo18, zIndex: 1, defaultColor: '0x747474'}
        ]
    };
    let tattooObject19 = {
        designs: [
            {sprite: tattoo19, zIndex: 1, defaultColor: '0x747474'}
        ],
        femaleObject: tattooObject19Female
    };
    tattooObject19Female.maleObject = tattooObject19;
    let tattooObject20 = {
        designs: [
            {sprite: tattoo20, zIndex: 1, defaultColor: '0x747474'}
        ],
        femaleObject: tattooObject20Female
    };
    tattooObject20Female.maleObject = tattooObject20;
    let tattooObject21 = {
        designs: [
            {sprite: tattoo21, zIndex: 1, defaultColor: '0x747474'}
        ],
        femaleObject: tattooObject21Female
    };
    tattooObject21Female.maleObject = tattooObject21;
    let tattooObject22 = {
        designs: [
            {sprite: tattoo22, zIndex: 1, defaultColor: '0x747474'}
        ],
        femaleObject: tattooObject22Female
    };
    tattooObject22Female.maleObject = tattooObject22;
    let tattooObject23 = {
        designs: [
            {sprite: tattoo23, zIndex: 1, defaultColor: '0x747474'}
        ],
        femaleObject: tattooObject23Female
    };
    tattooObject23Female.maleObject = tattooObject23;

    // Female tops
    let femaleTopObject1 = {
        designs: [
            {sprite: femaleTop1, zIndex: 7, defaultColor: '0x4E4E4E'}
        ]
    };
    let femaleTopObject2 = {
        designs: [
            {sprite: femaleTop2, zIndex: 7, defaultColor: '0xE12B6D'}
        ]
    };
    let femaleTopObject3 = {
        designs: [
            {sprite: femaleTop3, zIndex: 7, defaultColor: '0x545454'}
        ]
    };
    let femaleTopObject4 = {
        designs: [
            {sprite: femaleTop4, zIndex: 7, defaultColor: '0xE7E7E7'}
        ]
    };
    let femaleTopObject5 = {
        designs: [
            {sprite: femaleTop5, zIndex: 7, defaultColor: '0x81B7B7'}
        ]
    };
    let femaleTopObject6 = {
        designs: [
            {sprite: femaleTop6, zIndex: 7, defaultColor: '0x545454'}
        ]
    };
    let femaleTopObject7 = {
        designs: [
            {sprite: femaleTop7, zIndex: 7, defaultColor: '0x7AB71E'}
        ]
    };
    let femaleTopObject8 = {
        designs: [
            {sprite: femaleTop8A, zIndex: 7, defaultColor: '0xE5E5E5'},
            {sprite: femaleTop8B, zIndex: 7, defaultColor: '0xA6E3D6'}
        ]
    };
    let femaleTopObject9 = {
        designs: [
            {sprite: femaleTop9A, zIndex: 7, defaultColor: '0xA98312'},
            {sprite: femaleTop9B, zIndex: 7, defaultColor: '0xFAEABA'}
        ]
    };
    let femaleTopObject10 = {
        designs: [
            {sprite: femaleTop10A, zIndex: 7, defaultColor: '0x4FB199'},
            {sprite: femaleTop10B, zIndex: 7, defaultColor: '0xD7AD30'}
        ]
    };
    let femaleTopObject11 = {
        designs: [
            {sprite: femaleTop11A, zIndex: 7, defaultColor: '0xBCF270'},
            {sprite: femaleTop11B, zIndex: 7, defaultColor: '0x252525'}
        ]
    };

    // Female bottoms
    let femaleBottomObject1 = {
        designs: [
            {sprite: femaleBottom1A, zIndex: 3, defaultColor: '0x6681AC'},
            {sprite: femaleBottom1B, zIndex: 4, defaultColor: '0x3A4A63'}
        ]
    };
    let femaleBottomObject2 = {
        designs: [
            {sprite: femaleBottom2, zIndex: 3, defaultColor: '0xCA4B4B'}
        ]
    };
    let femaleBottomObject3 = {
        designs: [
            {sprite: femaleBottom3A, zIndex: 3, defaultColor: '0x4E4E4E'},
            {sprite: femaleBottom3B, zIndex: 4, defaultColor: '0xB1B1B1'},
            {sprite: femaleBottom3C, zIndex: 5, defaultColor: '0x151515'}
        ]
    };
    let femaleBottomObject4 = {
        designs: [
            {sprite: femaleBottom4A, zIndex: 3, defaultColor: '0x464646'},
            {sprite: femaleBottom4B, zIndex: 4, defaultColor: '0x394390'},
            {sprite: femaleBottom4C, zIndex: 5, defaultColor: '0xD8D8D8'}
        ]
    };
    let femaleBottomObject5 = {
        designs: [
            {sprite: femaleBottom5, zIndex: 3, defaultColor: '0xE8E8E8'}
        ]
    };
    let femaleBottomObject6 = {
        designs: [
            {sprite: femaleBottom6A, zIndex: 3, defaultColor: '0xC12323'},
            {sprite: femaleBottom6B, zIndex: 4, defaultColor: '0x181818'},
            {sprite: femaleBottom6C, zIndex: 5, defaultColor: '0xB0913B'}
        ]
    };
    let femaleBottomObject7 = {
        designs: [
            {sprite: femaleBottom7, zIndex: 3, defaultColor: '0x444444'}
        ]
    };
    let femaleBottomObject8 = {
        designs: [
            {sprite: femaleBottom8A, zIndex: 3, defaultColor: '0x1E1E1E'},
            {sprite: femaleBottom8B, zIndex: 4, defaultColor: '0xA43535'}
        ]
    };
    let femaleBottomObject9 = {
        designs: [
            {sprite: femaleBottom9A, zIndex: 3, defaultColor: '0x292929'},
            {sprite: femaleBottom9B, zIndex: 4, defaultColor: '0xD6D6D6'}
        ]
    };
    let femaleBottomObject10 = {
        designs: [
            {sprite: femaleBottom10, zIndex: 3, defaultColor: '0xc8c8c8'}
        ]
    };
    let femaleBottomObject11 = {
        designs: [
            {sprite: femaleBottom11, zIndex: 4, defaultColor: '0xA41515'}
        ]
    };
    let femaleBottomObject12 = {
        designs: [
            {sprite: femaleBottom12A, zIndex: 3, defaultColor: '0x2D2D2D'},
            {sprite: femaleBottom12B, zIndex: 4, defaultColor: '0x655346'},
            {sprite: femaleBottom12C, zIndex: 5, defaultColor: '0xBCD561'}
        ]
    };
    let femaleBottomObject13 = {
        designs: [
            {sprite: femaleBottom13, zIndex: 3, defaultColor: '0x9AB732'}
        ]
    };
    let femaleBottomObject14 = {
        designs: [
            {sprite: femaleBottom14A, zIndex: 13, defaultColor: '0xEED8B9'},
            {sprite: femaleBottom14B, zIndex: 14, defaultColor: '0xD3C3AC'}
        ]
    };
    let femaleBottomObject15 = {
        designs: [
            {sprite: femaleBottom15, zIndex: 13, defaultColor: '0x933838'}
        ]
    };
    let femaleBottomObject16 = {
        designs: [
            {sprite: femaleBottom16A, zIndex: 3, defaultColor: '0xE19EFF'},
            {sprite: femaleBottom16B, zIndex: 4, defaultColor: '0xA497E6'}
        ]
    };
    let femaleBottomObject17 = {
        designs: [
            {sprite: femaleBottom17, zIndex: 3, defaultColor: '0xFFFFFF'}
        ]
    };
    let femaleBottomObject18 = {
        designs: [
            {sprite: femaleBottom18, zIndex: 3, defaultColor: '0xFFFFFF'}
        ]
    };
    let femaleBottomObject19 = {
        designs: [
            {sprite: femaleBottom19, zIndex: 3, defaultColor: '0x794681'}
        ]
    };
    let femaleBottomObject20 = {
        designs: [
            {sprite: femaleBottom20, zIndex: 3, defaultColor: '0x333333'}
        ]
    };
    let femaleBottomObject21 = {
        designs: [
            {sprite: femaleBottom21A, zIndex: 3, defaultColor: '0xD02D36'},
            {sprite: femaleBottom21B, zIndex: 4, defaultColor: '0xF4D976'},
            {sprite: femaleBottom21C, zIndex: 5, defaultColor: '0x4D4430'}
        ]
    };


    // Female accessories
    let femaleAccessoryObject1 = {
        designs: [
            {sprite: femaleAccessory1, zIndex: 1, defaultColor: '0x272727'}
        ]
    };
    let femaleAccessoryObject2 = {
        designs: [
            {sprite: femaleAccessory2, zIndex: 20, defaultColor: '0x313131'}
        ]
    };
    let femaleAccessoryObject3 = {
        designs: [
            {sprite: femaleAccessory3, zIndex: 26, defaultColor: '0xCF5252'}
        ]
    };
    let femaleAccessoryObject4 = {
        designs: [
            {sprite: femaleAccessory4A, zIndex: 1, defaultColor: '0xA8A8A8'},
            {sprite: femaleAccessory4B, zIndex: 10, defaultColor: '0x434343'}
        ]
    };
    let femaleAccessoryObject5 = {
        designs: [
            {sprite: femaleAccessory5, zIndex: 2, defaultColor: '0xC5D78A'}
        ]
    };
    let femaleAccessoryObject6 = {
        designs: [
            {sprite: femaleAccessory6, zIndex: 2, defaultColor: '0xD4CBE4'}
        ]
    };
    let femaleAccessoryObject7 = {
        designs: [
            {sprite: femaleAccessory7, zIndex: 1, defaultColor: '0xCACACA'}
        ]
    };
    let femaleAccessoryObject8 = {
        designs: [
            {sprite: femaleAccessory8A, zIndex: 20, defaultColor: '0x5C7CC7'},
            {sprite: femaleAccessory8B, zIndex: 21, defaultColor: '0xE0E0E0'}
        ]
    };
    let femaleAccessoryObject9 = {
        designs: [
            {sprite: femaleAccessory9A, zIndex: 1, defaultColor: '0xA8A8A8'},
            {sprite: femaleAccessory9B, zIndex: 10, defaultColor: '0x404040'}
        ]
    };
    let femaleAccessoryObject10 = {
        designs: [
            {sprite: femaleAccessory10, zIndex: 2, defaultColor: '0xF55BE0'}
        ]
    };
    let femaleAccessoryObject11 = {
        designs: [
            {sprite: femaleAccessory11, zIndex: 26, defaultColor: '0x4e435d'}
        ]
    };
    let femaleAccessoryObject12 = {
        designs: [
            {sprite: femaleAccessory12, zIndex: 26, defaultColor: '0x4386AB'}
        ]
    };

    // Female hair
    let femaleHairObject1 = {
        designs: [
            {sprite: femaleHair1A, zIndex: 25, defaultColor: '0xB59B82'},
            {sprite: femaleHair1B, zIndex: 25, defaultColor: '0xB59B82'}
        ]
    };
    let femaleHairObject2 = {
        designs: [
            {sprite: femaleHair2A, zIndex: 25, defaultColor: '0xB59B82'},
            {sprite: femaleHair2B, zIndex: 25, defaultColor: '0xB59B82'}
        ]
    };
    let femaleHairObject3 = {
        designs: [
            {sprite: femaleHair3A, zIndex: 25, defaultColor: '0xB59B82'},
            {sprite: femaleHair3B, zIndex: 25, defaultColor: '0xB59B82'}
        ]
    };
    let femaleHairObject4 = {
        designs: [
            {sprite: femaleHair4A, zIndex: 25, defaultColor: '0xB59B82'}
        ]
    };
    let femaleHairObject5 = {
        designs: [
            {sprite: femaleHair5A, zIndex: 25, defaultColor: '0xB59B82'},
            {sprite: femaleHair5B, zIndex: 25, defaultColor: '0xB59B82'}
        ]
    };
    let femaleHairObject6 = {
        designs: [
            {sprite: femaleHair6A, zIndex: 25, defaultColor: '0xB59B82'},
            {sprite: femaleHair6B, zIndex: 25, defaultColor: '0xB59B82'}
        ]
    };
    let femaleHairObject7 = {
        designs: [
            {sprite: femaleHair7A, zIndex: 25, defaultColor: '0xB59B82'},
            {sprite: femaleHair7B, zIndex: 25, defaultColor: '0xB59B82'}
        ]
    };
    let femaleHairObject8 = {
        designs: [
            {sprite: femaleHair8A, zIndex: 25, defaultColor: '0xB59B82'},
            {sprite: femaleHair8B, zIndex: 25, defaultColor: '0xB59B82'}
        ]
    };
    let femaleHairObject9 = {
        designs: [
            {sprite: femaleHair9A, zIndex: 25, defaultColor: '0xB59B82'},
            {sprite: femaleHair9B, zIndex: 25, defaultColor: '0xB59B82'}
        ]
    };
    let femaleHairObject10 = {
        designs: [
            {sprite: femaleHair10A, zIndex: 25, defaultColor: '0xB59B82'},
            {sprite: femaleHair10B, zIndex: 25, defaultColor: '0xB59B82'}
        ]
    };
    let femaleHairObject11 = {
        designs: [
            {sprite: femaleHair11A, zIndex: 25, defaultColor: '0xB59B82'},
            {sprite: femaleHair11B, zIndex: 25, defaultColor: '0xB59B82'}
        ]
    };
    let femaleHairObject12 = {
        designs: [
            {sprite: femaleHair12A, zIndex: 25, defaultColor: '0xB59B82'},
            {sprite: femaleHair12B, zIndex: 25, defaultColor: '0xB59B82'}
        ]
    };
    let femaleHairObject13 = {
        designs: [
            {sprite: femaleHair13A, zIndex: 25, defaultColor: '0xB59B82'},
            {sprite: femaleHair13B, zIndex: 25, defaultColor: '0xB59B82'}
        ]
    };
    let femaleHairObject14 = {
        designs: [
            {sprite: femaleHair14A, zIndex: 25, defaultColor: '0xB59B82'},
            {sprite: femaleHair14B, zIndex: 25, defaultColor: '0xB59B82'}
        ]
    };
    let femaleHairObject15 = {
        designs: [
            {sprite: femaleHair15A, zIndex: 25, defaultColor: '0xB59B82'},
            {sprite: femaleHair15B, zIndex: 25, defaultColor: '0xB59B82'}
        ]
    };
    let femaleHairObject16 = {
        designs: [
            {sprite: femaleHair16A, zIndex: 25, defaultColor: '0xB59B82'},
            {sprite: femaleHair16B, zIndex: 25, defaultColor: '0xB59B82'}
        ]
    };
    let femaleHairObject17 = {
        designs: [
            {sprite: femaleHair17A, zIndex: 25, defaultColor: '0xB59B82'},
            {sprite: femaleHair17B, zIndex: 25, defaultColor: '0xB59B82'}
        ]
    };
    let femaleHairObject18 = {
        designs: [
            {sprite: femaleHair18A, zIndex: 25, defaultColor: '0xB59B82'},
            {sprite: femaleHair18B, zIndex: 25, defaultColor: '0xB59B82'}
        ]
    };
    let femaleHairObject19 = {
        designs: [
            {sprite: femaleHair19A, zIndex: 25, defaultColor: '0xB59B82'},
            {sprite: femaleHair19B, zIndex: 25, defaultColor: '0xB59B82'}
        ]
    };
    let femaleHairObject20 = {
        designs: [
            {sprite: femaleHair20A, zIndex: 25, defaultColor: '0xB59B82'},
            {sprite: femaleHair20B, zIndex: 25, defaultColor: '0xB59B82'}
        ]
    };
    let femaleHairObject21 = {
        designs: [
            {sprite: femaleHair21A, zIndex: 25, defaultColor: '0xB59B82'},
            {sprite: femaleHair21B, zIndex: 25, defaultColor: '0xB59B82'}
        ]
    };
    let femaleHairObject22 = {
        designs: [
            {sprite: femaleHair22A, zIndex: 25, defaultColor: '0xB59B82'},
            {sprite: femaleHair22B, zIndex: 25, defaultColor: '0xB59B82'}
        ]
    };
    let femaleHairObject23 = {
        designs: [
            {sprite: femaleHair23A, zIndex: 25, defaultColor: '0xB59B82'},
            {sprite: femaleHair23B, zIndex: 25, defaultColor: '0x83437F'},
            {sprite: femaleHair23C, zIndex: 25, defaultColor: '0xB59B82'}
        ]
    };
    let femaleHairObject24 = {
        designs: [
            {sprite: femaleHair24A, zIndex: 25, defaultColor: '0xB59B82'},
            {sprite: femaleHair24B, zIndex: 25, defaultColor: '0xB59B82'}
        ]
    };
    let femaleHairObject25 = {
        designs: [
            {sprite: femaleHair25A, zIndex: 25, defaultColor: '0xB59B82'},
            {sprite: femaleHair25B, zIndex: 25, defaultColor: '0xB59B82'}
        ]
    };
    let femaleHairObject26 = {
        designs: [
            {sprite: femaleHair26A, zIndex: 25, defaultColor: '0xB59B82'},
            {sprite: femaleHair26B, zIndex: 25, defaultColor: '0xB59B82'}
        ]
    };
    let femaleHairObject27 = {
        designs: [
            {sprite: femaleHair27A, zIndex: 25, defaultColor: '0xB59B82'},
            {sprite: femaleHair27B, zIndex: 25, defaultColor: '0xB59B82'}
        ]
    };
    let femaleHairObject28 = {
        designs: [
            {sprite: femaleHair28A, zIndex: 25, defaultColor: '0xB59B82'},
            {sprite: femaleHair28B, zIndex: 25, defaultColor: '0xB59B82'}
        ]
    };
    let femaleHairObject29 = {
        designs: [
            {sprite: femaleHair29A, zIndex: 25, defaultColor: '0x383838'},
            {sprite: femaleHair29B, zIndex: 25, defaultColor: '0x383838'}
        ]
    };
    let femaleHairObject30 = {
        designs: [
            {sprite: femaleHair30A, zIndex: 25, defaultColor: '0xB59B82'},
            {sprite: femaleHair30B, zIndex: 25, defaultColor: '0xB59B82'}
        ]
    };

    // Knee pads
    let kneepadObject1 = {
        designs: [
            {sprite: kneepad1, zIndex: 10, defaultColor: '0x333333'}
        ]
    };
    let kneepadObject2 = {
        designs: [
            {sprite: kneepad2, zIndex: 10, defaultColor: '0x333333'}
        ]
    };
    let kneepadObject3 = {
        designs: [
            {sprite: kneepad3, zIndex: 10, defaultColor: '0x333333'}
        ]
    };
    let kneepadObject4 = {
        designs: [
            {sprite: kneepad4, zIndex: 10, defaultColor: '0x333333'}
        ]
    };
    let kneepadObject5 = {
        designs: [
            {sprite: kneepad5, zIndex: 10, defaultColor: '0x333333'}
        ]
    };
    let kneepadObject6 = {
        designs: [
            {sprite: kneepad6, zIndex: 10, defaultColor: '0x333333'}
        ]
    };
    let kneepadObject7 = {
        designs: [
            {sprite: kneepad7, zIndex: 10, defaultColor: '0x333333'}
        ]
    };
    let kneepadObject8 = {
        designs: [
            {sprite: kneepad8, zIndex: 10, defaultColor: '0x333333'}
        ]
    };
    let kneepadObject9 = {
        designs: [
            {sprite: kneepad9, zIndex: 10, defaultColor: '0x333333'}
        ]
    };
    let kneepadObject10 = {
        designs: [
            {sprite: kneepad10, zIndex: 10, defaultColor: '0x333333'}
        ]
    };

    // Empty objects
    let emptyAccessoryObject = {
        designs: [
            {sprite: emptySprite, zIndex: 20, defaultColor: '0xEFEFEF'}
        ]
    };
    let emptyHairObject = {
        designs: [
            {sprite: hairDesign0, zIndex: 20, defaultColor: '0xEFEFEF'}
        ]
    };
    let emptyFacialHairObject = {
        designs: [
            {sprite: emptySprite, zIndex: 20, defaultColor: '0xEFEFEF'}
        ]
    };
    let emptyTopObject = {
        designs: [
            {sprite: emptySprite, zIndex: 20, defaultColor: '0xEFEFEF'}
        ]
    };
    let emptyElbowObject = {
        designs: [
            {sprite: emptySprite, zIndex: 20, defaultColor: '0xEFEFEF'}
        ]
    };
    let emptyKneepadObject = {
        designs: [
            {sprite: emptySprite, zIndex: 20, defaultColor: '0xEFEFEF'}
        ]
    };
    let emptyFacepaintObject = {
        designs: [
            {sprite: emptySprite, zIndex: 20, defaultColor: '0xEFEFEF'}
        ]
    };
    let emptyTattooObject = {
        designs: [
            {sprite: emptySprite, zIndex: 20, defaultColor: '0xEFEFEF'}
        ]
    };
    let emptyShoesObject = {
        designs: [
            {sprite: emptySprite, zIndex: 20, defaultColor: '0xEFEFEF'}
        ]
    };

    // Title objects

    let smallStrapObject1 = {
        designs: [
            {sprite: titleSmallStrap1, zIndex: 15, defaultColor: '0x1D1D1D'}
        ]
    };
    let smallStrapObject2 = {
        designs: [
            {sprite: titleSmallStrap2, zIndex: 15, defaultColor: '0x1D1D1D'}
        ]
    };
    let smallStrapObject3 = {
        designs: [
            {sprite: titleSmallStrap3, zIndex: 15, defaultColor: '0x1D1D1D'}
        ]
    };
    let smallStrapObject4 = {
        designs: [
            {sprite: titleSmallStrap4, zIndex: 15, defaultColor: '0x1D1D1D'}
        ]
    };
    let smallStrapObject5 = {
        designs: [
            {sprite: titleSmallStrap5, zIndex: 15, defaultColor: '0x1D1D1D'}
        ]
    };
    let smallStrapObject6 = {
        designs: [
            {sprite: titleSmallStrap6, zIndex: 15, defaultColor: '0x1D1D1D'}
        ]
    };
    let smallStrapObject7 = {
        designs: [
            {sprite: titleSmallStrap7, zIndex: 15, defaultColor: '0x1D1D1D'}
        ]
    };
    let smallStrapObject8 = {
        designs: [
            {sprite: titleSmallStrap8, zIndex: 15, defaultColor: '0x1D1D1D'}
        ]
    };
    let smallStrapObject9 = {
        designs: [
            {sprite: titleSmallStrap9, zIndex: 15, defaultColor: '0x1D1D1D'}
        ]
    };
    let smallStrapObject10 = {
        designs: [
            {sprite: titleSmallStrap10, zIndex: 15, defaultColor: '0x1D1D1D'}
        ]
    };

    let smallGemsObject1 = {
        designs: [
            {sprite: titleSmallGems1, zIndex: 17, defaultColor: '0xC51616'}
        ]
    };
    let smallGemsObject2 = {
        designs: [
            {sprite: titleSmallGems2, zIndex: 17, defaultColor: '0xC51616'}
        ]
    };
    let smallGemsObject3 = {
        designs: [
            {sprite: titleSmallGems3, zIndex: 17, defaultColor: '0xC51616'}
        ]
    };
    let smallGemsObject4 = {
        designs: [
            {sprite: titleSmallGems4, zIndex: 17, defaultColor: '0xC51616'}
        ]
    };
    let smallGemsObject5 = {
        designs: [
            {sprite: titleSmallGems5, zIndex: 17, defaultColor: '0xC51616'}
        ]
    };
    let smallGemsObject6 = {
        designs: [
            {sprite: titleSmallGems6, zIndex: 17, defaultColor: '0xC51616'}
        ]
    };
    let smallGemsObject7 = {
        designs: [
            {sprite: titleSmallGems7, zIndex: 17, defaultColor: '0xC51616'}
        ]
    };
    let smallGemsObject8 = {
        designs: [
            {sprite: titleSmallGems8, zIndex: 17, defaultColor: '0xC51616'}
        ]
    };
    let smallGemsObject9 = {
        designs: [
            {sprite: titleSmallGems9, zIndex: 17, defaultColor: '0xC51616'}
        ]
    };
    let smallGemsObject10 = {
        designs: [
            {sprite: titleSmallGems10, zIndex: 17, defaultColor: '0xC51616'}
        ]
    };

    let smallPlateObject1 = {
        designs: [
            {sprite: titleSmallPlate1, zIndex: 16, defaultColor: '0xC59548'}
        ],
        smallStrapObject: smallStrapObject1,
        smallGemsObject: smallGemsObject1
    };
    let smallPlateObject2 = {
        designs: [
            {sprite: titleSmallPlate2, zIndex: 16, defaultColor: '0xC59548'}
        ],
        smallStrapObject: smallStrapObject2,
        smallGemsObject: smallGemsObject2
    };
    let smallPlateObject3 = {
        designs: [
            {sprite: titleSmallPlate3, zIndex: 16, defaultColor: '0xC59548'}
        ],
        smallStrapObject: smallStrapObject3,
        smallGemsObject: smallGemsObject3
    };
    let smallPlateObject4 = {
        designs: [
            {sprite: titleSmallPlate4, zIndex: 16, defaultColor: '0xC59548'}
        ],
        smallStrapObject: smallStrapObject4,
        smallGemsObject: smallGemsObject4
    };
    let smallPlateObject5 = {
        designs: [
            {sprite: titleSmallPlate5, zIndex: 16, defaultColor: '0xC59548'}
        ],
        smallStrapObject: smallStrapObject5,
        smallGemsObject: smallGemsObject5
    };
    let smallPlateObject6 = {
        designs: [
            {sprite: titleSmallPlate6, zIndex: 16, defaultColor: '0xC59548'}
        ],
        smallStrapObject: smallStrapObject6,
        smallGemsObject: smallGemsObject6
    };
    let smallPlateObject7 = {
        designs: [
            {sprite: titleSmallPlate7, zIndex: 16, defaultColor: '0xC59548'}
        ],
        smallStrapObject: smallStrapObject7,
        smallGemsObject: smallGemsObject7
    };
    let smallPlateObject8 = {
        designs: [
            {sprite: titleSmallPlate8, zIndex: 16, defaultColor: '0xC59548'}
        ],
        smallStrapObject: smallStrapObject8,
        smallGemsObject: smallGemsObject8
    };
    let smallPlateObject9 = {
        designs: [
            {sprite: titleSmallPlate9, zIndex: 16, defaultColor: '0xC59548'}
        ],
        smallStrapObject: smallStrapObject9,
        smallGemsObject: smallGemsObject9
    };
    let smallPlateObject10 = {
        designs: [
            {sprite: titleSmallPlate10, zIndex: 16, defaultColor: '0xC59548'}
        ],
        smallStrapObject: smallStrapObject10,
        smallGemsObject: smallGemsObject10
    };

    let centerPlateObject1 = {
        smallPlateObject: smallPlateObject1
    };
    let centerPlateObject2 = {
        smallPlateObject: smallPlateObject2
    };
    let centerPlateObject3 = {
        smallPlateObject: smallPlateObject3
    };
    let centerPlateObject4 = {
        smallPlateObject: smallPlateObject4
    };
    let centerPlateObject5 = {
        smallPlateObject: smallPlateObject5
    };
    let centerPlateObject6 = {
        smallPlateObject: smallPlateObject6
    };
    let centerPlateObject7 = {
        smallPlateObject: smallPlateObject7
    };
    let centerPlateObject8 = {
        smallPlateObject: smallPlateObject8
    };
    let centerPlateObject9 = {
        smallPlateObject: smallPlateObject9
    };
    let centerPlateObject10 = {
        smallPlateObject: smallPlateObject10
    };

    // Blood objects
    let bloodObject1 = {
        designs: [
            {sprite: bloodDesign1, zIndex: 1, defaultColor: '0xFFFFFF'}
        ]
    };
    let bloodObject2 = {
        designs: [
            {sprite: bloodDesign2, zIndex: 1, defaultColor: '0xFFFFFF'}
        ]
    };
    let bloodObject3 = {
        designs: [
            {sprite: bloodDesign3, zIndex: 1, defaultColor: '0xFFFFFF'}
        ]
    };
    let bloodObject4 = {
        designs: [
            {sprite: bloodDesign4, zIndex: 1, defaultColor: '0xFFFFFF'}
        ]
    };
    let bloodObject5 = {
        designs: [
            {sprite: bloodDesign5, zIndex: 1, defaultColor: '0xFFFFFF'}
        ]
    };
    let bloodObject6 = {
        designs: [
            {sprite: bloodDesign6, zIndex: 1, defaultColor: '0xFFFFFF'}
        ]
    };
    let bloodObject7 = {
        designs: [
            {sprite: bloodDesign7, zIndex: 1, defaultColor: '0xFFFFFF'}
        ]
    };
    let bloodObject8 = {
        designs: [
            {sprite: bloodDesign8, zIndex: 1, defaultColor: '0xFFFFFF'}
        ]
    };
    let bloodObject9 = {
        designs: [
            {sprite: bloodDesign9, zIndex: 1, defaultColor: '0xFFFFFF'}
        ]
    };
    let bloodObject10 = {
        designs: [
            {sprite: bloodDesign10, zIndex: 1, defaultColor: '0xFFFFFF'}
        ]
    };
    let bloodObject11 = {
        designs: [
            {sprite: bloodDesign11, zIndex: 1, defaultColor: '0xFFFFFF'}
        ]
    };
    let bloodObject12 = {
        designs: [
            {sprite: bloodDesign12, zIndex: 1, defaultColor: '0xFFFFFF'}
        ]
    };
    let bloodObject13 = {
        designs: [
            {sprite: bloodDesign13, zIndex: 1, defaultColor: '0xFFFFFF'}
        ]
    };

    // Injury objects
    let bruiseEyeRightObject = {
        designs: [
            {sprite: bruiseEyeRight, zIndex: 1, defaultColor: '0xFFFFFF'}
        ]
    };
    let bruiseEyeLeftObject = {
        designs: [
            {sprite: bruiseEyeLeft, zIndex: 1, defaultColor: '0xFFFFFF'}
        ]
    };
    let bandageArmRightObject = {
        designs: [
            {sprite: bandageArmRight, zIndex: 1, defaultColor: '0xFFFFFF'}
        ]
    };
    let bandageArmLeftObject = {
        designs: [
            {sprite: bandageArmLeft, zIndex: 1, defaultColor: '0xFFFFFF'}
        ]
    };
    let bandageForeheadLeftObject = {
        designs: [
            {sprite: bandageForeheadLeft, zIndex: 1, defaultColor: '0xFFFFFF'}
        ]
    };
    let bandageForeheadRightObject = {
        designs: [
            {sprite: bandageForeheadRight, zIndex: 1, defaultColor: '0xFFFFFF'}
        ]
    };
    let bandageForeheadFullObject = {
        designs: [
            {sprite: bandageForeheadFull, zIndex: 1, defaultColor: '0xFFFFFF'}
        ]
    };

    // Trophy objects
    let trophyObject1 = {
        designs: [
            {sprite: TGITrophy, zIndex: 40, defaultColor: '0xFFFFFF'}
        ]
    };

    // Define sprite arrays
    let bodies = [bodyObjectHe, bodyObjectHe2, bodyObjectHe3, bodyObjectShe, bodyObjectSheAbs, bodyObjectHeAbs];
    let eyes = [eyesObject];
    let bottoms = [tightsObject0, tightsObject1, tightsObject2, tightsObject3, tightsObject4, tightsObject5, tightsObject6,
        tightsObject7, tightsObject8, tightsObject9, tightsObject10, tightsObject11, tightsObject12, tightsObject13,
        tightsObject14, tightsObject15, shortsObjectBasic, shortsObject1, shortsObject2, shortsObject3, shortsObject4,
        shortsObject5, shortsObject6, shortsObject7, shortsObject8, trunkObject1, trunkObject2, trunkObject3, trunkObject4,
        trunkObject5, trunkObject6, trunkObject7, trunkObject8, trunkObject9, trunkObject10, trunkObject11, trunkObject12,
        trunkObject13, trunkObject14, trunkObject15, trunkObject16, trunkObject17,
        femaleBottomObject1, femaleBottomObject18, femaleBottomObject2, femaleBottomObject3, femaleBottomObject4, femaleBottomObject5, femaleBottomObject6,
        femaleBottomObject7, femaleBottomObject8, femaleBottomObject9, femaleBottomObject19, femaleBottomObject10, femaleBottomObject11, femaleBottomObject12,
        femaleBottomObject13, femaleBottomObject14, femaleBottomObject15, femaleBottomObject16, femaleBottomObject17, femaleBottomObject20, tightsObject16, femaleBottomObject21,
        shortsObject9, tightsObject17, tightsObject18, tightsObject19, tightsObject20, tightsObject21, tightsObject22,
        tightsObject23, tightsObject24, tightsObject25];
    let shorts = [shortsObjectBasic, shortsObject1, shortsObject2, shortsObject3, shortsObject4, shortsObject5, shortsObject6,
        shortsObject7, shortsObject8, shortsObject9];
    let trunks = [trunkObject1, trunkObject2, trunkObject3, trunkObject4, trunkObject5,
        trunkObject6, trunkObject7, trunkObject8, trunkObject9, trunkObject10, trunkObject11, trunkObject12,
        trunkObject13, trunkObject14, trunkObject15, trunkObject16, trunkObject17];
    let tights = [tightsObject0, tightsObject1, tightsObject2, tightsObject3, tightsObject4, tightsObject5, tightsObject6,
        tightsObject7, tightsObject8, tightsObject9, tightsObject10, tightsObject11, tightsObject12, tightsObject13,
        tightsObject14, tightsObject15, tightsObject16, tightsObject17, tightsObject18, tightsObject19, tightsObject20,
        tightsObject21, tightsObject22, tightsObject23, tightsObject24, tightsObject25];
    let shoes = [shoesObject0, shoesObject1, shoesObject2, shoesObject3, shoesObject4, shoesObject5, shoesObject6,
        shoesObject7, shoesObject8, shoesObject9, shoesObject10, shoesObject11, shoesObject12, shoesObject13,
        shoesObject14, shoesObject15, shoesObject16, shoesObject17, shoesObject18, shoesObject19, shoesObject20,
        emptyShoesObject];
    let hairs = [emptyHairObject, hairObject1, hairObject2, hairObject3, hairObject4, hairObject5, hairObject6, hairObject7,
        hairObject8, hairObject9, hairObject10, hairObject11, hairObject12, hairObject13, hairObject14, hairObject15,
        hairObject16, hairObject17, hairObject18, hairObject19, hairObject20, hairObject21, hairObject22, hairObject23,
        hairObject24, hairObject25, hairObject26, hairObject27, hairObject28, hairObject29, hairObject30,
        hairObject31, hairObject32, hairObject33, hairObject34, hairObject35,
        femaleHairObject1, femaleHairObject2, femaleHairObject3, femaleHairObject4, femaleHairObject5, femaleHairObject6,
        femaleHairObject7, femaleHairObject8, femaleHairObject9, femaleHairObject10, femaleHairObject11, femaleHairObject12,
        femaleHairObject13, femaleHairObject14, femaleHairObject15, femaleHairObject16, femaleHairObject17, femaleHairObject18,
        femaleHairObject19, femaleHairObject20, femaleHairObject21, femaleHairObject22, femaleHairObject23, femaleHairObject24,
        femaleHairObject25, femaleHairObject26, femaleHairObject27, femaleHairObject28, femaleHairObject30, femaleHairObject29,
        hairObject36];
    let torsos = [topObject1, topObject2, topObject3, topObject4, topObject5, topObject6, topObject7, topObject8,
        topObject9, topObject10, topObject11, topObject12, topObject13, topObject14, topObject15, topObject16, topObject17,
        topObject18, topObject19, topObject20, topObject21, topObject22, topObject23, topObject24, topObject25, topObject26,
        topObject27, topObject28, topObject29, topObject30, topObject31, topObject32, topObject33, topObject34,
        topObject35, topObject36, topObject37, topObject38, topObject39, topObject40, topObject41, topObject42, topObject43,
        topObject44, topObject45, topObject46, topObject47, topObject48, topObject49,
        sportsBraObjectBasic, sportsBraObjectLow, sportsBraObjectShort, sportsBraObjectThin,
        sportsBraObject1, sportsBraObject2, sportsBraObject3, sportsBraObject4, sportsBraObject5, sportsBraObject6, sportsBraObject7,
        sportsBraObject8, sportsBraObject9, sportsBraObject10, sportsBraObject11, sportsBraObject12, sportsBraObject13, sportsBraObject14,
        sportsBraObject15,
        femaleTopObject1, femaleTopObject2, femaleTopObject3, femaleTopObject4, femaleTopObject5, femaleTopObject6,
        femaleTopObject7, femaleTopObject8, femaleTopObject9, femaleTopObject10, femaleTopObject11, sportsBraObject16,
        topObject50, topObject51, topObject52, topObject53, topObject54,
        emptyTopObject];
    let elbows = [elbowObject1, elbowObject2, elbowObject3, elbowObject4, elbowObject5, elbowObject6, elbowObject7,
        elbowObject8, elbowObject9, elbowObject10, emptyElbowObject];
    let facialHairs = [facialHairObject1, facialHairObject2, facialHairObject3, facialHairObject4, facialHairObject5,
        facialHairObject6, facialHairObject7, facialHairObject8, facialHairObject9, facialHairObject10,
        facialHairObject11, facialHairObject12, facialHairObject13, facialHairObject14, facialHairObject15,
        facialHairObject16, facialHairObject17, facialHairObject18, facialHairObject19, facialHairObject20,
        emptyFacialHairObject];
    let accessories = [accessoryObject1, accessoryObject2, accessoryObject3, accessoryObject4, accessoryObject5,
        accessoryObject6, accessoryObject7, accessoryObject8, accessoryObject9, accessoryObject10,
        accessoryObject11, accessoryObject12, accessoryObject13, accessoryObject14, accessoryObject15,
        accessoryObject16, accessoryObject17, accessoryObject18, accessoryObject19, accessoryObject20,
        glovesObject1, glovesObject2, glovesObject3, glovesObject4, glovesObject5, glovesObject6,
        wristTapeObject1, wristTapeObject2, wristTapeObject3,
        glassesObject2, glassesObject3, glassesObject4, glassesObject5,
        glassesObject6, glassesObject7, glassesObject8,
        suitsObject1, suitsObject2, suitsObject3,
        tiesObject1, tiesObject2, tiesObject3, tiesObject4,
        femaleAccessoryObject1, femaleAccessoryObject2, femaleAccessoryObject3, femaleAccessoryObject4, femaleAccessoryObject5,
        femaleAccessoryObject6, femaleAccessoryObject7, femaleAccessoryObject8, femaleAccessoryObject9, femaleAccessoryObject10,
        femaleAccessoryObject11, femaleAccessoryObject12, accessoryObject21, accessoryObject22, accessoryObject23,
        accessoryObject24, accessoryObject25, accessoryObject26, accessoryObject27, accessoryObject28,
        accessoryObject29, accessoryObject30, accessoryObject31, accessoryObject32, accessoryObject33,
        accessoryObject34, accessoryObject35, accessoryObject36, accessoryObject37, accessoryObject38,
        accessoryObject39, accessoryObject40, accessoryObject41, accessoryObject42, accessoryObject43,
        accessoryObject44, accessoryObject45, accessoryObject46, accessoryObject47, accessoryObject48,
        accessoryObject49, accessoryObject50, accessoryObject51, accessoryObject52, accessoryObject53,
        accessoryObject54, accessoryObject55, accessoryObject56, accessoryObject57, accessoryObject58,
        accessoryObject59, accessoryObject60, accessoryObject61, accessoryObject62, accessoryObject63,
        accessoryObject64, accessoryObject65, accessoryObject66, accessoryObject67, accessoryObject68,
        accessoryObject69, accessoryObject70, accessoryObject71, accessoryObject72, accessoryObject73,
        accessoryObject74, accessoryObject75, accessoryObject76,
        emptyAccessoryObject];
    let flags = [accessoryObject63, accessoryObject64, accessoryObject65, accessoryObject66, accessoryObject67,
        accessoryObject68, accessoryObject69];
    let facepaints = [
        facepaintObject1, facepaintObject2, facepaintObject3, facepaintObject4, facepaintObject5, facepaintObject6,
        facepaintObject7, facepaintObject8, facepaintObject9, facepaintObject10, facepaintObject11, facepaintObject12,
        emptyFacepaintObject
    ];
    let allFacepaints = [
        facepaintObject2Female, facepaintObject3Female, facepaintObject4Female, facepaintObject5Female,
        facepaintObject6Female, facepaintObject7Female,
        facepaintObject8Female, facepaintObject9Female, facepaintObject10Female, facepaintObject11Female, facepaintObject12Female,
        facepaintObject1, facepaintObject2, facepaintObject3, facepaintObject4, facepaintObject5, facepaintObject6,
        facepaintObject7, facepaintObject8, facepaintObject9, facepaintObject10, facepaintObject11, facepaintObject12
    ];
    let masculineFacepaints = [
        facepaintObject1, facepaintObject2, facepaintObject3, facepaintObject4, facepaintObject5, facepaintObject6,
        facepaintObject7, facepaintObject8, facepaintObject9, facepaintObject10, facepaintObject11, facepaintObject12,
        emptyFacepaintObject
    ];
    let feminineFacepaints = [
        facepaintObject1, facepaintObject2Female, facepaintObject3Female, facepaintObject4Female, facepaintObject5Female,
        facepaintObject6Female, facepaintObject7Female, facepaintObject8Female, facepaintObject9Female, facepaintObject10Female,
        facepaintObject11Female, facepaintObject12Female,
        emptyFacepaintObject
    ];
    let tattoos = [
        tattooObject1, tattooObject2, tattooObject3, tattooObject4, tattooObject5, tattooObject6, tattooObject7, tattooObject8,
        tattooObject9, tattooObject10, tattooObject11, tattooObject12, tattooObject13, tattooObject14, tattooObject15,
        tattooObject16, tattooObject17, tattooObject18, tattooObject19, tattooObject20, tattooObject21, tattooObject22,
        tattooObject23, emptyTattooObject
    ];
    let masculineTattoos = [
        tattooObject1, tattooObject2, tattooObject3, tattooObject4, tattooObject5, tattooObject6, tattooObject7,
        tattooObject8, tattooObject9, tattooObject10, tattooObject11, tattooObject12, tattooObject13, tattooObject14,
        tattooObject15, tattooObject16, tattooObject17, tattooObject18, tattooObject19, tattooObject20, tattooObject21,
        tattooObject22, tattooObject23, emptyTattooObject
    ];
    let feminineTattoos = [
        tattooObject1Female, tattooObject2Female, tattooObject3Female, tattooObject4Female, tattooObject5Female,
        tattooObject6, tattooObject7, tattooObject8, tattooObject9, tattooObject10Female, tattooObject11Female,
        tattooObject12, tattooObject13, tattooObject14, tattooObject15, tattooObject16Female, tattooObject17Female,
        tattooObject18, tattooObject19Female, tattooObject20Female, tattooObject21Female, tattooObject22Female,
        tattooObject23Female, emptyTattooObject
    ];
    let allTattoos = [
        tattooObject1Female, tattooObject2Female, tattooObject3Female, tattooObject4Female, tattooObject5Female,
        tattooObject10Female, tattooObject11Female, tattooObject16Female, tattooObject17Female, tattooObject19Female,
        tattooObject20Female, tattooObject21Female, tattooObject22Female, tattooObject23Female,
        tattooObject1, tattooObject2, tattooObject3, tattooObject4, tattooObject5, tattooObject6, tattooObject7, tattooObject8,
        tattooObject9, tattooObject10, tattooObject11, tattooObject12, tattooObject13, tattooObject14, tattooObject15,
        tattooObject16, tattooObject17, tattooObject18, tattooObject19, tattooObject20, tattooObject21,
        tattooObject22, tattooObject23
    ];
    let kneepads = [kneepadObject1, kneepadObject2, kneepadObject3, kneepadObject4, kneepadObject5, kneepadObject6,
        kneepadObject7, kneepadObject8, kneepadObject9, kneepadObject10,
        emptyKneepadObject];

    // Sub categories
    let shortHair = [emptyHairObject, hairObject1, hairObject2, hairObject3, hairObject5, hairObject6, hairObject7, hairObject9,
        hairObject11, hairObject13, hairObject14, hairObject15, hairObject16, hairObject17, hairObject18, hairObject21, hairObject22,
        hairObject23, hairObject24, hairObject25, hairObject26, hairObject28, hairObject33, hairObject34];
    let longHair = [hairObject4, hairObject8, hairObject10, hairObject12,
        hairObject19, hairObject20, hairObject27, hairObject29, hairObject30, hairObject31, hairObject32,
        hairObject35, hairObject36];
    let feminineHair = [femaleHairObject1, femaleHairObject2, femaleHairObject3, femaleHairObject4, femaleHairObject5, femaleHairObject6,
        femaleHairObject7, femaleHairObject8, femaleHairObject9, femaleHairObject10, femaleHairObject11, femaleHairObject12,
        femaleHairObject13, femaleHairObject14, femaleHairObject15, femaleHairObject16, femaleHairObject17, femaleHairObject18,
        femaleHairObject19, femaleHairObject20, femaleHairObject21, femaleHairObject22, femaleHairObject23, femaleHairObject24,
        femaleHairObject25, femaleHairObject26, femaleHairObject27, femaleHairObject28, femaleHairObject30, femaleHairObject29];

    let shirtTops = [topObject44, topObject1, topObject3, topObject46, topObject4, topObject7, topObject15, topObject20,
        topObject23, topObject25, topObject28, topObject29, topObject30, topObject31, topObject37, topObject41, topObject42,
        topObject43, topObject47, topObject48, topObject49, topObject50, topObject51, topObject52, topObject53, topObject54,
        emptyTopObject];
    let vestTops = [topObject45, topObject2, topObject9, topObject10, topObject11, topObject13, topObject14,
        topObject18, topObject19, topObject22, topObject24, topObject26, topObject27, topObject32, topObject36,
        topObject38, topObject40, emptyTopObject];
    let sportsBraTops = [sportsBraObjectBasic, sportsBraObjectLow, sportsBraObjectShort, sportsBraObjectThin,
        sportsBraObject1, sportsBraObject2, sportsBraObject3, sportsBraObject4, sportsBraObject5, sportsBraObject6, sportsBraObject7,
        sportsBraObject8, sportsBraObject9, sportsBraObject10, sportsBraObject11, sportsBraObject12, sportsBraObject13, sportsBraObject14,
        sportsBraObject15, sportsBraObject16, emptyTopObject];
    let feminineTops = [femaleTopObject1, femaleTopObject2, femaleTopObject3, femaleTopObject4, femaleTopObject5,
        femaleTopObject6, femaleTopObject7, femaleTopObject8, femaleTopObject9, femaleTopObject10, femaleTopObject11,
        emptyTopObject];
    let otherTops = [topObject5, topObject6, topObject8, topObject12, topObject16, topObject17, topObject21,
        topObject33, topObject34, topObject35, topObject39, emptyTopObject];

    let feminineBottoms = [femaleBottomObject1, femaleBottomObject18, femaleBottomObject2, femaleBottomObject3, femaleBottomObject4, femaleBottomObject5, femaleBottomObject6,
        femaleBottomObject7, femaleBottomObject8, femaleBottomObject9, femaleBottomObject19, femaleBottomObject10, femaleBottomObject11, femaleBottomObject12,
        femaleBottomObject13, femaleBottomObject14, femaleBottomObject15, femaleBottomObject16, femaleBottomObject17, femaleBottomObject20, femaleBottomObject21];

    let shortShoes = [shoesObject1, shoesObject3, shoesObject4, shoesObject5, shoesObject6, shoesObject8,
        shoesObject11, shoesObject16, shoesObject17, shoesObject18, emptyShoesObject];
    let longShoes = [shoesObject0, shoesObject2, shoesObject7, shoesObject9, shoesObject10, shoesObject12,
        shoesObject13, shoesObject14, shoesObject15, shoesObject19, shoesObject20, emptyShoesObject];

    let glovesAccessories = [glovesObject1, glovesObject2, glovesObject3, glovesObject4, glovesObject5, glovesObject6, emptyAccessoryObject];
    let wristTapeAccessories = [wristTapeObject1, wristTapeObject2, wristTapeObject3, accessoryObject11, accessoryObject12,
        accessoryObject13, emptyAccessoryObject];
    let suitAndTieAccessories = [suitsObject1, suitsObject2, suitsObject3,
        tiesObject1, tiesObject2, tiesObject3, tiesObject4, accessoryObject51, emptyAccessoryObject];
    let feminineAccessories = [femaleAccessoryObject1, femaleAccessoryObject2, femaleAccessoryObject3, femaleAccessoryObject4,
        femaleAccessoryObject5, femaleAccessoryObject6, femaleAccessoryObject7, femaleAccessoryObject8, femaleAccessoryObject9,
        femaleAccessoryObject10, femaleAccessoryObject11, femaleAccessoryObject12, emptyAccessoryObject];
    let neckAccessories = [accessoryObject4, accessoryObject5, accessoryObject15, accessoryObject16, emptyAccessoryObject];
    let otherAccessories = [accessoryObject1, accessoryObject2, accessoryObject3, accessoryObject6,
        accessoryObject9, accessoryObject14, accessoryObject17, accessoryObject18, accessoryObject19,
        accessoryObject20, accessoryObject21, accessoryObject22, accessoryObject23, accessoryObject24,
        accessoryObject26, accessoryObject27, accessoryObject28, accessoryObject32, accessoryObject33,
        accessoryObject34, accessoryObject35, accessoryObject36, accessoryObject37, accessoryObject38,
        accessoryObject39, accessoryObject40, accessoryObject42, accessoryObject46, accessoryObject48,
        accessoryObject50, accessoryObject61, accessoryObject62, accessoryObject70, accessoryObject71,
        accessoryObject73,
        emptyAccessoryObject];
    let glassesAccessories = [
        accessoryObject10, glassesObject2, glassesObject3, glassesObject4, glassesObject5,
        glassesObject6, glassesObject7, glassesObject8,
        emptyAccessoryObject
    ];
    let masksAccessories = [
        accessoryObject7, accessoryObject8, accessoryObject43, accessoryObject44, accessoryObject54,
        accessoryObject74, accessoryObject75, accessoryObject76, emptyAccessoryObject
    ];
    let flagsAccessories = [accessoryObject63, accessoryObject64, accessoryObject65, accessoryObject66,
        accessoryObject67, accessoryObject68, accessoryObject69, emptyAccessoryObject];

    // Title parts
    let centerPlates = [centerPlateObject10, centerPlateObject1, centerPlateObject2, centerPlateObject3, centerPlateObject4,
        centerPlateObject5, centerPlateObject6, centerPlateObject7, centerPlateObject8,
        centerPlateObject9];
    let smallCenterPlates = [smallPlateObject1, smallPlateObject2, smallPlateObject3, smallPlateObject4, smallPlateObject5,
        smallPlateObject6, smallPlateObject7, smallPlateObject8, smallPlateObject9, smallPlateObject10];
    let smallStraps = [smallStrapObject1, smallStrapObject2, smallStrapObject3, smallStrapObject4, smallStrapObject5,
        smallStrapObject6, smallStrapObject7, smallStrapObject8, smallStrapObject9, smallStrapObject10];
    let smallGems = [smallGemsObject1, smallGemsObject2, smallGemsObject3, smallGemsObject4, smallGemsObject5,
        smallGemsObject6, smallGemsObject7, smallGemsObject8, smallGemsObject9, smallGemsObject10];

    let bloodObjects = [bloodObject1, bloodObject2, bloodObject3, bloodObject4, bloodObject5, bloodObject6,
        bloodObject7, bloodObject8, bloodObject9, bloodObject10, bloodObject11, bloodObject12, bloodObject13];
    let backgroundObjects = [posterBackground1, posterBackground2, posterBackground3, posterBackground4,
        posterBackground5, posterBackground6, posterBackground7, posterBackground8, posterBackground9,
        posterBackground10];
    let weaponObjects = [accessoryObject25, accessoryObject29, accessoryObject30, accessoryObject31,
        accessoryObject41, accessoryObject45, accessoryObject47, accessoryObject49, accessoryObject52,
        accessoryObject53, accessoryObject55, accessoryObject56, accessoryObject57, accessoryObject58,
        accessoryObject59, accessoryObject60, accessoryObject72];
    let temporaryInjuryObjects = [bruiseEyeLeftObject, bruiseEyeRightObject, bandageArmLeftObject,
        bandageArmRightObject, bandageForeheadLeftObject, bandageForeheadRightObject, bandageForeheadFullObject];
    let temporaryTrophyObjects = [trophyObject1];

    return {
        accessories: accessories,
        bottoms: bottoms,
        torsos: torsos,
        hairs: hairs,
        shoes: shoes,
        elbows: elbows,
        facialHairs: facialHairs,
        bodies: bodies,
        kneepads: kneepads,
        facepaints: facepaints,
        tattoos: tattoos,
        eyes: eyes,
        bloodObjects: bloodObjects,
        weaponObjects: weaponObjects,
        temporaryInjuryObjects: temporaryInjuryObjects,
        temporaryTrophyObjects: temporaryTrophyObjects,
        shorts: shorts,
        trunks: trunks,
        tights: tights,
        flags: flags,
        allTattoos: allTattoos,
        masculineTattoos: masculineTattoos,
        feminineTattoos: feminineTattoos,
        allFacepaints: allFacepaints,
        masculineFacepaints: masculineFacepaints,
        feminineFacepaints: feminineFacepaints,
        shortHair: shortHair,
        longHair: longHair,
        feminineHair: feminineHair,
        shirtTops: shirtTops,
        vestTops: vestTops,
        sportsBraTops: sportsBraTops,
        feminineTops: feminineTops,
        otherTops: otherTops,
        feminineBottoms: feminineBottoms,
        shortShoes: shortShoes,
        longShoes: longShoes,
        glovesAccessories: glovesAccessories,
        wristTapeAccessories: wristTapeAccessories,
        suitAndTieAccessories: suitAndTieAccessories,
        feminineAccessories: feminineAccessories,
        neckAccessories: neckAccessories,
        otherAccessories: otherAccessories,
        glassesAccessories: glassesAccessories,
        masksAccessories: masksAccessories,
        flagsAccessories: flagsAccessories,
        centerPlates: centerPlates,
        smallCenterPlates: smallCenterPlates,
        smallStraps: smallStraps,
        smallGems: smallGems,
        backgroundObjects: backgroundObjects,
        gimmickMatchLadderBlack: gimmickMatchLadderBlack,
        gimmickMatchLadderGrey: gimmickMatchLadderGrey,
        gimmickMatchLadderOrange: gimmickMatchLadderOrange,
        gimmickMatchCageGrey: gimmickMatchCageGrey,
        gimmickMatchCageRed: gimmickMatchCageRed,
        gimmickMatchCageRetroBlue: gimmickMatchCageRetroBlue,
        gimmickMatchCageRetroBlack: gimmickMatchCageRetroBlack,
        gimmickMatchTableBrown: gimmickMatchTableBrown,
        gimmickMatchTableBrownStanding: gimmickMatchTableBrownStanding,
        gimmickMatchTableDarkBrown: gimmickMatchTableDarkBrown,
        gimmickMatchTableDarkBrownStanding: gimmickMatchTableDarkBrownStanding,
        gimmickMatchTableLightBrown: gimmickMatchTableLightBrown,
        gimmickMatchTableLightBrownStanding: gimmickMatchTableLightBrownStanding,
        gimmickMatchChairBiege: gimmickMatchChairBiege,
        gimmickMatchChairBlack: gimmickMatchChairBlack,
        gimmickMatchChairBlue: gimmickMatchChairBlue,
        gimmickMatchAmbulance: gimmickMatchAmbulance,
        gimmickMatchBarbedWireRopes: gimmickMatchBarbedWireRopes,
        gimmickMatchBarbedWireBoard: gimmickMatchBarbedWireBoard,
        gimmickMatchBuriedAlive: gimmickMatchBuriedAlive,
        gimmickMatchCasketBrown: gimmickMatchCasketBrown,
        gimmickMatchCasketPurple: gimmickMatchCasketPurple,
        gimmickMatchCasketLightBrown: gimmickMatchCasketLightBrown,
        gimmickMatchParkingLotA: gimmickMatchParkingLotA,
        gimmickMatchParkingLotB: gimmickMatchParkingLotB,
        specialSegmentsCar: specialSegmentsCar,
        specialSegmentsCarFire: specialSegmentsCarFire,
        specialSegmentsHelicopter: specialSegmentsHelicopter,
        specialSegmentsHelicopterBuilding: specialSegmentsHelicopterBuilding,
        specialSegmentsHelicopterBuildingLights: specialSegmentsHelicopterBuildingLights,
        specialSegmentsLemonadeTruck: specialSegmentsLemonadeTruck,
        specialSegmentsLemonadeTruckSpray: specialSegmentsLemonadeTruckSpray,
        specialSegmentsStage: specialSegmentsStage,
        specialSegmentsStageRailing: specialSegmentsStageRailing,
        specialSegmentsDummy: specialSegmentsDummy,
        specialSegmentsAmbulance: specialSegmentsAmbulance,
        specialSegmentsCelebrityAmericanQueen: specialSegmentsCelebrityAmericanQueen,
        specialSegmentsCelebrityPrezz: specialSegmentsCelebrityPrezz,
        specialSegmentsCelebrityBigT: specialSegmentsCelebrityBigT,
        specialSegmentsRantMic: specialSegmentsRantMic,
        specialSegmentsRantSpeech: specialSegmentsRantSpeech,
        specialSegmentsLoveMakingManClothed: specialSegmentsLoveMakingManClothed,
        specialSegmentsLoveMakingManNude: specialSegmentsLoveMakingManNude,
        specialSegmentsLoveMakingWomanClothed: specialSegmentsLoveMakingWomanClothed,
        specialSegmentsLoveMakingWomanNude: specialSegmentsLoveMakingWomanNude,
        specialSegmentsLoveMakingBottomCensor: specialSegmentsLoveMakingBottomCensor,
        specialSegmentsLoveMakingTopCensor: specialSegmentsLoveMakingTopCensor,
        specialSegmentsLoveMakingBed: specialSegmentsLoveMakingBed,
        specialSegmentsLoveMakingHeart: specialSegmentsLoveMakingHeart,
        specialSegmentsRing: specialSegmentsRing,
        specialSegmentsRingRopes: specialSegmentsRingRopes,
        specialSegmentsRingPeopleTop: specialSegmentsRingPeopleTop,
        specialSegmentsRingPeopleBottom: specialSegmentsRingPeopleBottom,
        accessoryObject23: accessoryObject23,
        accessoryObject24: accessoryObject24,
        accessoryObject50: accessoryObject50,
        accessoryObject25: accessoryObject25,
        accessoryObject29: accessoryObject29,
        accessoryObject30: accessoryObject30,
        accessoryObject31: accessoryObject31,
        accessoryObject41: accessoryObject41,
        accessoryObject45: accessoryObject45,
        accessoryObject47: accessoryObject47,
        accessoryObject49: accessoryObject49,
        accessoryObject52: accessoryObject52,
        accessoryObject53: accessoryObject53,
        accessoryObject55: accessoryObject55,
        accessoryObject56: accessoryObject56,
        accessoryObject57: accessoryObject57,
        accessoryObject58: accessoryObject58,
        accessoryObject59: accessoryObject59,
        accessoryObject72: accessoryObject72,
        TGIFireworks: TGIFireworks,
        TGITrophy: TGITrophy,
        emptySprite: emptySprite,
        topObject41: topObject41,
        emptyTopObject: emptyTopObject,
        tightsObject0: tightsObject0,
        shoesObject0: shoesObject0,
        hairObject1: hairObject1,
        femaleBottomObject7: femaleBottomObject7,
        sportsBraObjectBasic: sportsBraObjectBasic,
        posterBackground3: posterBackground3,
        bodyObjectShe: bodyObjectShe,
        bodyObjectSheAbs: bodyObjectSheAbs,
        bodyObjectHe: bodyObjectHe,
    }
}


export function loadTitleSprites() {

    // Get sprites
    let textures = PIXI.loader.resources["static/www/static/images/sprites/sprites.json"].textures;

    let centerPlate1 = new PIXI.Sprite(textures["title_center_1.png"]);
    let centerPlate2 = new PIXI.Sprite(textures["title_center_2.png"]);
    let centerPlate3 = new PIXI.Sprite(textures["title_center_3.png"]);
    let centerPlate4 = new PIXI.Sprite(textures["title_center_4.png"]);
    let centerPlate5 = new PIXI.Sprite(textures["title_center_5.png"]);
    let centerPlate6 = new PIXI.Sprite(textures["title_center_6.png"]);
    let centerPlate7 = new PIXI.Sprite(textures["title_center_7.png"]);
    let centerPlate8 = new PIXI.Sprite(textures["title_center_8.png"]);
    let centerPlate9 = new PIXI.Sprite(textures["title_center_9.png"]);
    let centerPlate10 = new PIXI.Sprite(textures["title_center_10.png"]);

    let centerGems1 = new PIXI.Sprite(textures["title_gems_1.png"]);
    let centerGems2 = new PIXI.Sprite(textures["title_gems_2.png"]);
    let centerGems3 = new PIXI.Sprite(textures["title_gems_3.png"]);
    let centerGems4 = new PIXI.Sprite(textures["title_gems_4.png"]);
    let centerGems5 = new PIXI.Sprite(textures["title_gems_5.png"]);
    let centerGems6 = new PIXI.Sprite(textures["title_gems_6.png"]);
    let centerGems7 = new PIXI.Sprite(textures["title_gems_7.png"]);
    let centerGems8 = new PIXI.Sprite(textures["title_gems_8.png"]);
    let centerGems9 = new PIXI.Sprite(textures["title_gems_9.png"]);
    let centerGems10 = new PIXI.Sprite(textures["title_gems_10.png"]);

    let sideGems1 = new PIXI.Sprite(textures["title_side_gems_1.png"]);
    let sideGems2 = new PIXI.Sprite(textures["title_side_gems_2.png"]);
    let sideGems3 = new PIXI.Sprite(textures["title_side_gems_3.png"]);
    let sideGems4 = new PIXI.Sprite(textures["title_side_gems_4.png"]);
    let sideGems5 = new PIXI.Sprite(textures["title_side_gems_5.png"]);
    let sideGems6 = new PIXI.Sprite(textures["title_side_gems_6.png"]);
    let sideGems7 = new PIXI.Sprite(textures["title_side_gems_7.png"]);
    let sideGems8 = new PIXI.Sprite(textures["title_side_gems_8.png"]);
    let sideGems9 = new PIXI.Sprite(textures["title_side_gems_9.png"]);
    let sideGems10 = new PIXI.Sprite(textures["title_side_gems_10.png"]);

    let strap1 = new PIXI.Sprite(textures["title_strap_1.png"]);
    let strap2 = new PIXI.Sprite(textures["title_strap_2.png"]);
    let strap3 = new PIXI.Sprite(textures["title_strap_3.png"]);
    let strap4 = new PIXI.Sprite(textures["title_strap_4.png"]);
    let strap5 = new PIXI.Sprite(textures["title_strap_5.png"]);
    let strap6 = new PIXI.Sprite(textures["title_strap_6.png"]);
    let strap7 = new PIXI.Sprite(textures["title_strap_7.png"]);
    let strap8 = new PIXI.Sprite(textures["title_strap_8.png"]);
    let strap9 = new PIXI.Sprite(textures["title_strap_9.png"]);
    let strap10 = new PIXI.Sprite(textures["title_strap_10.png"]);

    let sidePlates1 = new PIXI.Sprite(textures["title_side_plates_1.png"]);
    let sidePlates2 = new PIXI.Sprite(textures["title_side_plates_2.png"]);
    let sidePlates3 = new PIXI.Sprite(textures["title_side_plates_3.png"]);
    let sidePlates4 = new PIXI.Sprite(textures["title_side_plates_4.png"]);
    let sidePlates5 = new PIXI.Sprite(textures["title_side_plates_5.png"]);
    let sidePlates6 = new PIXI.Sprite(textures["title_side_plates_6.png"]);
    let sidePlates7 = new PIXI.Sprite(textures["title_side_plates_7.png"]);
    let sidePlates8 = new PIXI.Sprite(textures["title_side_plates_8.png"]);
    let sidePlates9 = new PIXI.Sprite(textures["title_side_plates_9.png"]);
    let sidePlates10 = new PIXI.Sprite(textures["title_side_plates_10.png"]);

    let sidePlatesGeneral1 = new PIXI.Sprite(textures["side_plates_1.png"]);
    let sidePlatesGeneral2 = new PIXI.Sprite(textures["side_plates_2.png"]);
    let sidePlatesGeneral3 = new PIXI.Sprite(textures["side_plates_3.png"]);
    let sidePlatesGeneral4 = new PIXI.Sprite(textures["side_plates_4.png"]);
    let sidePlatesGeneral5 = new PIXI.Sprite(textures["side_plates_5.png"]);
    let sidePlatesGeneral6 = new PIXI.Sprite(textures["side_plates_6.png"]);
    let sidePlatesGeneral7 = new PIXI.Sprite(textures["side_plates_7.png"]);
    let sidePlatesGeneral8 = new PIXI.Sprite(textures["side_plates_8.png"]);
    let sidePlatesGeneral9 = new PIXI.Sprite(textures["side_plates_9.png"]);
    let sidePlatesGeneral10 = new PIXI.Sprite(textures["side_plates_10.png"]);
    let sidePlatesGeneral11 = new PIXI.Sprite(textures["side_plates_11.png"]);

    let sideGemsGeneral1 = new PIXI.Sprite(textures["side_plate_gems_1.png"]);
    let sideGemsGeneral2 = new PIXI.Sprite(textures["side_plate_gems_2.png"]);
    let sideGemsGeneral3 = new PIXI.Sprite(textures["side_plate_gems_3.png"]);
    let sideGemsGeneral4 = new PIXI.Sprite(textures["side_plate_gems_4.png"]);
    let sideGemsGeneral5 = new PIXI.Sprite(textures["side_plate_gems_5.png"]);
    let sideGemsGeneral6 = new PIXI.Sprite(textures["side_plate_gems_6.png"]);
    let sideGemsGeneral7 = new PIXI.Sprite(textures["side_plate_gems_7.png"]);
    let sideGemsGeneral8 = new PIXI.Sprite(textures["side_plate_gems_8.png"]);
    let sideGemsGeneral9 = new PIXI.Sprite(textures["side_plate_gems_9.png"]);
    let sideGemsGeneral10 = new PIXI.Sprite(textures["side_plate_gems_10.png"]);
    let sideGemsGeneral11 = new PIXI.Sprite(textures["side_plate_gems_11.png"]);

    let emptySprite = new PIXI.Sprite(textures["empty_sprite.png"]);

    let centerGemsObject1 = {
        designs: [
            {sprite: centerGems1, zIndex: 2, defaultColor: '0xC51616'}
        ]
    };
    let centerGemsObject2 = {
        designs: [
            {sprite: centerGems2, zIndex: 2, defaultColor: '0xC51616'}
        ]
    };
    let centerGemsObject3 = {
        designs: [
            {sprite: centerGems3, zIndex: 2, defaultColor: '0xC51616'}
        ]
    };
    let centerGemsObject4 = {
        designs: [
            {sprite: centerGems4, zIndex: 2, defaultColor: '0xC51616'}
        ]
    };
    let centerGemsObject5 = {
        designs: [
            {sprite: centerGems5, zIndex: 2, defaultColor: '0xC51616'}
        ]
    };
    let centerGemsObject6 = {
        designs: [
            {sprite: centerGems6, zIndex: 2, defaultColor: '0xC51616'}
        ]
    };
    let centerGemsObject7 = {
        designs: [
            {sprite: centerGems7, zIndex: 2, defaultColor: '0xC51616'}
        ]
    };
    let centerGemsObject8 = {
        designs: [
            {sprite: centerGems8, zIndex: 2, defaultColor: '0xC51616'}
        ]
    };
    let centerGemsObject9 = {
        designs: [
            {sprite: centerGems9, zIndex: 2, defaultColor: '0xC51616'}
        ]
    };
    let centerGemsObject10 = {
        designs: [
            {sprite: centerGems10, zIndex: 2, defaultColor: '0xC51616'}
        ]
    };

    let sideGemsObject1 = {
        designs: [
            {sprite: sideGems1, zIndex: 4, defaultColor: '0xC51616'}
        ]
    };
    let sideGemsObject2 = {
        designs: [
            {sprite: sideGems2, zIndex: 4, defaultColor: '0xC51616'}
        ]
    };
    let sideGemsObject3 = {
        designs: [
            {sprite: sideGems3, zIndex: 4, defaultColor: '0xC51616'}
        ]
    };
    let sideGemsObject4 = {
        designs: [
            {sprite: sideGems4, zIndex: 4, defaultColor: '0xC51616'}
        ]
    };
    let sideGemsObject5 = {
        designs: [
            {sprite: sideGems5, zIndex: 4, defaultColor: '0xC51616'}
        ]
    };
    let sideGemsObject6 = {
        designs: [
            {sprite: sideGems6, zIndex: 4, defaultColor: '0xC51616'}
        ]
    };
    let sideGemsObject7 = {
        designs: [
            {sprite: sideGems7, zIndex: 4, defaultColor: '0xC51616'}
        ]
    };
    let sideGemsObject8 = {
        designs: [
            {sprite: sideGems8, zIndex: 4, defaultColor: '0xC51616'}
        ]
    };
    let sideGemsObject9 = {
        designs: [
            {sprite: sideGems9, zIndex: 4, defaultColor: '0xC51616'}
        ]
    };
    let sideGemsObject10 = {
        designs: [
            {sprite: sideGems10, zIndex: 4, defaultColor: '0xC51616'}
        ]
    };

    let sideGemsGeneralObject1 = {
        designs: [
            {sprite: sideGemsGeneral1, zIndex: 4, defaultColor: '0xC51616'}
        ]
    };
    let sideGemsGeneralObject2 = {
        designs: [
            {sprite: sideGemsGeneral2, zIndex: 4, defaultColor: '0xC51616'}
        ]
    };
    let sideGemsGeneralObject3 = {
        designs: [
            {sprite: sideGemsGeneral3, zIndex: 4, defaultColor: '0xC51616'}
        ]
    };
    let sideGemsGeneralObject4 = {
        designs: [
            {sprite: sideGemsGeneral4, zIndex: 4, defaultColor: '0xC51616'}
        ]
    };
    let sideGemsGeneralObject5 = {
        designs: [
            {sprite: sideGemsGeneral5, zIndex: 4, defaultColor: '0xC51616'}
        ]
    };
    let sideGemsGeneralObject6 = {
        designs: [
            {sprite: sideGemsGeneral6, zIndex: 4, defaultColor: '0xC51616'}
        ]
    };
    let sideGemsGeneralObject7 = {
        designs: [
            {sprite: sideGemsGeneral7, zIndex: 4, defaultColor: '0xC51616'}
        ]
    };
    let sideGemsGeneralObject8 = {
        designs: [
            {sprite: sideGemsGeneral8, zIndex: 4, defaultColor: '0xC51616'}
        ]
    };
    let sideGemsGeneralObject9 = {
        designs: [
            {sprite: sideGemsGeneral9, zIndex: 4, defaultColor: '0xC51616'}
        ]
    };
    let sideGemsGeneralObject10 = {
        designs: [
            {sprite: sideGemsGeneral10, zIndex: 4, defaultColor: '0xC51616'}
        ]
    };
    let sideGemsGeneralObject11 = {
        designs: [
            {sprite: sideGemsGeneral11, zIndex: 4, defaultColor: '0xC51616'}
        ]
    };

    let strapObject1 = {
        designs: [
            {sprite: strap1, zIndex: 0, defaultColor: '0x1D1D1D'}
        ]
    };
    let strapObject2 = {
        designs: [
            {sprite: strap2, zIndex: 0, defaultColor: '0x1D1D1D'}
        ]
    };
    let strapObject3 = {
        designs: [
            {sprite: strap3, zIndex: 0, defaultColor: '0x1D1D1D'}
        ]
    };
    let strapObject4 = {
        designs: [
            {sprite: strap4, zIndex: 0, defaultColor: '0x1D1D1D'}
        ]
    };
    let strapObject5 = {
        designs: [
            {sprite: strap5, zIndex: 0, defaultColor: '0x1D1D1D'}
        ]
    };
    let strapObject6 = {
        designs: [
            {sprite: strap6, zIndex: 0, defaultColor: '0x1D1D1D'}
        ]
    };
    let strapObject7 = {
        designs: [
            {sprite: strap7, zIndex: 0, defaultColor: '0x1D1D1D'}
        ]
    };
    let strapObject8 = {
        designs: [
            {sprite: strap8, zIndex: 0, defaultColor: '0x1D1D1D'}
        ]
    };
    let strapObject9 = {
        designs: [
            {sprite: strap9, zIndex: 0, defaultColor: '0x1D1D1D'}
        ]
    };
    let strapObject10 = {
        designs: [
            {sprite: strap10, zIndex: 0, defaultColor: '0x1D1D1D'}
        ]
    };

    let sidePlateObject1 = {
        designs: [
            {sprite: sidePlates1, zIndex: 3, defaultColor: '0xC59548'}
        ],
        sideGemsPart: sideGemsObject1
    };
    let sidePlateObject2 = {
        designs: [
            {sprite: sidePlates2, zIndex: 3, defaultColor: '0xC59548'}
        ],
        sideGemsPart: sideGemsObject2
    };
    let sidePlateObject3 = {
        designs: [
            {sprite: sidePlates3, zIndex: 3, defaultColor: '0xC59548'}
        ],
        sideGemsPart: sideGemsObject3
    };
    let sidePlateObject4 = {
        designs: [
            {sprite: sidePlates4, zIndex: 3, defaultColor: '0xC59548'}
        ],
        sideGemsPart: sideGemsObject4
    };
    let sidePlateObject5 = {
        designs: [
            {sprite: sidePlates5, zIndex: 3, defaultColor: '0xC59548'}
        ],
        sideGemsPart: sideGemsObject5
    };
    let sidePlateObject6 = {
        designs: [
            {sprite: sidePlates6, zIndex: 3, defaultColor: '0xC59548'}
        ],
        sideGemsPart: sideGemsObject6
    };
    let sidePlateObject7 = {
        designs: [
            {sprite: sidePlates7, zIndex: 3, defaultColor: '0xC59548'}
        ],
        sideGemsPart: sideGemsObject7
    };
    let sidePlateObject8 = {
        designs: [
            {sprite: sidePlates8, zIndex: 3, defaultColor: '0xC59548'}
        ],
        sideGemsPart: sideGemsObject8
    };
    let sidePlateObject9 = {
        designs: [
            {sprite: sidePlates9, zIndex: 3, defaultColor: '0xC59548'}
        ],
        sideGemsPart: sideGemsObject9
    };
    let sidePlateObject10 = {
        designs: [
            {sprite: sidePlates10, zIndex: 3, defaultColor: '0xC59548'}
        ],
        sideGemsPart: sideGemsObject10
    };

    let sidePlatesGeneralObject1 = {
        designs: [
            {sprite: sidePlatesGeneral1, zIndex: 3, defaultColor: '0xC59548'}
        ],
        sideGemsPart: sideGemsGeneralObject1
    };
    let sidePlatesGeneralObject2 = {
        designs: [
            {sprite: sidePlatesGeneral2, zIndex: 3, defaultColor: '0xC59548'}
        ],
        sideGemsPart: sideGemsGeneralObject2
    };
    let sidePlatesGeneralObject3 = {
        designs: [
            {sprite: sidePlatesGeneral3, zIndex: 3, defaultColor: '0xC59548'}
        ],
        sideGemsPart: sideGemsGeneralObject3
    };
    let sidePlatesGeneralObject4 = {
        designs: [
            {sprite: sidePlatesGeneral4, zIndex: 3, defaultColor: '0xC59548'}
        ],
        sideGemsPart: sideGemsGeneralObject4
    };
    let sidePlatesGeneralObject5 = {
        designs: [
            {sprite: sidePlatesGeneral5, zIndex: 3, defaultColor: '0xC59548'}
        ],
        sideGemsPart: sideGemsGeneralObject6
    };
    let sidePlatesGeneralObject6 = {
        designs: [
            {sprite: sidePlatesGeneral6, zIndex: 3, defaultColor: '0xC59548'}
        ],
        sideGemsPart: sideGemsGeneralObject5
    };
    let sidePlatesGeneralObject7 = {
        designs: [
            {sprite: sidePlatesGeneral7, zIndex: 3, defaultColor: '0xC59548'}
        ],
        sideGemsPart: sideGemsGeneralObject7
    };
    let sidePlatesGeneralObject8 = {
        designs: [
            {sprite: sidePlatesGeneral8, zIndex: 3, defaultColor: '0xC59548'}
        ],
        sideGemsPart: sideGemsGeneralObject8
    };
    let sidePlatesGeneralObject9 = {
        designs: [
            {sprite: sidePlatesGeneral9, zIndex: 3, defaultColor: '0xC59548'}
        ],
        sideGemsPart: sideGemsGeneralObject9
    };
    let sidePlatesGeneralObject10 = {
        designs: [
            {sprite: sidePlatesGeneral10, zIndex: 3, defaultColor: '0xC59548'}
        ],
        sideGemsPart: sideGemsGeneralObject10
    };
    let sidePlatesGeneralObject11 = {
        designs: [
            {sprite: sidePlatesGeneral11, zIndex: 3, defaultColor: '0xC59548'}
        ],
        sideGemsPart: sideGemsGeneralObject11
    };

    let centerPlateObject1 = {
        designs: [
            {sprite: centerPlate1, zIndex: 1, defaultColor: '0xC59548'}
        ],
        gemPart: centerGemsObject1,
        strapPart: strapObject1,
        sidePlatesPart: sidePlateObject1
    };
    let centerPlateObject2 = {
        designs: [
            {sprite: centerPlate2, zIndex: 1, defaultColor: '0xC59548'}
        ],
        gemPart: centerGemsObject2,
        strapPart: strapObject2,
        sidePlatesPart: sidePlateObject2
    };
    let centerPlateObject3 = {
        designs: [
            {sprite: centerPlate3, zIndex: 1, defaultColor: '0xC59548'}
        ],
        gemPart: centerGemsObject3,
        strapPart: strapObject3,
        sidePlatesPart: sidePlateObject3
    };
    let centerPlateObject4 = {
        designs: [
            {sprite: centerPlate4, zIndex: 1, defaultColor: '0xC59548'}
        ],
        gemPart: centerGemsObject4,
        strapPart: strapObject4,
        sidePlatesPart: sidePlateObject4
    };
    let centerPlateObject5 = {
        designs: [
            {sprite: centerPlate5, zIndex: 1, defaultColor: '0xC59548'}
        ],
        gemPart: centerGemsObject5,
        strapPart: strapObject5,
        sidePlatesPart: sidePlateObject5
    };
    let centerPlateObject6 = {
        designs: [
            {sprite: centerPlate6, zIndex: 1, defaultColor: '0xC59548'}
        ],
        gemPart: centerGemsObject6,
        strapPart: strapObject6,
        sidePlatesPart: sidePlateObject6
    };
    let centerPlateObject7 = {
        designs: [
            {sprite: centerPlate7, zIndex: 1, defaultColor: '0xC59548'}
        ],
        gemPart: centerGemsObject7,
        strapPart: strapObject7,
        sidePlatesPart: sidePlateObject7
    };
    let centerPlateObject8 = {
        designs: [
            {sprite: centerPlate8, zIndex: 1, defaultColor: '0xC59548'}
        ],
        gemPart: centerGemsObject8,
        strapPart: strapObject8,
        sidePlatesPart: sidePlateObject8
    };
    let centerPlateObject9 = {
        designs: [
            {sprite: centerPlate9, zIndex: 1, defaultColor: '0xC59548'}
        ],
        gemPart: centerGemsObject9,
        strapPart: strapObject9,
        sidePlatesPart: sidePlateObject9
    };
    let centerPlateObject10 = {
        designs: [
            {sprite: centerPlate10, zIndex: 1, defaultColor: '0xC59548'}
        ],
        gemPart: centerGemsObject10,
        strapPart: strapObject10,
        sidePlatesPart: sidePlateObject10
    };

    // Empty objects
    let emptyCenterGemsObject = {
        designs: [
            {sprite: emptySprite, zIndex: 0, defaultColor: '0xFFFFFF'}
        ]
    };
    let emptySideGemsObject = {
        designs: [
            {sprite: emptySprite, zIndex: 0, defaultColor: '0xFFFFFF'}
        ]
    };
    let emptySidePlatesObject = {
        designs: [
            {sprite: emptySprite, zIndex: 0, defaultColor: '0xFFFFFF'}
        ],
        sideGemsPart: emptySideGemsObject
    };

    // Initialize variables and arrays
    let allCenterPlates = [centerPlateObject10, centerPlateObject1, centerPlateObject2, centerPlateObject3, centerPlateObject4,
        centerPlateObject5, centerPlateObject6, centerPlateObject7, centerPlateObject8,
        centerPlateObject9];
    let allStraps = [strapObject1, strapObject2, strapObject3, strapObject4, strapObject5, strapObject6,
        strapObject7, strapObject8, strapObject9, strapObject10];
    let allCenterGems = [centerGemsObject1, centerGemsObject2, centerGemsObject3, centerGemsObject4,
        centerGemsObject5, centerGemsObject6, centerGemsObject7, centerGemsObject8, centerGemsObject9,
        centerGemsObject10, emptyCenterGemsObject];
    let allSidePlates = [sidePlateObject1, sidePlateObject2, sidePlateObject3, sidePlateObject4, sidePlateObject5,
        sidePlateObject6, sidePlateObject7, sidePlateObject8, sidePlateObject9, sidePlateObject10,
        sidePlatesGeneralObject1, sidePlatesGeneralObject2, sidePlatesGeneralObject3, sidePlatesGeneralObject4,
        sidePlatesGeneralObject5, sidePlatesGeneralObject6, sidePlatesGeneralObject7,
        sidePlatesGeneralObject8, sidePlatesGeneralObject9, sidePlatesGeneralObject10, sidePlatesGeneralObject11,
        emptySidePlatesObject];
    let allSideGems = [sideGemsObject1, sideGemsObject2, sideGemsObject3, sideGemsObject4, sideGemsObject5,
        sideGemsObject6, sideGemsObject7, sideGemsObject8, sideGemsObject9, sideGemsObject10,
        sideGemsGeneralObject1, sideGemsGeneralObject2, sideGemsGeneralObject3, sideGemsGeneralObject4,
        sideGemsGeneralObject5, sideGemsGeneralObject6, sideGemsGeneralObject7, sideGemsGeneralObject8,
        sideGemsGeneralObject9, sideGemsGeneralObject10, sideGemsGeneralObject11,
        emptySideGemsObject];

    let centerPlates = [centerPlateObject10, centerPlateObject1, centerPlateObject2, centerPlateObject3, centerPlateObject4,
        centerPlateObject5, centerPlateObject6, centerPlateObject7, centerPlateObject8,
        centerPlateObject9];
    let straps = [strapObject1];
    let centerGems = [centerGemsObject1];
    let sidePlates = [sidePlateObject1, sidePlateObject2, sidePlateObject3, sidePlateObject4, sidePlateObject5,
        sidePlateObject6, sidePlateObject7, sidePlateObject8, sidePlateObject9, sidePlateObject10,
        sidePlatesGeneralObject1, sidePlatesGeneralObject2, sidePlatesGeneralObject3, sidePlatesGeneralObject4,
        sidePlatesGeneralObject5, sidePlatesGeneralObject6, sidePlatesGeneralObject7,
        sidePlatesGeneralObject8, sidePlatesGeneralObject9, sidePlatesGeneralObject10, sidePlatesGeneralObject11,
        emptySidePlatesObject];
    let sideGems = [sideGemsObject1];

    return {
        allCenterPlates: allCenterPlates,
        allStraps: allStraps,
        allCenterGems: allCenterGems,
        allSidePlates: allSidePlates,
        allSideGems: allSideGems,
        centerPlates: centerPlates,
        straps: straps,
        centerGems: centerGems,
        sidePlates: sidePlates,
        sideGems: sideGems,
        emptySprite: emptySprite,
        emptyCenterGemsObject: emptyCenterGemsObject,
        emptySideGemsObject: emptySideGemsObject,
        emptySidePlatesObject: emptySidePlatesObject
    }
}